var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
/*
Trix 2.1.15
Copyright © 2025 37signals, LLC
 */
!function (t, e) {
  exports = e();
}(exports, function () {
  "use strict";

  var t = "2.1.15";
  const e = "[data-trix-attachment]",
    i = {
      preview: {
        presentation: "gallery",
        caption: {
          name: !0,
          size: !0
        }
      },
      file: {
        caption: {
          size: !0
        }
      }
    },
    n = {
      default: {
        tagName: "div",
        parse: !1
      },
      quote: {
        tagName: "blockquote",
        nestable: !0
      },
      heading1: {
        tagName: "h1",
        terminal: !0,
        breakOnReturn: !0,
        group: !1
      },
      code: {
        tagName: "pre",
        terminal: !0,
        htmlAttributes: ["language"],
        text: {
          plaintext: !0
        }
      },
      bulletList: {
        tagName: "ul",
        parse: !1
      },
      bullet: {
        tagName: "li",
        listAttribute: "bulletList",
        group: !1,
        nestable: !0,
        test(t) {
          return r(t.parentNode) === n[(this || _global).listAttribute].tagName;
        }
      },
      numberList: {
        tagName: "ol",
        parse: !1
      },
      number: {
        tagName: "li",
        listAttribute: "numberList",
        group: !1,
        nestable: !0,
        test(t) {
          return r(t.parentNode) === n[(this || _global).listAttribute].tagName;
        }
      },
      attachmentGallery: {
        tagName: "div",
        exclusive: !0,
        terminal: !0,
        parse: !1,
        group: !1
      }
    },
    r = t => {
      var e;
      return null == t || null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase();
    },
    o = navigator.userAgent.match(/android\s([0-9]+.*Chrome)/i),
    s = o && parseInt(o[1]);
  var a = {
      composesExistingText: /Android.*Chrome/.test(navigator.userAgent),
      recentAndroid: s && s > 12,
      samsungAndroid: s && navigator.userAgent.match(/Android.*SM-/),
      forcesObjectResizing: /Trident.*rv:11/.test(navigator.userAgent),
      supportsInputEvents: "undefined" != typeof InputEvent && ["data", "getTargetRanges", "inputType"].every(t => t in InputEvent.prototype)
    },
    l = {
      ADD_ATTR: ["language"],
      SAFE_FOR_XML: !1,
      RETURN_DOM: !0
    },
    c = {
      attachFiles: "Attach Files",
      bold: "Bold",
      bullets: "Bullets",
      byte: "Byte",
      bytes: "Bytes",
      captionPlaceholder: "Add a caption\u2026",
      code: "Code",
      heading1: "Heading",
      indent: "Increase Level",
      italic: "Italic",
      link: "Link",
      numbers: "Numbers",
      outdent: "Decrease Level",
      quote: "Quote",
      redo: "Redo",
      remove: "Remove",
      strike: "Strikethrough",
      undo: "Undo",
      unlink: "Unlink",
      url: "URL",
      urlPlaceholder: "Enter a URL\u2026",
      GB: "GB",
      KB: "KB",
      MB: "MB",
      PB: "PB",
      TB: "TB"
    };
  const u = [c.bytes, c.KB, c.MB, c.GB, c.TB, c.PB];
  var h = {
    prefix: "IEC",
    precision: 2,
    formatter(t) {
      switch (t) {
        case 0:
          return "0 ".concat(c.bytes);
        case 1:
          return "1 ".concat(c.byte);
        default:
          let e;
          "SI" === (this || _global).prefix ? e = 1000 : "IEC" === (this || _global).prefix && (e = 1024);
          const i = Math.floor(Math.log(t) / Math.log(e)),
            n = (t / Math.pow(e, i)).toFixed((this || _global).precision).replace(/0*$/, "").replace(/\.$/, "");
          return "".concat(n, " ").concat(u[i]);
      }
    }
  };
  const d = "\uFEFF",
    g = "\xA0",
    m = function (t) {
      for (const e in t) {
        const i = t[e];
        (this || _global)[e] = i;
      }
      return this || _global;
    },
    p = document.documentElement,
    f = p.matches,
    b = function (t) {
      let {
        onElement: e,
        matchingSelector: i,
        withCallback: n,
        inPhase: r,
        preventDefault: o,
        times: s
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const a = e || p,
        l = i,
        c = "capturing" === r,
        u = function (t) {
          null != s && 0 == --s && u.destroy();
          const e = y(t.target, {
            matchingSelector: l
          });
          null != e && (null == n || n.call(e, t, e), o && t.preventDefault());
        };
      return u.destroy = () => a.removeEventListener(t, u, c), a.addEventListener(t, u, c), u;
    },
    v = function (t) {
      let {
        onElement: e,
        bubbles: i,
        cancelable: n,
        attributes: r
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const o = null != e ? e : p;
      i = !1 !== i, n = !1 !== n;
      const s = document.createEvent("Events");
      return s.initEvent(t, i, n), null != r && m.call(s, r), o.dispatchEvent(s);
    },
    A = function (t, e) {
      if (1 === (null == t ? void 0 : t.nodeType)) return f.call(t, e);
    },
    y = function (t) {
      let {
        matchingSelector: e,
        untilNode: i
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      for (; t && t.nodeType !== Node.ELEMENT_NODE;) t = t.parentNode;
      if (null != t) {
        if (null == e) return t;
        if (t.closest && null == i) return t.closest(e);
        for (; t && t !== i;) {
          if (A(t, e)) return t;
          t = t.parentNode;
        }
      }
    },
    x = t => document.activeElement !== t && C(t, document.activeElement),
    C = function (t, e) {
      if (t && e) for (; e;) {
        if (e === t) return !0;
        e = e.parentNode;
      }
    },
    E = function (t) {
      var e;
      if (null === (e = t) || void 0 === e || !e.parentNode) return;
      let i = 0;
      for (t = t.previousSibling; t;) i++, t = t.previousSibling;
      return i;
    },
    S = t => {
      var e;
      return null == t || null === (e = t.parentNode) || void 0 === e ? void 0 : e.removeChild(t);
    },
    R = function (t) {
      let {
        onlyNodesOfType: e,
        usingFilter: i,
        expandEntityReferences: n
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const r = (() => {
        switch (e) {
          case "element":
            return NodeFilter.SHOW_ELEMENT;
          case "text":
            return NodeFilter.SHOW_TEXT;
          case "comment":
            return NodeFilter.SHOW_COMMENT;
          default:
            return NodeFilter.SHOW_ALL;
        }
      })();
      return document.createTreeWalker(t, r, null != i ? i : null, !0 === n);
    },
    k = t => {
      var e;
      return null == t || null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase();
    },
    T = function (t) {
      let e,
        i,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      "object" == typeof t ? (n = t, t = n.tagName) : n = {
        attributes: n
      };
      const r = document.createElement(t);
      if (null != n.editable && (null == n.attributes && (n.attributes = {}), n.attributes.contenteditable = n.editable), n.attributes) for (e in n.attributes) i = n.attributes[e], r.setAttribute(e, i);
      if (n.style) for (e in n.style) i = n.style[e], r.style[e] = i;
      if (n.data) for (e in n.data) i = n.data[e], r.dataset[e] = i;
      return n.className && n.className.split(" ").forEach(t => {
        r.classList.add(t);
      }), n.textContent && (r.textContent = n.textContent), n.childNodes && [].concat(n.childNodes).forEach(t => {
        r.appendChild(t);
      }), r;
    };
  let w;
  const L = function () {
      if (null != w) return w;
      w = [];
      for (const t in n) {
        const e = n[t];
        e.tagName && w.push(e.tagName);
      }
      return w;
    },
    D = t => I(null == t ? void 0 : t.firstChild),
    N = function (t) {
      let {
        strict: e
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        strict: !0
      };
      return e ? I(t) : I(t) || !I(t.firstChild) && function (t) {
        return L().includes(k(t)) && !L().includes(k(t.firstChild));
      }(t);
    },
    I = t => O(t) && "block" === (null == t ? void 0 : t.data),
    O = t => (null == t ? void 0 : t.nodeType) === Node.COMMENT_NODE,
    F = function (t) {
      let {
        name: e
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (t) return B(t) ? t.data === d ? !e || t.parentNode.dataset.trixCursorTarget === e : void 0 : F(t.firstChild);
    },
    P = t => A(t, e),
    M = t => B(t) && "" === (null == t ? void 0 : t.data),
    B = t => (null == t ? void 0 : t.nodeType) === Node.TEXT_NODE,
    _ = {
      level2Enabled: !0,
      getLevel() {
        return (this || _global).level2Enabled && a.supportsInputEvents ? 2 : 0;
      },
      pickFiles(t) {
        const e = T("input", {
          type: "file",
          multiple: !0,
          hidden: !0,
          id: (this || _global).fileInputId
        });
        e.addEventListener("change", () => {
          t(e.files), S(e);
        }), S(document.getElementById((this || _global).fileInputId)), document.body.appendChild(e), e.click();
      }
    };
  var j = {
      removeBlankTableCells: !1,
      tableCellSeparator: " | ",
      tableRowSeparator: "\n"
    },
    W = {
      bold: {
        tagName: "strong",
        inheritable: !0,
        parser(t) {
          const e = window.getComputedStyle(t);
          return "bold" === e.fontWeight || e.fontWeight >= 600;
        }
      },
      italic: {
        tagName: "em",
        inheritable: !0,
        parser: t => "italic" === window.getComputedStyle(t).fontStyle
      },
      href: {
        groupTagName: "a",
        parser(t) {
          const i = "a:not(".concat(e, ")"),
            n = t.closest(i);
          if (n) return n.getAttribute("href");
        }
      },
      strike: {
        tagName: "del",
        inheritable: !0
      },
      frozen: {
        style: {
          backgroundColor: "highlight"
        }
      }
    },
    U = {
      getDefaultHTML: () => "<div class=\"trix-button-row\">\n      <span class=\"trix-button-group trix-button-group--text-tools\" data-trix-button-group=\"text-tools\">\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-bold\" data-trix-attribute=\"bold\" data-trix-key=\"b\" title=\"".concat(c.bold, "\" tabindex=\"-1\">").concat(c.bold, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-italic\" data-trix-attribute=\"italic\" data-trix-key=\"i\" title=\"").concat(c.italic, "\" tabindex=\"-1\">").concat(c.italic, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-strike\" data-trix-attribute=\"strike\" title=\"").concat(c.strike, "\" tabindex=\"-1\">").concat(c.strike, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-link\" data-trix-attribute=\"href\" data-trix-action=\"link\" data-trix-key=\"k\" title=\"").concat(c.link, "\" tabindex=\"-1\">").concat(c.link, "</button>\n      </span>\n\n      <span class=\"trix-button-group trix-button-group--block-tools\" data-trix-button-group=\"block-tools\">\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-heading-1\" data-trix-attribute=\"heading1\" title=\"").concat(c.heading1, "\" tabindex=\"-1\">").concat(c.heading1, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-quote\" data-trix-attribute=\"quote\" title=\"").concat(c.quote, "\" tabindex=\"-1\">").concat(c.quote, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-code\" data-trix-attribute=\"code\" title=\"").concat(c.code, "\" tabindex=\"-1\">").concat(c.code, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-bullet-list\" data-trix-attribute=\"bullet\" title=\"").concat(c.bullets, "\" tabindex=\"-1\">").concat(c.bullets, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-number-list\" data-trix-attribute=\"number\" title=\"").concat(c.numbers, "\" tabindex=\"-1\">").concat(c.numbers, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-decrease-nesting-level\" data-trix-action=\"decreaseNestingLevel\" title=\"").concat(c.outdent, "\" tabindex=\"-1\">").concat(c.outdent, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-increase-nesting-level\" data-trix-action=\"increaseNestingLevel\" title=\"").concat(c.indent, "\" tabindex=\"-1\">").concat(c.indent, "</button>\n      </span>\n\n      <span class=\"trix-button-group trix-button-group--file-tools\" data-trix-button-group=\"file-tools\">\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-attach\" data-trix-action=\"attachFiles\" title=\"").concat(c.attachFiles, "\" tabindex=\"-1\">").concat(c.attachFiles, "</button>\n      </span>\n\n      <span class=\"trix-button-group-spacer\"></span>\n\n      <span class=\"trix-button-group trix-button-group--history-tools\" data-trix-button-group=\"history-tools\">\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-undo\" data-trix-action=\"undo\" data-trix-key=\"z\" title=\"").concat(c.undo, "\" tabindex=\"-1\">").concat(c.undo, "</button>\n        <button type=\"button\" class=\"trix-button trix-button--icon trix-button--icon-redo\" data-trix-action=\"redo\" data-trix-key=\"shift+z\" title=\"").concat(c.redo, "\" tabindex=\"-1\">").concat(c.redo, "</button>\n      </span>\n    </div>\n\n    <div class=\"trix-dialogs\" data-trix-dialogs>\n      <div class=\"trix-dialog trix-dialog--link\" data-trix-dialog=\"href\" data-trix-dialog-attribute=\"href\">\n        <div class=\"trix-dialog__link-fields\">\n          <input type=\"url\" name=\"href\" class=\"trix-input trix-input--dialog\" placeholder=\"").concat(c.urlPlaceholder, "\" aria-label=\"").concat(c.url, "\" data-trix-validate-href required data-trix-input>\n          <div class=\"trix-button-group\">\n            <input type=\"button\" class=\"trix-button trix-button--dialog\" value=\"").concat(c.link, "\" data-trix-method=\"setAttribute\">\n            <input type=\"button\" class=\"trix-button trix-button--dialog\" value=\"").concat(c.unlink, "\" data-trix-method=\"removeAttribute\">\n          </div>\n        </div>\n      </div>\n    </div>")
    };
  const V = {
    interval: 5000
  };
  var z = Object.freeze({
    __proto__: null,
    attachments: i,
    blockAttributes: n,
    browser: a,
    css: {
      attachment: "attachment",
      attachmentCaption: "attachment__caption",
      attachmentCaptionEditor: "attachment__caption-editor",
      attachmentMetadata: "attachment__metadata",
      attachmentMetadataContainer: "attachment__metadata-container",
      attachmentName: "attachment__name",
      attachmentProgress: "attachment__progress",
      attachmentSize: "attachment__size",
      attachmentToolbar: "attachment__toolbar",
      attachmentGallery: "attachment-gallery"
    },
    dompurify: l,
    fileSize: h,
    input: _,
    keyNames: {
      8: "backspace",
      9: "tab",
      13: "return",
      27: "escape",
      37: "left",
      39: "right",
      46: "delete",
      68: "d",
      72: "h",
      79: "o"
    },
    lang: c,
    parser: j,
    textAttributes: W,
    toolbar: U,
    undo: V
  });
  class q {
    static proxyMethod(t) {
      const {
        name: e,
        toMethod: i,
        toProperty: n,
        optional: r
      } = H(t);
      this.prototype[e] = function () {
        let t, o;
        var s, a;
        i ? o = r ? null === (s = this[i]) || void 0 === s ? void 0 : s.call(this) : this[i]() : n && (o = this[n]);
        return r ? (t = null === (a = o) || void 0 === a ? void 0 : a[e], t ? J.call(t, o, arguments) : void 0) : (t = o[e], J.call(t, o, arguments));
      };
    }
  }
  const H = function (t) {
      const e = t.match(K);
      if (!e) throw new Error("can't parse @proxyMethod expression: ".concat(t));
      const i = {
        name: e[4]
      };
      return null != e[2] ? i.toMethod = e[1] : i.toProperty = e[1], null != e[3] && (i.optional = !0), i;
    },
    {
      apply: J
    } = Function.prototype,
    K = new RegExp("^(.+?)(\\(\\))?(\\?)?\\.(.+?)$");
  var G, Y, X;
  class $ extends q {
    static box() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
      return t instanceof this ? t : this.fromUCS2String(null == t ? void 0 : t.toString());
    }
    static fromUCS2String(t) {
      return new this(t, et(t));
    }
    static fromCodepoints(t) {
      return new this(it(t), t);
    }
    constructor(t, e) {
      super(...arguments), this.ucs2String = t, this.codepoints = e, this.length = this.codepoints.length, this.ucs2Length = this.ucs2String.length;
    }
    offsetToUCS2Offset(t) {
      return it(this.codepoints.slice(0, Math.max(0, t))).length;
    }
    offsetFromUCS2Offset(t) {
      return et(this.ucs2String.slice(0, Math.max(0, t))).length;
    }
    slice() {
      return this.constructor.fromCodepoints(this.codepoints.slice(...arguments));
    }
    charAt(t) {
      return this.slice(t, t + 1);
    }
    isEqualTo(t) {
      return this.constructor.box(t).ucs2String === this.ucs2String;
    }
    toJSON() {
      return this.ucs2String;
    }
    getCacheKey() {
      return this.ucs2String;
    }
    toString() {
      return this.ucs2String;
    }
  }
  const Z = 1 === (null === (G = Array.from) || void 0 === G ? void 0 : G.call(Array, "\uD83D\uDC7C").length),
    Q = null != (null === (Y = " ".codePointAt) || void 0 === Y ? void 0 : Y.call(" ", 0)),
    tt = " \uD83D\uDC7C" === (null === (X = String.fromCodePoint) || void 0 === X ? void 0 : X.call(String, 32, 128124));
  let et, it;
  et = Z && Q ? t => Array.from(t).map(t => t.codePointAt(0)) : function (t) {
    const e = [];
    let i = 0;
    const {
      length: n
    } = t;
    for (; i < n;) {
      let r = t.charCodeAt(i++);
      if (55296 <= r && r <= 56319 && i < n) {
        const e = t.charCodeAt(i++);
        56320 == (64512 & e) ? r = ((1023 & r) << 10) + (1023 & e) + 65536 : i--;
      }
      e.push(r);
    }
    return e;
  }, it = tt ? t => String.fromCodePoint(...Array.from(t || [])) : function (t) {
    return (() => {
      const e = [];
      return Array.from(t).forEach(t => {
        let i = "";
        t > 65535 && (t -= 65536, i += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e.push(i + String.fromCharCode(t));
      }), e;
    })().join("");
  };
  let nt = 0;
  class rt extends q {
    static fromJSONString(t) {
      return this.fromJSON(JSON.parse(t));
    }
    constructor() {
      super(...arguments), this.id = ++nt;
    }
    hasSameConstructorAs(t) {
      return this.constructor === (null == t ? void 0 : t.constructor);
    }
    isEqualTo(t) {
      return this === t;
    }
    inspect() {
      const t = [],
        e = this.contentsForInspection() || {};
      for (const i in e) {
        const n = e[i];
        t.push("".concat(i, "=").concat(n));
      }
      return "#<".concat(this.constructor.name, ":").concat(this.id).concat(t.length ? " ".concat(t.join(", ")) : "", ">");
    }
    contentsForInspection() {}
    toJSONString() {
      return JSON.stringify(this);
    }
    toUTF16String() {
      return $.box(this);
    }
    getCacheKey() {
      return this.id.toString();
    }
  }
  const ot = function () {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      if (t.length !== e.length) return !1;
      for (let i = 0; i < t.length; i++) {
        if (t[i] !== e[i]) return !1;
      }
      return !0;
    },
    st = function (t) {
      const e = t.slice(0);
      for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) n[r - 1] = arguments[r];
      return e.splice(...n), e;
    },
    at = /[\u05BE\u05C0\u05C3\u05D0-\u05EA\u05F0-\u05F4\u061B\u061F\u0621-\u063A\u0640-\u064A\u066D\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D5\u06E5\u06E6\u200F\u202B\u202E\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE72\uFE74\uFE76-\uFEFC]/,
    lt = function () {
      const t = T("input", {
          dir: "auto",
          name: "x",
          dirName: "x.dir"
        }),
        e = T("textarea", {
          dir: "auto",
          name: "y",
          dirName: "y.dir"
        }),
        i = T("form");
      i.appendChild(t), i.appendChild(e);
      const n = function () {
          try {
            return new FormData(i).has(e.dirName);
          } catch (t) {
            return !1;
          }
        }(),
        r = function () {
          try {
            return t.matches(":dir(ltr),:dir(rtl)");
          } catch (t) {
            return !1;
          }
        }();
      return n ? function (t) {
        return e.value = t, new FormData(i).get(e.dirName);
      } : r ? function (e) {
        return t.value = e, t.matches(":dir(rtl)") ? "rtl" : "ltr";
      } : function (t) {
        const e = t.trim().charAt(0);
        return at.test(e) ? "rtl" : "ltr";
      };
    }();
  let ct = null,
    ut = null,
    ht = null,
    dt = null;
  const gt = () => (ct || (ct = bt().concat(pt())), ct),
    mt = t => n[t],
    pt = () => (ut || (ut = Object.keys(n)), ut),
    ft = t => W[t],
    bt = () => (ht || (ht = Object.keys(W)), ht),
    vt = function (t, e) {
      At(t).textContent = e.replace(/%t/g, t);
    },
    At = function (t) {
      const e = document.createElement("style");
      e.setAttribute("type", "text/css"), e.setAttribute("data-tag-name", t.toLowerCase());
      const i = yt();
      return i && e.setAttribute("nonce", i), document.head.insertBefore(e, document.head.firstChild), e;
    },
    yt = function () {
      const t = xt("trix-csp-nonce") || xt("csp-nonce");
      if (t) {
        const {
          nonce: e,
          content: i
        } = t;
        return "" == e ? i : e;
      }
    },
    xt = t => document.head.querySelector("meta[name=".concat(t, "]")),
    Ct = {
      "application/x-trix-feature-detection": "test"
    },
    Et = function (t) {
      const e = t.getData("text/plain"),
        i = t.getData("text/html");
      if (!e || !i) return null == e ? void 0 : e.length;
      {
        const {
          body: t
        } = new DOMParser().parseFromString(i, "text/html");
        if (t.textContent === e) return !t.querySelector("*");
      }
    },
    St = /Mac|^iP/.test(navigator.platform) ? t => t.metaKey : t => t.ctrlKey;
  const Rt = t => setTimeout(t, 1),
    kt = function () {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      const e = {};
      for (const i in t) {
        const n = t[i];
        e[i] = n;
      }
      return e;
    },
    Tt = function () {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (Object.keys(t).length !== Object.keys(e).length) return !1;
      for (const i in t) {
        if (t[i] !== e[i]) return !1;
      }
      return !0;
    },
    wt = function (t) {
      if (null != t) return Array.isArray(t) || (t = [t, t]), [Nt(t[0]), Nt(null != t[1] ? t[1] : t[0])];
    },
    Lt = function (t) {
      if (null == t) return;
      const [e, i] = wt(t);
      return It(e, i);
    },
    Dt = function (t, e) {
      if (null == t || null == e) return;
      const [i, n] = wt(t),
        [r, o] = wt(e);
      return It(i, r) && It(n, o);
    },
    Nt = function (t) {
      return "number" == typeof t ? t : kt(t);
    },
    It = function (t, e) {
      return "number" == typeof t ? t === e : Tt(t, e);
    };
  class Ot extends q {
    constructor() {
      super(...arguments), this.update = this.update.bind(this), this.selectionManagers = [];
    }
    start() {
      this.started || (this.started = !0, document.addEventListener("selectionchange", this.update, !0));
    }
    stop() {
      if (this.started) return this.started = !1, document.removeEventListener("selectionchange", this.update, !0);
    }
    registerSelectionManager(t) {
      if (!this.selectionManagers.includes(t)) return this.selectionManagers.push(t), this.start();
    }
    unregisterSelectionManager(t) {
      if (this.selectionManagers = this.selectionManagers.filter(e => e !== t), 0 === this.selectionManagers.length) return this.stop();
    }
    notifySelectionManagersOfSelectionChange() {
      return this.selectionManagers.map(t => t.selectionDidChange());
    }
    update() {
      this.notifySelectionManagersOfSelectionChange();
    }
    reset() {
      this.update();
    }
  }
  const Ft = new Ot(),
    Pt = function () {
      const t = window.getSelection();
      if (t.rangeCount > 0) return t;
    },
    Mt = function () {
      var t;
      const e = null === (t = Pt()) || void 0 === t ? void 0 : t.getRangeAt(0);
      if (e && !_t(e)) return e;
    },
    Bt = function (t) {
      const e = window.getSelection();
      return e.removeAllRanges(), e.addRange(t), Ft.update();
    },
    _t = t => jt(t.startContainer) || jt(t.endContainer),
    jt = t => !Object.getPrototypeOf(t),
    Wt = t => t.replace(new RegExp("".concat(d), "g"), "").replace(new RegExp("".concat(g), "g"), " "),
    Ut = new RegExp("[^\\S".concat(g, "]")),
    Vt = t => t.replace(new RegExp("".concat(Ut.source), "g"), " ").replace(/\ {2,}/g, " "),
    zt = function (t, e) {
      if (t.isEqualTo(e)) return ["", ""];
      const i = qt(t, e),
        {
          length: n
        } = i.utf16String;
      let r;
      if (n) {
        const {
            offset: o
          } = i,
          s = t.codepoints.slice(0, o).concat(t.codepoints.slice(o + n));
        r = qt(e, $.fromCodepoints(s));
      } else r = qt(e, t);
      return [i.utf16String.toString(), r.utf16String.toString()];
    },
    qt = function (t, e) {
      let i = 0,
        n = t.length,
        r = e.length;
      for (; i < n && t.charAt(i).isEqualTo(e.charAt(i));) i++;
      for (; n > i + 1 && t.charAt(n - 1).isEqualTo(e.charAt(r - 1));) n--, r--;
      return {
        utf16String: t.slice(i, n),
        offset: i
      };
    };
  class Ht extends rt {
    static fromCommonAttributesOfObjects() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      if (!t.length) return new this();
      let e = Yt(t[0]),
        i = e.getKeys();
      return t.slice(1).forEach(t => {
        i = e.getKeysCommonToHash(Yt(t)), e = e.slice(i);
      }), e;
    }
    static box(t) {
      return Yt(t);
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      super(...arguments), this.values = Gt(t);
    }
    add(t, e) {
      return this.merge(Jt(t, e));
    }
    remove(t) {
      return new Ht(Gt(this.values, t));
    }
    get(t) {
      return this.values[t];
    }
    has(t) {
      return t in this.values;
    }
    merge(t) {
      return new Ht(Kt(this.values, Xt(t)));
    }
    slice(t) {
      const e = {};
      return Array.from(t).forEach(t => {
        this.has(t) && (e[t] = this.values[t]);
      }), new Ht(e);
    }
    getKeys() {
      return Object.keys(this.values);
    }
    getKeysCommonToHash(t) {
      return t = Yt(t), this.getKeys().filter(e => this.values[e] === t.values[e]);
    }
    isEqualTo(t) {
      return ot(this.toArray(), Yt(t).toArray());
    }
    isEmpty() {
      return 0 === this.getKeys().length;
    }
    toArray() {
      if (!this.array) {
        const t = [];
        for (const e in this.values) {
          const i = this.values[e];
          t.push(t.push(e, i));
        }
        this.array = t.slice(0);
      }
      return this.array;
    }
    toObject() {
      return Gt(this.values);
    }
    toJSON() {
      return this.toObject();
    }
    contentsForInspection() {
      return {
        values: JSON.stringify(this.values)
      };
    }
  }
  const Jt = function (t, e) {
      const i = {};
      return i[t] = e, i;
    },
    Kt = function (t, e) {
      const i = Gt(t);
      for (const t in e) {
        const n = e[t];
        i[t] = n;
      }
      return i;
    },
    Gt = function (t, e) {
      const i = {};
      return Object.keys(t).sort().forEach(n => {
        n !== e && (i[n] = t[n]);
      }), i;
    },
    Yt = function (t) {
      return t instanceof Ht ? t : new Ht(t);
    },
    Xt = function (t) {
      return t instanceof Ht ? t.values : t;
    };
  class $t {
    static groupObjects() {
      let t,
        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        {
          depth: i,
          asTree: n
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      n && null == i && (i = 0);
      const r = [];
      return Array.from(e).forEach(e => {
        var o;
        if (t) {
          var s, a, l;
          if (null !== (s = e.canBeGrouped) && void 0 !== s && s.call(e, i) && null !== (a = (l = t[t.length - 1]).canBeGroupedWith) && void 0 !== a && a.call(l, e, i)) return void t.push(e);
          r.push(new this(t, {
            depth: i,
            asTree: n
          })), t = null;
        }
        null !== (o = e.canBeGrouped) && void 0 !== o && o.call(e, i) ? t = [e] : r.push(e);
      }), t && r.push(new this(t, {
        depth: i,
        asTree: n
      })), r;
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        {
          depth: e,
          asTree: i
        } = arguments.length > 1 ? arguments[1] : void 0;
      this.objects = t, i && (this.depth = e, this.objects = this.constructor.groupObjects(this.objects, {
        asTree: i,
        depth: this.depth + 1
      }));
    }
    getObjects() {
      return this.objects;
    }
    getDepth() {
      return this.depth;
    }
    getCacheKey() {
      const t = ["objectGroup"];
      return Array.from(this.getObjects()).forEach(e => {
        t.push(e.getCacheKey());
      }), t.join("/");
    }
  }
  class Zt extends q {
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      super(...arguments), this.objects = {}, Array.from(t).forEach(t => {
        const e = JSON.stringify(t);
        null == this.objects[e] && (this.objects[e] = t);
      });
    }
    find(t) {
      const e = JSON.stringify(t);
      return this.objects[e];
    }
  }
  class Qt {
    constructor(t) {
      this.reset(t);
    }
    add(t) {
      const e = te(t);
      this.elements[e] = t;
    }
    remove(t) {
      const e = te(t),
        i = this.elements[e];
      if (i) return delete this.elements[e], i;
    }
    reset() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      return this.elements = {}, Array.from(t).forEach(t => {
        this.add(t);
      }), t;
    }
  }
  const te = t => t.dataset.trixStoreKey;
  class ee extends q {
    isPerforming() {
      return !0 === this.performing;
    }
    hasPerformed() {
      return !0 === this.performed;
    }
    hasSucceeded() {
      return this.performed && this.succeeded;
    }
    hasFailed() {
      return this.performed && !this.succeeded;
    }
    getPromise() {
      return this.promise || (this.promise = new Promise((t, e) => (this.performing = !0, this.perform((i, n) => {
        this.succeeded = i, this.performing = !1, this.performed = !0, this.succeeded ? t(n) : e(n);
      })))), this.promise;
    }
    perform(t) {
      return t(!1);
    }
    release() {
      var t, e;
      null === (t = this.promise) || void 0 === t || null === (e = t.cancel) || void 0 === e || e.call(t), this.promise = null, this.performing = null, this.performed = null, this.succeeded = null;
    }
  }
  ee.proxyMethod("getPromise().then"), ee.proxyMethod("getPromise().catch");
  class ie extends q {
    constructor(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      super(...arguments), this.object = t, this.options = e, this.childViews = [], this.rootView = this;
    }
    getNodes() {
      return this.nodes || (this.nodes = this.createNodes()), this.nodes.map(t => t.cloneNode(!0));
    }
    invalidate() {
      var t;
      return this.nodes = null, this.childViews = [], null === (t = this.parentView) || void 0 === t ? void 0 : t.invalidate();
    }
    invalidateViewForObject(t) {
      var e;
      return null === (e = this.findViewForObject(t)) || void 0 === e ? void 0 : e.invalidate();
    }
    findOrCreateCachedChildView(t, e, i) {
      let n = this.getCachedViewForObject(e);
      return n ? this.recordChildView(n) : (n = this.createChildView(...arguments), this.cacheViewForObject(n, e)), n;
    }
    createChildView(t, e) {
      let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      e instanceof $t && (i.viewClass = t, t = ne);
      const n = new t(e, i);
      return this.recordChildView(n);
    }
    recordChildView(t) {
      return t.parentView = this, t.rootView = this.rootView, this.childViews.push(t), t;
    }
    getAllChildViews() {
      let t = [];
      return this.childViews.forEach(e => {
        t.push(e), t = t.concat(e.getAllChildViews());
      }), t;
    }
    findElement() {
      return this.findElementForObject(this.object);
    }
    findElementForObject(t) {
      const e = null == t ? void 0 : t.id;
      if (e) return this.rootView.element.querySelector("[data-trix-id='".concat(e, "']"));
    }
    findViewForObject(t) {
      for (const e of this.getAllChildViews()) if (e.object === t) return e;
    }
    getViewCache() {
      return this.rootView !== this ? this.rootView.getViewCache() : this.isViewCachingEnabled() ? (this.viewCache || (this.viewCache = {}), this.viewCache) : void 0;
    }
    isViewCachingEnabled() {
      return !1 !== this.shouldCacheViews;
    }
    enableViewCaching() {
      this.shouldCacheViews = !0;
    }
    disableViewCaching() {
      this.shouldCacheViews = !1;
    }
    getCachedViewForObject(t) {
      var e;
      return null === (e = this.getViewCache()) || void 0 === e ? void 0 : e[t.getCacheKey()];
    }
    cacheViewForObject(t, e) {
      const i = this.getViewCache();
      i && (i[e.getCacheKey()] = t);
    }
    garbageCollectCachedViews() {
      const t = this.getViewCache();
      if (t) {
        const e = this.getAllChildViews().concat(this).map(t => t.object.getCacheKey());
        for (const i in t) e.includes(i) || delete t[i];
      }
    }
  }
  class ne extends ie {
    constructor() {
      super(...arguments), this.objectGroup = this.object, this.viewClass = this.options.viewClass, delete this.options.viewClass;
    }
    getChildViews() {
      return this.childViews.length || Array.from(this.objectGroup.getObjects()).forEach(t => {
        this.findOrCreateCachedChildView(this.viewClass, t, this.options);
      }), this.childViews;
    }
    createNodes() {
      const t = this.createContainerElement();
      return this.getChildViews().forEach(e => {
        Array.from(e.getNodes()).forEach(e => {
          t.appendChild(e);
        });
      }), [t];
    }
    createContainerElement() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.objectGroup.getDepth();
      return this.getChildViews()[0].createContainerElement(t);
    }
  }
  /*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */
  const {
    entries: re,
    setPrototypeOf: oe,
    isFrozen: se,
    getPrototypeOf: ae,
    getOwnPropertyDescriptor: le
  } = Object;
  let {
      freeze: ce,
      seal: ue,
      create: he
    } = Object,
    {
      apply: de,
      construct: ge
    } = "undefined" != typeof Reflect && Reflect;
  ce || (ce = function (t) {
    return t;
  }), ue || (ue = function (t) {
    return t;
  }), de || (de = function (t, e, i) {
    return t.apply(e, i);
  }), ge || (ge = function (t, e) {
    return new t(...e);
  });
  const me = Le(Array.prototype.forEach),
    pe = Le(Array.prototype.lastIndexOf),
    fe = Le(Array.prototype.pop),
    be = Le(Array.prototype.push),
    ve = Le(Array.prototype.splice),
    Ae = Le(String.prototype.toLowerCase),
    ye = Le(String.prototype.toString),
    xe = Le(String.prototype.match),
    Ce = Le(String.prototype.replace),
    Ee = Le(String.prototype.indexOf),
    Se = Le(String.prototype.trim),
    Re = Le(Object.prototype.hasOwnProperty),
    ke = Le(RegExp.prototype.test),
    Te = (we = TypeError, function () {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
      return ge(we, e);
    });
  var we;
  function Le(t) {
    return function (e) {
      e instanceof RegExp && (e.lastIndex = 0);
      for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) n[r - 1] = arguments[r];
      return de(t, e, n);
    };
  }
  function De(t, e) {
    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Ae;
    oe && oe(t, null);
    let n = e.length;
    for (; n--;) {
      let r = e[n];
      if ("string" == typeof r) {
        const t = i(r);
        t !== r && (se(e) || (e[n] = t), r = t);
      }
      t[r] = !0;
    }
    return t;
  }
  function Ne(t) {
    for (let e = 0; e < t.length; e++) {
      Re(t, e) || (t[e] = null);
    }
    return t;
  }
  function Ie(t) {
    const e = he(null);
    for (const [i, n] of re(t)) {
      Re(t, i) && (Array.isArray(n) ? e[i] = Ne(n) : n && "object" == typeof n && n.constructor === Object ? e[i] = Ie(n) : e[i] = n);
    }
    return e;
  }
  function Oe(t, e) {
    for (; null !== t;) {
      const i = le(t, e);
      if (i) {
        if (i.get) return Le(i.get);
        if ("function" == typeof i.value) return Le(i.value);
      }
      t = ae(t);
    }
    return function () {
      return null;
    };
  }
  const Fe = ce(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
    Pe = ce(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
    Me = ce(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
    Be = ce(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
    _e = ce(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
    je = ce(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
    We = ce(["#text"]),
    Ue = ce(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
    Ve = ce(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
    ze = ce(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
    qe = ce(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
    He = ue(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
    Je = ue(/<%[\w\W]*|[\w\W]*%>/gm),
    Ke = ue(/\$\{[\w\W]*/gm),
    Ge = ue(/^data-[\-\w.\u00B7-\uFFFF]+$/),
    Ye = ue(/^aria-[\-\w]+$/),
    Xe = ue(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
    $e = ue(/^(?:\w+script|data):/i),
    Ze = ue(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
    Qe = ue(/^html$/i),
    ti = ue(/^[a-z][.\w]*(-[.\w]+)+$/i);
  var ei = Object.freeze({
    __proto__: null,
    ARIA_ATTR: Ye,
    ATTR_WHITESPACE: Ze,
    CUSTOM_ELEMENT: ti,
    DATA_ATTR: Ge,
    DOCTYPE_NAME: Qe,
    ERB_EXPR: Je,
    IS_ALLOWED_URI: Xe,
    IS_SCRIPT_OR_DATA: $e,
    MUSTACHE_EXPR: He,
    TMPLIT_EXPR: Ke
  });
  const ii = 1,
    ni = 3,
    ri = 7,
    oi = 8,
    si = 9,
    ai = function () {
      return "undefined" == typeof window ? null : window;
    };
  var li = function t() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ai();
    const i = e => t(e);
    if (i.version = "3.2.5", i.removed = [], !e || !e.document || e.document.nodeType !== si || !e.Element) return i.isSupported = !1, i;
    let {
      document: n
    } = e;
    const r = n,
      o = r.currentScript,
      {
        DocumentFragment: s,
        HTMLTemplateElement: a,
        Node: l,
        Element: c,
        NodeFilter: u,
        NamedNodeMap: h = e.NamedNodeMap || e.MozNamedAttrMap,
        HTMLFormElement: d,
        DOMParser: g,
        trustedTypes: m
      } = e,
      p = c.prototype,
      f = Oe(p, "cloneNode"),
      b = Oe(p, "remove"),
      v = Oe(p, "nextSibling"),
      A = Oe(p, "childNodes"),
      y = Oe(p, "parentNode");
    if ("function" == typeof a) {
      const t = n.createElement("template");
      t.content && t.content.ownerDocument && (n = t.content.ownerDocument);
    }
    let x,
      C = "";
    const {
        implementation: E,
        createNodeIterator: S,
        createDocumentFragment: R,
        getElementsByTagName: k
      } = n,
      {
        importNode: T
      } = r;
    let w = {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: []
    };
    i.isSupported = "function" == typeof re && "function" == typeof y && E && void 0 !== E.createHTMLDocument;
    const {
      MUSTACHE_EXPR: L,
      ERB_EXPR: D,
      TMPLIT_EXPR: N,
      DATA_ATTR: I,
      ARIA_ATTR: O,
      IS_SCRIPT_OR_DATA: F,
      ATTR_WHITESPACE: P,
      CUSTOM_ELEMENT: M
    } = ei;
    let {
        IS_ALLOWED_URI: B
      } = ei,
      _ = null;
    const j = De({}, [...Fe, ...Pe, ...Me, ..._e, ...We]);
    let W = null;
    const U = De({}, [...Ue, ...Ve, ...ze, ...qe]);
    let V = Object.seal(he(null, {
        tagNameCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null
        },
        attributeNameCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null
        },
        allowCustomizedBuiltInElements: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: !1
        }
      })),
      z = null,
      q = null,
      H = !0,
      J = !0,
      K = !1,
      G = !0,
      Y = !1,
      X = !0,
      $ = !1,
      Z = !1,
      Q = !1,
      tt = !1,
      et = !1,
      it = !1,
      nt = !0,
      rt = !1,
      ot = !0,
      st = !1,
      at = {},
      lt = null;
    const ct = De({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
    let ut = null;
    const ht = De({}, ["audio", "video", "img", "source", "image", "track"]);
    let dt = null;
    const gt = De({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
      mt = "http://www.w3.org/1998/Math/MathML",
      pt = "http://www.w3.org/2000/svg",
      ft = "http://www.w3.org/1999/xhtml";
    let bt = ft,
      vt = !1,
      At = null;
    const yt = De({}, [mt, pt, ft], ye);
    let xt = De({}, ["mi", "mo", "mn", "ms", "mtext"]),
      Ct = De({}, ["annotation-xml"]);
    const Et = De({}, ["title", "style", "font", "a", "script"]);
    let St = null;
    const Rt = ["application/xhtml+xml", "text/html"];
    let kt = null,
      Tt = null;
    const wt = n.createElement("form"),
      Lt = function (t) {
        return t instanceof RegExp || t instanceof Function;
      },
      Dt = function () {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if (!Tt || Tt !== t) {
          if (t && "object" == typeof t || (t = {}), t = Ie(t), St = -1 === Rt.indexOf(t.PARSER_MEDIA_TYPE) ? "text/html" : t.PARSER_MEDIA_TYPE, kt = "application/xhtml+xml" === St ? ye : Ae, _ = Re(t, "ALLOWED_TAGS") ? De({}, t.ALLOWED_TAGS, kt) : j, W = Re(t, "ALLOWED_ATTR") ? De({}, t.ALLOWED_ATTR, kt) : U, At = Re(t, "ALLOWED_NAMESPACES") ? De({}, t.ALLOWED_NAMESPACES, ye) : yt, dt = Re(t, "ADD_URI_SAFE_ATTR") ? De(Ie(gt), t.ADD_URI_SAFE_ATTR, kt) : gt, ut = Re(t, "ADD_DATA_URI_TAGS") ? De(Ie(ht), t.ADD_DATA_URI_TAGS, kt) : ht, lt = Re(t, "FORBID_CONTENTS") ? De({}, t.FORBID_CONTENTS, kt) : ct, z = Re(t, "FORBID_TAGS") ? De({}, t.FORBID_TAGS, kt) : {}, q = Re(t, "FORBID_ATTR") ? De({}, t.FORBID_ATTR, kt) : {}, at = !!Re(t, "USE_PROFILES") && t.USE_PROFILES, H = !1 !== t.ALLOW_ARIA_ATTR, J = !1 !== t.ALLOW_DATA_ATTR, K = t.ALLOW_UNKNOWN_PROTOCOLS || !1, G = !1 !== t.ALLOW_SELF_CLOSE_IN_ATTR, Y = t.SAFE_FOR_TEMPLATES || !1, X = !1 !== t.SAFE_FOR_XML, $ = t.WHOLE_DOCUMENT || !1, tt = t.RETURN_DOM || !1, et = t.RETURN_DOM_FRAGMENT || !1, it = t.RETURN_TRUSTED_TYPE || !1, Q = t.FORCE_BODY || !1, nt = !1 !== t.SANITIZE_DOM, rt = t.SANITIZE_NAMED_PROPS || !1, ot = !1 !== t.KEEP_CONTENT, st = t.IN_PLACE || !1, B = t.ALLOWED_URI_REGEXP || Xe, bt = t.NAMESPACE || ft, xt = t.MATHML_TEXT_INTEGRATION_POINTS || xt, Ct = t.HTML_INTEGRATION_POINTS || Ct, V = t.CUSTOM_ELEMENT_HANDLING || {}, t.CUSTOM_ELEMENT_HANDLING && Lt(t.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (V.tagNameCheck = t.CUSTOM_ELEMENT_HANDLING.tagNameCheck), t.CUSTOM_ELEMENT_HANDLING && Lt(t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (V.attributeNameCheck = t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), t.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (V.allowCustomizedBuiltInElements = t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Y && (J = !1), et && (tt = !0), at && (_ = De({}, We), W = [], !0 === at.html && (De(_, Fe), De(W, Ue)), !0 === at.svg && (De(_, Pe), De(W, Ve), De(W, qe)), !0 === at.svgFilters && (De(_, Me), De(W, Ve), De(W, qe)), !0 === at.mathMl && (De(_, _e), De(W, ze), De(W, qe))), t.ADD_TAGS && (_ === j && (_ = Ie(_)), De(_, t.ADD_TAGS, kt)), t.ADD_ATTR && (W === U && (W = Ie(W)), De(W, t.ADD_ATTR, kt)), t.ADD_URI_SAFE_ATTR && De(dt, t.ADD_URI_SAFE_ATTR, kt), t.FORBID_CONTENTS && (lt === ct && (lt = Ie(lt)), De(lt, t.FORBID_CONTENTS, kt)), ot && (_["#text"] = !0), $ && De(_, ["html", "head", "body"]), _.table && (De(_, ["tbody"]), delete z.tbody), t.TRUSTED_TYPES_POLICY) {
            if ("function" != typeof t.TRUSTED_TYPES_POLICY.createHTML) throw Te("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
            if ("function" != typeof t.TRUSTED_TYPES_POLICY.createScriptURL) throw Te("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
            x = t.TRUSTED_TYPES_POLICY, C = x.createHTML("");
          } else void 0 === x && (x = function (t, e) {
            if ("object" != typeof t || "function" != typeof t.createPolicy) return null;
            let i = null;
            const n = "data-tt-policy-suffix";
            e && e.hasAttribute(n) && (i = e.getAttribute(n));
            const r = "dompurify" + (i ? "#" + i : "");
            try {
              return t.createPolicy(r, {
                createHTML: t => t,
                createScriptURL: t => t
              });
            } catch (t) {
              return console.warn("TrustedTypes policy " + r + " could not be created."), null;
            }
          }(m, o)), null !== x && "string" == typeof C && (C = x.createHTML(""));
          ce && ce(t), Tt = t;
        }
      },
      Nt = De({}, [...Pe, ...Me, ...Be]),
      It = De({}, [..._e, ...je]),
      Ot = function (t) {
        be(i.removed, {
          element: t
        });
        try {
          y(t).removeChild(t);
        } catch (e) {
          b(t);
        }
      },
      Ft = function (t, e) {
        try {
          be(i.removed, {
            attribute: e.getAttributeNode(t),
            from: e
          });
        } catch (t) {
          be(i.removed, {
            attribute: null,
            from: e
          });
        }
        if (e.removeAttribute(t), "is" === t) if (tt || et) try {
          Ot(e);
        } catch (t) {} else try {
          e.setAttribute(t, "");
        } catch (t) {}
      },
      Pt = function (t) {
        let e = null,
          i = null;
        if (Q) t = "<remove></remove>" + t;else {
          const e = xe(t, /^[\r\n\t ]+/);
          i = e && e[0];
        }
        "application/xhtml+xml" === St && bt === ft && (t = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + t + "</body></html>");
        const r = x ? x.createHTML(t) : t;
        if (bt === ft) try {
          e = new g().parseFromString(r, St);
        } catch (t) {}
        if (!e || !e.documentElement) {
          e = E.createDocument(bt, "template", null);
          try {
            e.documentElement.innerHTML = vt ? C : r;
          } catch (t) {}
        }
        const o = e.body || e.documentElement;
        return t && i && o.insertBefore(n.createTextNode(i), o.childNodes[0] || null), bt === ft ? k.call(e, $ ? "html" : "body")[0] : $ ? e.documentElement : o;
      },
      Mt = function (t) {
        return S.call(t.ownerDocument || t, t, u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION, null);
      },
      Bt = function (t) {
        return t instanceof d && ("string" != typeof t.nodeName || "string" != typeof t.textContent || "function" != typeof t.removeChild || !(t.attributes instanceof h) || "function" != typeof t.removeAttribute || "function" != typeof t.setAttribute || "string" != typeof t.namespaceURI || "function" != typeof t.insertBefore || "function" != typeof t.hasChildNodes);
      },
      _t = function (t) {
        return "function" == typeof l && t instanceof l;
      };
    function jt(t, e, n) {
      me(t, t => {
        t.call(i, e, n, Tt);
      });
    }
    const Wt = function (t) {
        let e = null;
        if (jt(w.beforeSanitizeElements, t, null), Bt(t)) return Ot(t), !0;
        const n = kt(t.nodeName);
        if (jt(w.uponSanitizeElement, t, {
          tagName: n,
          allowedTags: _
        }), t.hasChildNodes() && !_t(t.firstElementChild) && ke(/<[/\w!]/g, t.innerHTML) && ke(/<[/\w!]/g, t.textContent)) return Ot(t), !0;
        if (t.nodeType === ri) return Ot(t), !0;
        if (X && t.nodeType === oi && ke(/<[/\w]/g, t.data)) return Ot(t), !0;
        if (!_[n] || z[n]) {
          if (!z[n] && Vt(n)) {
            if (V.tagNameCheck instanceof RegExp && ke(V.tagNameCheck, n)) return !1;
            if (V.tagNameCheck instanceof Function && V.tagNameCheck(n)) return !1;
          }
          if (ot && !lt[n]) {
            const e = y(t) || t.parentNode,
              i = A(t) || t.childNodes;
            if (i && e) {
              for (let n = i.length - 1; n >= 0; --n) {
                const r = f(i[n], !0);
                r.__removalCount = (t.__removalCount || 0) + 1, e.insertBefore(r, v(t));
              }
            }
          }
          return Ot(t), !0;
        }
        return t instanceof c && !function (t) {
          let e = y(t);
          e && e.tagName || (e = {
            namespaceURI: bt,
            tagName: "template"
          });
          const i = Ae(t.tagName),
            n = Ae(e.tagName);
          return !!At[t.namespaceURI] && (t.namespaceURI === pt ? e.namespaceURI === ft ? "svg" === i : e.namespaceURI === mt ? "svg" === i && ("annotation-xml" === n || xt[n]) : Boolean(Nt[i]) : t.namespaceURI === mt ? e.namespaceURI === ft ? "math" === i : e.namespaceURI === pt ? "math" === i && Ct[n] : Boolean(It[i]) : t.namespaceURI === ft ? !(e.namespaceURI === pt && !Ct[n]) && !(e.namespaceURI === mt && !xt[n]) && !It[i] && (Et[i] || !Nt[i]) : !("application/xhtml+xml" !== St || !At[t.namespaceURI]));
        }(t) ? (Ot(t), !0) : "noscript" !== n && "noembed" !== n && "noframes" !== n || !ke(/<\/no(script|embed|frames)/i, t.innerHTML) ? (Y && t.nodeType === ni && (e = t.textContent, me([L, D, N], t => {
          e = Ce(e, t, " ");
        }), t.textContent !== e && (be(i.removed, {
          element: t.cloneNode()
        }), t.textContent = e)), jt(w.afterSanitizeElements, t, null), !1) : (Ot(t), !0);
      },
      Ut = function (t, e, i) {
        if (nt && ("id" === e || "name" === e) && (i in n || i in wt)) return !1;
        if (J && !q[e] && ke(I, e)) ;else if (H && ke(O, e)) ;else if (!W[e] || q[e]) {
          if (!(Vt(t) && (V.tagNameCheck instanceof RegExp && ke(V.tagNameCheck, t) || V.tagNameCheck instanceof Function && V.tagNameCheck(t)) && (V.attributeNameCheck instanceof RegExp && ke(V.attributeNameCheck, e) || V.attributeNameCheck instanceof Function && V.attributeNameCheck(e)) || "is" === e && V.allowCustomizedBuiltInElements && (V.tagNameCheck instanceof RegExp && ke(V.tagNameCheck, i) || V.tagNameCheck instanceof Function && V.tagNameCheck(i)))) return !1;
        } else if (dt[e]) ;else if (ke(B, Ce(i, P, ""))) ;else if ("src" !== e && "xlink:href" !== e && "href" !== e || "script" === t || 0 !== Ee(i, "data:") || !ut[t]) {
          if (K && !ke(F, Ce(i, P, ""))) ;else if (i) return !1;
        } else ;
        return !0;
      },
      Vt = function (t) {
        return "annotation-xml" !== t && xe(t, M);
      },
      zt = function (t) {
        jt(w.beforeSanitizeAttributes, t, null);
        const {
          attributes: e
        } = t;
        if (!e || Bt(t)) return;
        const n = {
          attrName: "",
          attrValue: "",
          keepAttr: !0,
          allowedAttributes: W,
          forceKeepAttr: void 0
        };
        let r = e.length;
        for (; r--;) {
          const o = e[r],
            {
              name: s,
              namespaceURI: a,
              value: l
            } = o,
            c = kt(s);
          let u = "value" === s ? l : Se(l);
          if (n.attrName = c, n.attrValue = u, n.keepAttr = !0, n.forceKeepAttr = void 0, jt(w.uponSanitizeAttribute, t, n), u = n.attrValue, !rt || "id" !== c && "name" !== c || (Ft(s, t), u = "user-content-" + u), X && ke(/((--!?|])>)|<\/(style|title)/i, u)) {
            Ft(s, t);
            continue;
          }
          if (n.forceKeepAttr) continue;
          if (Ft(s, t), !n.keepAttr) continue;
          if (!G && ke(/\/>/i, u)) {
            Ft(s, t);
            continue;
          }
          Y && me([L, D, N], t => {
            u = Ce(u, t, " ");
          });
          const h = kt(t.nodeName);
          if (Ut(h, c, u)) {
            if (x && "object" == typeof m && "function" == typeof m.getAttributeType) if (a) ;else switch (m.getAttributeType(h, c)) {
              case "TrustedHTML":
                u = x.createHTML(u);
                break;
              case "TrustedScriptURL":
                u = x.createScriptURL(u);
            }
            try {
              a ? t.setAttributeNS(a, s, u) : t.setAttribute(s, u), Bt(t) ? Ot(t) : fe(i.removed);
            } catch (t) {}
          }
        }
        jt(w.afterSanitizeAttributes, t, null);
      },
      qt = function t(e) {
        let i = null;
        const n = Mt(e);
        for (jt(w.beforeSanitizeShadowDOM, e, null); i = n.nextNode();) jt(w.uponSanitizeShadowNode, i, null), Wt(i), zt(i), i.content instanceof s && t(i.content);
        jt(w.afterSanitizeShadowDOM, e, null);
      };
    return i.sanitize = function (t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = null,
        o = null,
        a = null,
        c = null;
      if (vt = !t, vt && (t = "<!-->"), "string" != typeof t && !_t(t)) {
        if ("function" != typeof t.toString) throw Te("toString is not a function");
        if ("string" != typeof (t = t.toString())) throw Te("dirty is not a string, aborting");
      }
      if (!i.isSupported) return t;
      if (Z || Dt(e), i.removed = [], "string" == typeof t && (st = !1), st) {
        if (t.nodeName) {
          const e = kt(t.nodeName);
          if (!_[e] || z[e]) throw Te("root node is forbidden and cannot be sanitized in-place");
        }
      } else if (t instanceof l) n = Pt("<!---->"), o = n.ownerDocument.importNode(t, !0), o.nodeType === ii && "BODY" === o.nodeName || "HTML" === o.nodeName ? n = o : n.appendChild(o);else {
        if (!tt && !Y && !$ && -1 === t.indexOf("<")) return x && it ? x.createHTML(t) : t;
        if (n = Pt(t), !n) return tt ? null : it ? C : "";
      }
      n && Q && Ot(n.firstChild);
      const u = Mt(st ? t : n);
      for (; a = u.nextNode();) Wt(a), zt(a), a.content instanceof s && qt(a.content);
      if (st) return t;
      if (tt) {
        if (et) for (c = R.call(n.ownerDocument); n.firstChild;) c.appendChild(n.firstChild);else c = n;
        return (W.shadowroot || W.shadowrootmode) && (c = T.call(r, c, !0)), c;
      }
      let h = $ ? n.outerHTML : n.innerHTML;
      return $ && _["!doctype"] && n.ownerDocument && n.ownerDocument.doctype && n.ownerDocument.doctype.name && ke(Qe, n.ownerDocument.doctype.name) && (h = "<!DOCTYPE " + n.ownerDocument.doctype.name + ">\n" + h), Y && me([L, D, N], t => {
        h = Ce(h, t, " ");
      }), x && it ? x.createHTML(h) : h;
    }, i.setConfig = function () {
      Dt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Z = !0;
    }, i.clearConfig = function () {
      Tt = null, Z = !1;
    }, i.isValidAttribute = function (t, e, i) {
      Tt || Dt({});
      const n = kt(t),
        r = kt(e);
      return Ut(n, r, i);
    }, i.addHook = function (t, e) {
      "function" == typeof e && be(w[t], e);
    }, i.removeHook = function (t, e) {
      if (void 0 !== e) {
        const i = pe(w[t], e);
        return -1 === i ? void 0 : ve(w[t], i, 1)[0];
      }
      return fe(w[t]);
    }, i.removeHooks = function (t) {
      w[t] = [];
    }, i.removeAllHooks = function () {
      w = {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
      };
    }, i;
  }();
  li.addHook("uponSanitizeAttribute", function (t, e) {
    /^data-trix-/.test(e.attrName) && (e.forceKeepAttr = !0);
  });
  const ci = "style href src width height language class".split(" "),
    ui = "javascript:".split(" "),
    hi = "script iframe form noscript".split(" ");
  class di extends q {
    static setHTML(t, e, i) {
      const n = new this(e, i).sanitize(),
        r = n.getHTML ? n.getHTML() : n.outerHTML;
      t.innerHTML = r;
    }
    static sanitize(t, e) {
      const i = new this(t, e);
      return i.sanitize(), i;
    }
    constructor(t) {
      let {
        allowedAttributes: e,
        forbiddenProtocols: i,
        forbiddenElements: n,
        purifyOptions: r
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      super(...arguments), this.allowedAttributes = e || ci, this.forbiddenProtocols = i || ui, this.forbiddenElements = n || hi, this.purifyOptions = r || {}, this.body = gi(t);
    }
    sanitize() {
      this.sanitizeElements(), this.normalizeListElementNesting();
      const t = Object.assign({}, l, this.purifyOptions);
      return li.setConfig(t), this.body = li.sanitize(this.body), this.body;
    }
    getHTML() {
      return this.body.innerHTML;
    }
    getBody() {
      return this.body;
    }
    sanitizeElements() {
      const t = R(this.body),
        e = [];
      for (; t.nextNode();) {
        const i = t.currentNode;
        switch (i.nodeType) {
          case Node.ELEMENT_NODE:
            this.elementIsRemovable(i) ? e.push(i) : this.sanitizeElement(i);
            break;
          case Node.COMMENT_NODE:
            e.push(i);
        }
      }
      return e.forEach(t => S(t)), this.body;
    }
    sanitizeElement(t) {
      return t.hasAttribute("href") && this.forbiddenProtocols.includes(t.protocol) && t.removeAttribute("href"), Array.from(t.attributes).forEach(e => {
        let {
          name: i
        } = e;
        this.allowedAttributes.includes(i) || 0 === i.indexOf("data-trix") || t.removeAttribute(i);
      }), t;
    }
    normalizeListElementNesting() {
      return Array.from(this.body.querySelectorAll("ul,ol")).forEach(t => {
        const e = t.previousElementSibling;
        e && "li" === k(e) && e.appendChild(t);
      }), this.body;
    }
    elementIsRemovable(t) {
      if ((null == t ? void 0 : t.nodeType) === Node.ELEMENT_NODE) return this.elementIsForbidden(t) || this.elementIsntSerializable(t);
    }
    elementIsForbidden(t) {
      return this.forbiddenElements.includes(k(t));
    }
    elementIsntSerializable(t) {
      return "false" === t.getAttribute("data-trix-serialize") && !P(t);
    }
  }
  const gi = function () {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
      t = t.replace(/<\/html[^>]*>[^]*$/i, "</html>");
      const e = document.implementation.createHTMLDocument("");
      return e.documentElement.innerHTML = t, Array.from(e.head.querySelectorAll("style")).forEach(t => {
        e.body.appendChild(t);
      }), e.body;
    },
    {
      css: mi
    } = z;
  class pi extends ie {
    constructor() {
      super(...arguments), this.attachment = this.object, this.attachment.uploadProgressDelegate = this, this.attachmentPiece = this.options.piece;
    }
    createContentNodes() {
      return [];
    }
    createNodes() {
      let t;
      const e = t = T({
          tagName: "figure",
          className: this.getClassName(),
          data: this.getData(),
          editable: !1
        }),
        i = this.getHref();
      return i && (t = T({
        tagName: "a",
        editable: !1,
        attributes: {
          href: i,
          tabindex: -1
        }
      }), e.appendChild(t)), this.attachment.hasContent() ? di.setHTML(t, this.attachment.getContent()) : this.createContentNodes().forEach(e => {
        t.appendChild(e);
      }), t.appendChild(this.createCaptionElement()), this.attachment.isPending() && (this.progressElement = T({
        tagName: "progress",
        attributes: {
          class: mi.attachmentProgress,
          value: this.attachment.getUploadProgress(),
          max: 100
        },
        data: {
          trixMutable: !0,
          trixStoreKey: ["progressElement", this.attachment.id].join("/")
        }
      }), e.appendChild(this.progressElement)), [fi("left"), e, fi("right")];
    }
    createCaptionElement() {
      const t = T({
          tagName: "figcaption",
          className: mi.attachmentCaption
        }),
        e = this.attachmentPiece.getCaption();
      if (e) t.classList.add("".concat(mi.attachmentCaption, "--edited")), t.textContent = e;else {
        let e, i;
        const n = this.getCaptionConfig();
        if (n.name && (e = this.attachment.getFilename()), n.size && (i = this.attachment.getFormattedFilesize()), e) {
          const i = T({
            tagName: "span",
            className: mi.attachmentName,
            textContent: e
          });
          t.appendChild(i);
        }
        if (i) {
          e && t.appendChild(document.createTextNode(" "));
          const n = T({
            tagName: "span",
            className: mi.attachmentSize,
            textContent: i
          });
          t.appendChild(n);
        }
      }
      return t;
    }
    getClassName() {
      const t = [mi.attachment, "".concat(mi.attachment, "--").concat(this.attachment.getType())],
        e = this.attachment.getExtension();
      return e && t.push("".concat(mi.attachment, "--").concat(e)), t.join(" ");
    }
    getData() {
      const t = {
          trixAttachment: JSON.stringify(this.attachment),
          trixContentType: this.attachment.getContentType(),
          trixId: this.attachment.id
        },
        {
          attributes: e
        } = this.attachmentPiece;
      return e.isEmpty() || (t.trixAttributes = JSON.stringify(e)), this.attachment.isPending() && (t.trixSerialize = !1), t;
    }
    getHref() {
      if (!bi(this.attachment.getContent(), "a")) return this.attachment.getHref();
    }
    getCaptionConfig() {
      var t;
      const e = this.attachment.getType(),
        n = kt(null === (t = i[e]) || void 0 === t ? void 0 : t.caption);
      return "file" === e && (n.name = !0), n;
    }
    findProgressElement() {
      var t;
      return null === (t = this.findElement()) || void 0 === t ? void 0 : t.querySelector("progress");
    }
    attachmentDidChangeUploadProgress() {
      const t = this.attachment.getUploadProgress(),
        e = this.findProgressElement();
      e && (e.value = t);
    }
  }
  const fi = t => T({
      tagName: "span",
      textContent: d,
      data: {
        trixCursorTarget: t,
        trixSerialize: !1
      }
    }),
    bi = function (t, e) {
      const i = T("div");
      return di.setHTML(i, t || ""), i.querySelector(e);
    };
  class vi extends pi {
    constructor() {
      super(...arguments), this.attachment.previewDelegate = this;
    }
    createContentNodes() {
      return this.image = T({
        tagName: "img",
        attributes: {
          src: ""
        },
        data: {
          trixMutable: !0
        }
      }), this.refresh(this.image), [this.image];
    }
    createCaptionElement() {
      const t = super.createCaptionElement(...arguments);
      return t.textContent || t.setAttribute("data-trix-placeholder", c.captionPlaceholder), t;
    }
    refresh(t) {
      var e;
      t || (t = null === (e = this.findElement()) || void 0 === e ? void 0 : e.querySelector("img"));
      if (t) return this.updateAttributesForImage(t);
    }
    updateAttributesForImage(t) {
      const e = this.attachment.getURL(),
        i = this.attachment.getPreviewURL();
      if (t.src = i || e, i === e) t.removeAttribute("data-trix-serialized-attributes");else {
        const i = JSON.stringify({
          src: e
        });
        t.setAttribute("data-trix-serialized-attributes", i);
      }
      const n = this.attachment.getWidth(),
        r = this.attachment.getHeight();
      null != n && (t.width = n), null != r && (t.height = r);
      const o = ["imageElement", this.attachment.id, t.src, t.width, t.height].join("/");
      t.dataset.trixStoreKey = o;
    }
    attachmentDidChangeAttributes() {
      return this.refresh(this.image), this.refresh();
    }
  }
  class Ai extends ie {
    constructor() {
      super(...arguments), this.piece = this.object, this.attributes = this.piece.getAttributes(), this.textConfig = this.options.textConfig, this.context = this.options.context, this.piece.attachment ? this.attachment = this.piece.attachment : this.string = this.piece.toString();
    }
    createNodes() {
      let t = this.attachment ? this.createAttachmentNodes() : this.createStringNodes();
      const e = this.createElement();
      if (e) {
        const i = function (t) {
          for (; null !== (e = t) && void 0 !== e && e.firstElementChild;) {
            var e;
            t = t.firstElementChild;
          }
          return t;
        }(e);
        Array.from(t).forEach(t => {
          i.appendChild(t);
        }), t = [e];
      }
      return t;
    }
    createAttachmentNodes() {
      const t = this.attachment.isPreviewable() ? vi : pi;
      return this.createChildView(t, this.piece.attachment, {
        piece: this.piece
      }).getNodes();
    }
    createStringNodes() {
      var t;
      if (null !== (t = this.textConfig) && void 0 !== t && t.plaintext) return [document.createTextNode(this.string)];
      {
        const t = [],
          e = this.string.split("\n");
        for (let i = 0; i < e.length; i++) {
          const n = e[i];
          if (i > 0) {
            const e = T("br");
            t.push(e);
          }
          if (n.length) {
            const e = document.createTextNode(this.preserveSpaces(n));
            t.push(e);
          }
        }
        return t;
      }
    }
    createElement() {
      let t, e, i;
      const n = {};
      for (e in this.attributes) {
        i = this.attributes[e];
        const o = ft(e);
        if (o) {
          if (o.tagName) {
            var r;
            const e = T(o.tagName);
            r ? (r.appendChild(e), r = e) : t = r = e;
          }
          if (o.styleProperty && (n[o.styleProperty] = i), o.style) for (e in o.style) i = o.style[e], n[e] = i;
        }
      }
      if (Object.keys(n).length) for (e in t || (t = T("span")), n) i = n[e], t.style[e] = i;
      return t;
    }
    createContainerElement() {
      for (const t in this.attributes) {
        const e = this.attributes[t],
          i = ft(t);
        if (i && i.groupTagName) {
          const n = {};
          return n[t] = e, T(i.groupTagName, n);
        }
      }
    }
    preserveSpaces(t) {
      return this.context.isLast && (t = t.replace(/\ $/, g)), t = t.replace(/(\S)\ {3}(\S)/g, "$1 ".concat(g, " $2")).replace(/\ {2}/g, "".concat(g, " ")).replace(/\ {2}/g, " ".concat(g)), (this.context.isFirst || this.context.followsWhitespace) && (t = t.replace(/^\ /, g)), t;
    }
  }
  class yi extends ie {
    constructor() {
      super(...arguments), this.text = this.object, this.textConfig = this.options.textConfig;
    }
    createNodes() {
      const t = [],
        e = $t.groupObjects(this.getPieces()),
        i = e.length - 1;
      for (let r = 0; r < e.length; r++) {
        const o = e[r],
          s = {};
        0 === r && (s.isFirst = !0), r === i && (s.isLast = !0), xi(n) && (s.followsWhitespace = !0);
        const a = this.findOrCreateCachedChildView(Ai, o, {
          textConfig: this.textConfig,
          context: s
        });
        t.push(...Array.from(a.getNodes() || []));
        var n = o;
      }
      return t;
    }
    getPieces() {
      return Array.from(this.text.getPieces()).filter(t => !t.hasAttribute("blockBreak"));
    }
  }
  const xi = t => /\s$/.test(null == t ? void 0 : t.toString()),
    {
      css: Ci
    } = z;
  class Ei extends ie {
    constructor() {
      super(...arguments), this.block = this.object, this.attributes = this.block.getAttributes();
    }
    createNodes() {
      const t = [document.createComment("block")];
      if (this.block.isEmpty()) t.push(T("br"));else {
        var e;
        const i = null === (e = mt(this.block.getLastAttribute())) || void 0 === e ? void 0 : e.text,
          n = this.findOrCreateCachedChildView(yi, this.block.text, {
            textConfig: i
          });
        t.push(...Array.from(n.getNodes() || [])), this.shouldAddExtraNewlineElement() && t.push(T("br"));
      }
      if (this.attributes.length) return t;
      {
        let e;
        const {
          tagName: i
        } = n.default;
        this.block.isRTL() && (e = {
          dir: "rtl"
        });
        const r = T({
          tagName: i,
          attributes: e
        });
        return t.forEach(t => r.appendChild(t)), [r];
      }
    }
    createContainerElement(t) {
      const e = {};
      let i;
      const n = this.attributes[t],
        {
          tagName: r,
          htmlAttributes: o = []
        } = mt(n);
      if (0 === t && this.block.isRTL() && Object.assign(e, {
        dir: "rtl"
      }), "attachmentGallery" === n) {
        const t = this.block.getBlockBreakPosition();
        i = "".concat(Ci.attachmentGallery, " ").concat(Ci.attachmentGallery, "--").concat(t);
      }
      return Object.entries(this.block.htmlAttributes).forEach(t => {
        let [i, n] = t;
        o.includes(i) && (e[i] = n);
      }), T({
        tagName: r,
        className: i,
        attributes: e
      });
    }
    shouldAddExtraNewlineElement() {
      return /\n\n$/.test(this.block.toString());
    }
  }
  class Si extends ie {
    static render(t) {
      const e = T("div"),
        i = new this(t, {
          element: e
        });
      return i.render(), i.sync(), e;
    }
    constructor() {
      super(...arguments), this.element = this.options.element, this.elementStore = new Qt(), this.setDocument(this.object);
    }
    setDocument(t) {
      t.isEqualTo(this.document) || (this.document = this.object = t);
    }
    render() {
      if (this.childViews = [], this.shadowElement = T("div"), !this.document.isEmpty()) {
        const t = $t.groupObjects(this.document.getBlocks(), {
          asTree: !0
        });
        Array.from(t).forEach(t => {
          const e = this.findOrCreateCachedChildView(Ei, t);
          Array.from(e.getNodes()).map(t => this.shadowElement.appendChild(t));
        });
      }
    }
    isSynced() {
      return ki(this.shadowElement, this.element);
    }
    sync() {
      const t = this.createDocumentFragmentForSync();
      for (; this.element.lastChild;) this.element.removeChild(this.element.lastChild);
      return this.element.appendChild(t), this.didSync();
    }
    didSync() {
      return this.elementStore.reset(Ri(this.element)), Rt(() => this.garbageCollectCachedViews());
    }
    createDocumentFragmentForSync() {
      const t = document.createDocumentFragment();
      return Array.from(this.shadowElement.childNodes).forEach(e => {
        t.appendChild(e.cloneNode(!0));
      }), Array.from(Ri(t)).forEach(t => {
        const e = this.elementStore.remove(t);
        e && t.parentNode.replaceChild(e, t);
      }), t;
    }
  }
  const Ri = t => t.querySelectorAll("[data-trix-store-key]"),
    ki = (t, e) => Ti(t.innerHTML) === Ti(e.innerHTML),
    Ti = t => t.replace(/&nbsp;/g, " ");
  function wi(t) {
    var e, i;
    function n(e, i) {
      try {
        var o = t[e](i),
          s = o.value,
          a = s instanceof Li;
        Promise.resolve(a ? s.v : s).then(function (i) {
          if (a) {
            var l = "return" === e ? "return" : "next";
            if (!s.k || i.done) return n(l, i);
            i = t[l](i).value;
          }
          r(o.done ? "return" : "normal", i);
        }, function (t) {
          n("throw", t);
        });
      } catch (t) {
        r("throw", t);
      }
    }
    function r(t, r) {
      switch (t) {
        case "return":
          e.resolve({
            value: r,
            done: !0
          });
          break;
        case "throw":
          e.reject(r);
          break;
        default:
          e.resolve({
            value: r,
            done: !1
          });
      }
      (e = e.next) ? n(e.key, e.arg) : i = null;
    }
    (this || _global)._invoke = function (t, r) {
      return new Promise(function (o, s) {
        var a = {
          key: t,
          arg: r,
          resolve: o,
          reject: s,
          next: null
        };
        i ? i = i.next = a : (e = i = a, n(t, r));
      });
    }, "function" != typeof t.return && ((this || _global).return = void 0);
  }
  function Li(t, e) {
    (this || _global).v = t, (this || _global).k = e;
  }
  function Di(t, e, i) {
    return (e = Ni(e)) in t ? Object.defineProperty(t, e, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = i, t;
  }
  function Ni(t) {
    var e = function (t, e) {
      if ("object" != typeof t || null === t) return t;
      var i = t[Symbol.toPrimitive];
      if (void 0 !== i) {
        var n = i.call(t, e || "default");
        if ("object" != typeof n) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == typeof e ? e : String(e);
  }
  wi.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () {
    return this || _global;
  }, wi.prototype.next = function (t) {
    return this._invoke("next", t);
  }, wi.prototype.throw = function (t) {
    return this._invoke("throw", t);
  }, wi.prototype.return = function (t) {
    return this._invoke("return", t);
  };
  function Ii(t, e) {
    return Pi(t, Fi(t, e, "get"));
  }
  function Oi(t, e, i) {
    return Mi(t, Fi(t, e, "set"), i), i;
  }
  function Fi(t, e, i) {
    if (!e.has(t)) throw new TypeError("attempted to " + i + " private field on non-instance");
    return e.get(t);
  }
  function Pi(t, e) {
    return e.get ? e.get.call(t) : e.value;
  }
  function Mi(t, e, i) {
    if (e.set) e.set.call(t, i);else {
      if (!e.writable) throw new TypeError("attempted to set read only private field");
      e.value = i;
    }
  }
  function Bi(t, e, i) {
    if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
    return i;
  }
  function _i(t, e) {
    if (e.has(t)) throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
  function ji(t, e, i) {
    _i(t, e), e.set(t, i);
  }
  class Wi extends rt {
    static registerType(t, e) {
      e.type = t, this.types[t] = e;
    }
    static fromJSON(t) {
      const e = this.types[t.type];
      if (e) return e.fromJSON(t);
    }
    constructor(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      super(...arguments), this.attributes = Ht.box(e);
    }
    copyWithAttributes(t) {
      return new this.constructor(this.getValue(), t);
    }
    copyWithAdditionalAttributes(t) {
      return this.copyWithAttributes(this.attributes.merge(t));
    }
    copyWithoutAttribute(t) {
      return this.copyWithAttributes(this.attributes.remove(t));
    }
    copy() {
      return this.copyWithAttributes(this.attributes);
    }
    getAttribute(t) {
      return this.attributes.get(t);
    }
    getAttributesHash() {
      return this.attributes;
    }
    getAttributes() {
      return this.attributes.toObject();
    }
    hasAttribute(t) {
      return this.attributes.has(t);
    }
    hasSameStringValueAsPiece(t) {
      return t && this.toString() === t.toString();
    }
    hasSameAttributesAsPiece(t) {
      return t && (this.attributes === t.attributes || this.attributes.isEqualTo(t.attributes));
    }
    isBlockBreak() {
      return !1;
    }
    isEqualTo(t) {
      return super.isEqualTo(...arguments) || this.hasSameConstructorAs(t) && this.hasSameStringValueAsPiece(t) && this.hasSameAttributesAsPiece(t);
    }
    isEmpty() {
      return 0 === this.length;
    }
    isSerializable() {
      return !0;
    }
    toJSON() {
      return {
        type: this.constructor.type,
        attributes: this.getAttributes()
      };
    }
    contentsForInspection() {
      return {
        type: this.constructor.type,
        attributes: this.attributes.inspect()
      };
    }
    canBeGrouped() {
      return this.hasAttribute("href");
    }
    canBeGroupedWith(t) {
      return this.getAttribute("href") === t.getAttribute("href");
    }
    getLength() {
      return this.length;
    }
    canBeConsolidatedWith(t) {
      return !1;
    }
  }
  Di(Wi, "types", {});
  class Ui extends ee {
    constructor(t) {
      super(...arguments), this.url = t;
    }
    perform(t) {
      const e = new Image();
      e.onload = () => (e.width = this.width = e.naturalWidth, e.height = this.height = e.naturalHeight, t(!0, e)), e.onerror = () => t(!1), e.src = this.url;
    }
  }
  class Vi extends rt {
    static attachmentForFile(t) {
      const e = new this(this.attributesForFile(t));
      return e.setFile(t), e;
    }
    static attributesForFile(t) {
      return new Ht({
        filename: t.name,
        filesize: t.size,
        contentType: t.type
      });
    }
    static fromJSON(t) {
      return new this(t);
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      super(t), this.releaseFile = this.releaseFile.bind(this), this.attributes = Ht.box(t), this.didChangeAttributes();
    }
    getAttribute(t) {
      return this.attributes.get(t);
    }
    hasAttribute(t) {
      return this.attributes.has(t);
    }
    getAttributes() {
      return this.attributes.toObject();
    }
    setAttributes() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      const e = this.attributes.merge(t);
      var i, n, r, o;
      if (!this.attributes.isEqualTo(e)) return this.attributes = e, this.didChangeAttributes(), null === (i = this.previewDelegate) || void 0 === i || null === (n = i.attachmentDidChangeAttributes) || void 0 === n || n.call(i, this), null === (r = this.delegate) || void 0 === r || null === (o = r.attachmentDidChangeAttributes) || void 0 === o ? void 0 : o.call(r, this);
    }
    didChangeAttributes() {
      if (this.isPreviewable()) return this.preloadURL();
    }
    isPending() {
      return null != this.file && !(this.getURL() || this.getHref());
    }
    isPreviewable() {
      return this.attributes.has("previewable") ? this.attributes.get("previewable") : Vi.previewablePattern.test(this.getContentType());
    }
    getType() {
      return this.hasContent() ? "content" : this.isPreviewable() ? "preview" : "file";
    }
    getURL() {
      return this.attributes.get("url");
    }
    getHref() {
      return this.attributes.get("href");
    }
    getFilename() {
      return this.attributes.get("filename") || "";
    }
    getFilesize() {
      return this.attributes.get("filesize");
    }
    getFormattedFilesize() {
      const t = this.attributes.get("filesize");
      return "number" == typeof t ? h.formatter(t) : "";
    }
    getExtension() {
      var t;
      return null === (t = this.getFilename().match(/\.(\w+)$/)) || void 0 === t ? void 0 : t[1].toLowerCase();
    }
    getContentType() {
      return this.attributes.get("contentType");
    }
    hasContent() {
      return this.attributes.has("content");
    }
    getContent() {
      return this.attributes.get("content");
    }
    getWidth() {
      return this.attributes.get("width");
    }
    getHeight() {
      return this.attributes.get("height");
    }
    getFile() {
      return this.file;
    }
    setFile(t) {
      if (this.file = t, this.isPreviewable()) return this.preloadFile();
    }
    releaseFile() {
      this.releasePreloadedFile(), this.file = null;
    }
    getUploadProgress() {
      return null != this.uploadProgress ? this.uploadProgress : 0;
    }
    setUploadProgress(t) {
      var e, i;
      if (this.uploadProgress !== t) return this.uploadProgress = t, null === (e = this.uploadProgressDelegate) || void 0 === e || null === (i = e.attachmentDidChangeUploadProgress) || void 0 === i ? void 0 : i.call(e, this);
    }
    toJSON() {
      return this.getAttributes();
    }
    getCacheKey() {
      return [super.getCacheKey(...arguments), this.attributes.getCacheKey(), this.getPreviewURL()].join("/");
    }
    getPreviewURL() {
      return this.previewURL || this.preloadingURL;
    }
    setPreviewURL(t) {
      var e, i, n, r;
      if (t !== this.getPreviewURL()) return this.previewURL = t, null === (e = this.previewDelegate) || void 0 === e || null === (i = e.attachmentDidChangeAttributes) || void 0 === i || i.call(e, this), null === (n = this.delegate) || void 0 === n || null === (r = n.attachmentDidChangePreviewURL) || void 0 === r ? void 0 : r.call(n, this);
    }
    preloadURL() {
      return this.preload(this.getURL(), this.releaseFile);
    }
    preloadFile() {
      if (this.file) return this.fileObjectURL = URL.createObjectURL(this.file), this.preload(this.fileObjectURL);
    }
    releasePreloadedFile() {
      this.fileObjectURL && (URL.revokeObjectURL(this.fileObjectURL), this.fileObjectURL = null);
    }
    preload(t, e) {
      if (t && t !== this.getPreviewURL()) {
        this.preloadingURL = t;
        return new Ui(t).then(i => {
          let {
            width: n,
            height: r
          } = i;
          return this.getWidth() && this.getHeight() || this.setAttributes({
            width: n,
            height: r
          }), this.preloadingURL = null, this.setPreviewURL(t), null == e ? void 0 : e();
        }).catch(() => (this.preloadingURL = null, null == e ? void 0 : e()));
      }
    }
  }
  Di(Vi, "previewablePattern", /^image(\/(gif|png|webp|jpe?g)|$)/);
  class zi extends Wi {
    static fromJSON(t) {
      return new this(Vi.fromJSON(t.attachment), t.attributes);
    }
    constructor(t) {
      super(...arguments), this.attachment = t, this.length = 1, this.ensureAttachmentExclusivelyHasAttribute("href"), this.attachment.hasContent() || this.removeProhibitedAttributes();
    }
    ensureAttachmentExclusivelyHasAttribute(t) {
      this.hasAttribute(t) && (this.attachment.hasAttribute(t) || this.attachment.setAttributes(this.attributes.slice([t])), this.attributes = this.attributes.remove(t));
    }
    removeProhibitedAttributes() {
      const t = this.attributes.slice(zi.permittedAttributes);
      t.isEqualTo(this.attributes) || (this.attributes = t);
    }
    getValue() {
      return this.attachment;
    }
    isSerializable() {
      return !this.attachment.isPending();
    }
    getCaption() {
      return this.attributes.get("caption") || "";
    }
    isEqualTo(t) {
      var e;
      return super.isEqualTo(t) && this.attachment.id === (null == t || null === (e = t.attachment) || void 0 === e ? void 0 : e.id);
    }
    toString() {
      return "\uFFFC";
    }
    toJSON() {
      const t = super.toJSON(...arguments);
      return t.attachment = this.attachment, t;
    }
    getCacheKey() {
      return [super.getCacheKey(...arguments), this.attachment.getCacheKey()].join("/");
    }
    toConsole() {
      return JSON.stringify(this.toString());
    }
  }
  Di(zi, "permittedAttributes", ["caption", "presentation"]), Wi.registerType("attachment", zi);
  class qi extends Wi {
    static fromJSON(t) {
      return new this(t.string, t.attributes);
    }
    constructor(t) {
      super(...arguments), this.string = (t => t.replace(/\r\n?/g, "\n"))(t), this.length = this.string.length;
    }
    getValue() {
      return this.string;
    }
    toString() {
      return this.string.toString();
    }
    isBlockBreak() {
      return "\n" === this.toString() && !0 === this.getAttribute("blockBreak");
    }
    toJSON() {
      const t = super.toJSON(...arguments);
      return t.string = this.string, t;
    }
    canBeConsolidatedWith(t) {
      return t && this.hasSameConstructorAs(t) && this.hasSameAttributesAsPiece(t);
    }
    consolidateWith(t) {
      return new this.constructor(this.toString() + t.toString(), this.attributes);
    }
    splitAtOffset(t) {
      let e, i;
      return 0 === t ? (e = null, i = this) : t === this.length ? (e = this, i = null) : (e = new this.constructor(this.string.slice(0, t), this.attributes), i = new this.constructor(this.string.slice(t), this.attributes)), [e, i];
    }
    toConsole() {
      let {
        string: t
      } = this;
      return t.length > 15 && (t = t.slice(0, 14) + "\u2026"), JSON.stringify(t.toString());
    }
  }
  Wi.registerType("string", qi);
  class Hi extends rt {
    static box(t) {
      return t instanceof this ? t : new this(t);
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      super(...arguments), this.objects = t.slice(0), this.length = this.objects.length;
    }
    indexOf(t) {
      return this.objects.indexOf(t);
    }
    splice() {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
      return new this.constructor(st(this.objects, ...e));
    }
    eachObject(t) {
      return this.objects.map((e, i) => t(e, i));
    }
    insertObjectAtIndex(t, e) {
      return this.splice(e, 0, t);
    }
    insertSplittableListAtIndex(t, e) {
      return this.splice(e, 0, ...t.objects);
    }
    insertSplittableListAtPosition(t, e) {
      const [i, n] = this.splitObjectAtPosition(e);
      return new this.constructor(i).insertSplittableListAtIndex(t, n);
    }
    editObjectAtIndex(t, e) {
      return this.replaceObjectAtIndex(e(this.objects[t]), t);
    }
    replaceObjectAtIndex(t, e) {
      return this.splice(e, 1, t);
    }
    removeObjectAtIndex(t) {
      return this.splice(t, 1);
    }
    getObjectAtIndex(t) {
      return this.objects[t];
    }
    getSplittableListInRange(t) {
      const [e, i, n] = this.splitObjectsAtRange(t);
      return new this.constructor(e.slice(i, n + 1));
    }
    selectSplittableList(t) {
      const e = this.objects.filter(e => t(e));
      return new this.constructor(e);
    }
    removeObjectsInRange(t) {
      const [e, i, n] = this.splitObjectsAtRange(t);
      return new this.constructor(e).splice(i, n - i + 1);
    }
    transformObjectsInRange(t, e) {
      const [i, n, r] = this.splitObjectsAtRange(t),
        o = i.map((t, i) => n <= i && i <= r ? e(t) : t);
      return new this.constructor(o);
    }
    splitObjectsAtRange(t) {
      let e,
        [i, n, r] = this.splitObjectAtPosition(Ki(t));
      return [i, e] = new this.constructor(i).splitObjectAtPosition(Gi(t) + r), [i, n, e - 1];
    }
    getObjectAtPosition(t) {
      const {
        index: e
      } = this.findIndexAndOffsetAtPosition(t);
      return this.objects[e];
    }
    splitObjectAtPosition(t) {
      let e, i;
      const {
          index: n,
          offset: r
        } = this.findIndexAndOffsetAtPosition(t),
        o = this.objects.slice(0);
      if (null != n) {
        if (0 === r) e = n, i = 0;else {
          const t = this.getObjectAtIndex(n),
            [s, a] = t.splitAtOffset(r);
          o.splice(n, 1, s, a), e = n + 1, i = s.getLength() - r;
        }
      } else e = o.length, i = 0;
      return [o, e, i];
    }
    consolidate() {
      const t = [];
      let e = this.objects[0];
      return this.objects.slice(1).forEach(i => {
        var n, r;
        null !== (n = (r = e).canBeConsolidatedWith) && void 0 !== n && n.call(r, i) ? e = e.consolidateWith(i) : (t.push(e), e = i);
      }), e && t.push(e), new this.constructor(t);
    }
    consolidateFromIndexToIndex(t, e) {
      const i = this.objects.slice(0).slice(t, e + 1),
        n = new this.constructor(i).consolidate().toArray();
      return this.splice(t, i.length, ...n);
    }
    findIndexAndOffsetAtPosition(t) {
      let e,
        i = 0;
      for (e = 0; e < this.objects.length; e++) {
        const n = i + this.objects[e].getLength();
        if (i <= t && t < n) return {
          index: e,
          offset: t - i
        };
        i = n;
      }
      return {
        index: null,
        offset: null
      };
    }
    findPositionAtIndexAndOffset(t, e) {
      let i = 0;
      for (let n = 0; n < this.objects.length; n++) {
        const r = this.objects[n];
        if (n < t) i += r.getLength();else if (n === t) {
          i += e;
          break;
        }
      }
      return i;
    }
    getEndPosition() {
      return null == this.endPosition && (this.endPosition = 0, this.objects.forEach(t => this.endPosition += t.getLength())), this.endPosition;
    }
    toString() {
      return this.objects.join("");
    }
    toArray() {
      return this.objects.slice(0);
    }
    toJSON() {
      return this.toArray();
    }
    isEqualTo(t) {
      return super.isEqualTo(...arguments) || Ji(this.objects, null == t ? void 0 : t.objects);
    }
    contentsForInspection() {
      return {
        objects: "[".concat(this.objects.map(t => t.inspect()).join(", "), "]")
      };
    }
  }
  const Ji = function (t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      if (t.length !== e.length) return !1;
      let i = !0;
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        i && !r.isEqualTo(e[n]) && (i = !1);
      }
      return i;
    },
    Ki = t => t[0],
    Gi = t => t[1];
  class Yi extends rt {
    static textForAttachmentWithAttributes(t, e) {
      return new this([new zi(t, e)]);
    }
    static textForStringWithAttributes(t, e) {
      return new this([new qi(t, e)]);
    }
    static fromJSON(t) {
      return new this(Array.from(t).map(t => Wi.fromJSON(t)));
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      super(...arguments);
      const e = t.filter(t => !t.isEmpty());
      this.pieceList = new Hi(e);
    }
    copy() {
      return this.copyWithPieceList(this.pieceList);
    }
    copyWithPieceList(t) {
      return new this.constructor(t.consolidate().toArray());
    }
    copyUsingObjectMap(t) {
      const e = this.getPieces().map(e => t.find(e) || e);
      return new this.constructor(e);
    }
    appendText(t) {
      return this.insertTextAtPosition(t, this.getLength());
    }
    insertTextAtPosition(t, e) {
      return this.copyWithPieceList(this.pieceList.insertSplittableListAtPosition(t.pieceList, e));
    }
    removeTextAtRange(t) {
      return this.copyWithPieceList(this.pieceList.removeObjectsInRange(t));
    }
    replaceTextAtRange(t, e) {
      return this.removeTextAtRange(e).insertTextAtPosition(t, e[0]);
    }
    moveTextFromRangeToPosition(t, e) {
      if (t[0] <= e && e <= t[1]) return;
      const i = this.getTextAtRange(t),
        n = i.getLength();
      return t[0] < e && (e -= n), this.removeTextAtRange(t).insertTextAtPosition(i, e);
    }
    addAttributeAtRange(t, e, i) {
      const n = {};
      return n[t] = e, this.addAttributesAtRange(n, i);
    }
    addAttributesAtRange(t, e) {
      return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, e => e.copyWithAdditionalAttributes(t)));
    }
    removeAttributeAtRange(t, e) {
      return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, e => e.copyWithoutAttribute(t)));
    }
    setAttributesAtRange(t, e) {
      return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, e => e.copyWithAttributes(t)));
    }
    getAttributesAtPosition(t) {
      var e;
      return (null === (e = this.pieceList.getObjectAtPosition(t)) || void 0 === e ? void 0 : e.getAttributes()) || {};
    }
    getCommonAttributes() {
      const t = Array.from(this.pieceList.toArray()).map(t => t.getAttributes());
      return Ht.fromCommonAttributesOfObjects(t).toObject();
    }
    getCommonAttributesAtRange(t) {
      return this.getTextAtRange(t).getCommonAttributes() || {};
    }
    getExpandedRangeForAttributeAtOffset(t, e) {
      let i,
        n = i = e;
      const r = this.getLength();
      for (; n > 0 && this.getCommonAttributesAtRange([n - 1, i])[t];) n--;
      for (; i < r && this.getCommonAttributesAtRange([e, i + 1])[t];) i++;
      return [n, i];
    }
    getTextAtRange(t) {
      return this.copyWithPieceList(this.pieceList.getSplittableListInRange(t));
    }
    getStringAtRange(t) {
      return this.pieceList.getSplittableListInRange(t).toString();
    }
    getStringAtPosition(t) {
      return this.getStringAtRange([t, t + 1]);
    }
    startsWithString(t) {
      return this.getStringAtRange([0, t.length]) === t;
    }
    endsWithString(t) {
      const e = this.getLength();
      return this.getStringAtRange([e - t.length, e]) === t;
    }
    getAttachmentPieces() {
      return this.pieceList.toArray().filter(t => !!t.attachment);
    }
    getAttachments() {
      return this.getAttachmentPieces().map(t => t.attachment);
    }
    getAttachmentAndPositionById(t) {
      let e = 0;
      for (const n of this.pieceList.toArray()) {
        var i;
        if ((null === (i = n.attachment) || void 0 === i ? void 0 : i.id) === t) return {
          attachment: n.attachment,
          position: e
        };
        e += n.length;
      }
      return {
        attachment: null,
        position: null
      };
    }
    getAttachmentById(t) {
      const {
        attachment: e
      } = this.getAttachmentAndPositionById(t);
      return e;
    }
    getRangeOfAttachment(t) {
      const e = this.getAttachmentAndPositionById(t.id),
        i = e.position;
      if (t = e.attachment) return [i, i + 1];
    }
    updateAttributesForAttachment(t, e) {
      const i = this.getRangeOfAttachment(e);
      return i ? this.addAttributesAtRange(t, i) : this;
    }
    getLength() {
      return this.pieceList.getEndPosition();
    }
    isEmpty() {
      return 0 === this.getLength();
    }
    isEqualTo(t) {
      var e;
      return super.isEqualTo(t) || (null == t || null === (e = t.pieceList) || void 0 === e ? void 0 : e.isEqualTo(this.pieceList));
    }
    isBlockBreak() {
      return 1 === this.getLength() && this.pieceList.getObjectAtIndex(0).isBlockBreak();
    }
    eachPiece(t) {
      return this.pieceList.eachObject(t);
    }
    getPieces() {
      return this.pieceList.toArray();
    }
    getPieceAtPosition(t) {
      return this.pieceList.getObjectAtPosition(t);
    }
    contentsForInspection() {
      return {
        pieceList: this.pieceList.inspect()
      };
    }
    toSerializableText() {
      const t = this.pieceList.selectSplittableList(t => t.isSerializable());
      return this.copyWithPieceList(t);
    }
    toString() {
      return this.pieceList.toString();
    }
    toJSON() {
      return this.pieceList.toJSON();
    }
    toConsole() {
      return JSON.stringify(this.pieceList.toArray().map(t => JSON.parse(t.toConsole())));
    }
    getDirection() {
      return lt(this.toString());
    }
    isRTL() {
      return "rtl" === this.getDirection();
    }
  }
  class Xi extends rt {
    static fromJSON(t) {
      return new this(Yi.fromJSON(t.text), t.attributes, t.htmlAttributes);
    }
    constructor(t, e, i) {
      super(...arguments), this.text = $i(t || new Yi()), this.attributes = e || [], this.htmlAttributes = i || {};
    }
    isEmpty() {
      return this.text.isBlockBreak();
    }
    isEqualTo(t) {
      return !!super.isEqualTo(t) || this.text.isEqualTo(null == t ? void 0 : t.text) && ot(this.attributes, null == t ? void 0 : t.attributes) && Tt(this.htmlAttributes, null == t ? void 0 : t.htmlAttributes);
    }
    copyWithText(t) {
      return new Xi(t, this.attributes, this.htmlAttributes);
    }
    copyWithoutText() {
      return this.copyWithText(null);
    }
    copyWithAttributes(t) {
      return new Xi(this.text, t, this.htmlAttributes);
    }
    copyWithoutAttributes() {
      return this.copyWithAttributes(null);
    }
    copyUsingObjectMap(t) {
      const e = t.find(this.text);
      return e ? this.copyWithText(e) : this.copyWithText(this.text.copyUsingObjectMap(t));
    }
    addAttribute(t) {
      const e = this.attributes.concat(rn(t));
      return this.copyWithAttributes(e);
    }
    addHTMLAttribute(t, e) {
      const i = Object.assign({}, this.htmlAttributes, {
        [t]: e
      });
      return new Xi(this.text, this.attributes, i);
    }
    removeAttribute(t) {
      const {
          listAttribute: e
        } = mt(t),
        i = sn(sn(this.attributes, t), e);
      return this.copyWithAttributes(i);
    }
    removeLastAttribute() {
      return this.removeAttribute(this.getLastAttribute());
    }
    getLastAttribute() {
      return on(this.attributes);
    }
    getAttributes() {
      return this.attributes.slice(0);
    }
    getAttributeLevel() {
      return this.attributes.length;
    }
    getAttributeAtLevel(t) {
      return this.attributes[t - 1];
    }
    hasAttribute(t) {
      return this.attributes.includes(t);
    }
    hasAttributes() {
      return this.getAttributeLevel() > 0;
    }
    getLastNestableAttribute() {
      return on(this.getNestableAttributes());
    }
    getNestableAttributes() {
      return this.attributes.filter(t => mt(t).nestable);
    }
    getNestingLevel() {
      return this.getNestableAttributes().length;
    }
    decreaseNestingLevel() {
      const t = this.getLastNestableAttribute();
      return t ? this.removeAttribute(t) : this;
    }
    increaseNestingLevel() {
      const t = this.getLastNestableAttribute();
      if (t) {
        const e = this.attributes.lastIndexOf(t),
          i = st(this.attributes, e + 1, 0, ...rn(t));
        return this.copyWithAttributes(i);
      }
      return this;
    }
    getListItemAttributes() {
      return this.attributes.filter(t => mt(t).listAttribute);
    }
    isListItem() {
      var t;
      return null === (t = mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.listAttribute;
    }
    isTerminalBlock() {
      var t;
      return null === (t = mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.terminal;
    }
    breaksOnReturn() {
      var t;
      return null === (t = mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.breakOnReturn;
    }
    findLineBreakInDirectionFromPosition(t, e) {
      const i = this.toString();
      let n;
      switch (t) {
        case "forward":
          n = i.indexOf("\n", e);
          break;
        case "backward":
          n = i.slice(0, e).lastIndexOf("\n");
      }
      if (-1 !== n) return n;
    }
    contentsForInspection() {
      return {
        text: this.text.inspect(),
        attributes: this.attributes
      };
    }
    toString() {
      return this.text.toString();
    }
    toJSON() {
      return {
        text: this.text,
        attributes: this.attributes,
        htmlAttributes: this.htmlAttributes
      };
    }
    getDirection() {
      return this.text.getDirection();
    }
    isRTL() {
      return this.text.isRTL();
    }
    getLength() {
      return this.text.getLength();
    }
    canBeConsolidatedWith(t) {
      return !this.hasAttributes() && !t.hasAttributes() && this.getDirection() === t.getDirection();
    }
    consolidateWith(t) {
      const e = Yi.textForStringWithAttributes("\n"),
        i = this.getTextWithoutBlockBreak().appendText(e);
      return this.copyWithText(i.appendText(t.text));
    }
    splitAtOffset(t) {
      let e, i;
      return 0 === t ? (e = null, i = this) : t === this.getLength() ? (e = this, i = null) : (e = this.copyWithText(this.text.getTextAtRange([0, t])), i = this.copyWithText(this.text.getTextAtRange([t, this.getLength()]))), [e, i];
    }
    getBlockBreakPosition() {
      return this.text.getLength() - 1;
    }
    getTextWithoutBlockBreak() {
      return en(this.text) ? this.text.getTextAtRange([0, this.getBlockBreakPosition()]) : this.text.copy();
    }
    canBeGrouped(t) {
      return this.attributes[t];
    }
    canBeGroupedWith(t, e) {
      const i = t.getAttributes(),
        r = i[e],
        o = this.attributes[e];
      return o === r && !(!1 === mt(o).group && !(() => {
        if (!dt) {
          dt = [];
          for (const t in n) {
            const {
              listAttribute: e
            } = n[t];
            null != e && dt.push(e);
          }
        }
        return dt;
      })().includes(i[e + 1])) && (this.getDirection() === t.getDirection() || t.isEmpty());
    }
  }
  const $i = function (t) {
      return t = Zi(t), t = tn(t);
    },
    Zi = function (t) {
      let e = !1;
      const i = t.getPieces();
      let n = i.slice(0, i.length - 1);
      const r = i[i.length - 1];
      return r ? (n = n.map(t => t.isBlockBreak() ? (e = !0, nn(t)) : t), e ? new Yi([...n, r]) : t) : t;
    },
    Qi = Yi.textForStringWithAttributes("\n", {
      blockBreak: !0
    }),
    tn = function (t) {
      return en(t) ? t : t.appendText(Qi);
    },
    en = function (t) {
      const e = t.getLength();
      if (0 === e) return !1;
      return t.getTextAtRange([e - 1, e]).isBlockBreak();
    },
    nn = t => t.copyWithoutAttribute("blockBreak"),
    rn = function (t) {
      const {
        listAttribute: e
      } = mt(t);
      return e ? [e, t] : [t];
    },
    on = t => t.slice(-1)[0],
    sn = function (t, e) {
      const i = t.lastIndexOf(e);
      return -1 === i ? t : st(t, i, 1);
    };
  class an extends rt {
    static fromJSON(t) {
      return new this(Array.from(t).map(t => Xi.fromJSON(t)));
    }
    static fromString(t, e) {
      const i = Yi.textForStringWithAttributes(t, e);
      return new this([new Xi(i)]);
    }
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      super(...arguments), 0 === t.length && (t = [new Xi()]), this.blockList = Hi.box(t);
    }
    isEmpty() {
      const t = this.getBlockAtIndex(0);
      return 1 === this.blockList.length && t.isEmpty() && !t.hasAttributes();
    }
    copy() {
      const t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).consolidateBlocks ? this.blockList.consolidate().toArray() : this.blockList.toArray();
      return new this.constructor(t);
    }
    copyUsingObjectsFromDocument(t) {
      const e = new Zt(t.getObjects());
      return this.copyUsingObjectMap(e);
    }
    copyUsingObjectMap(t) {
      const e = this.getBlocks().map(e => t.find(e) || e.copyUsingObjectMap(t));
      return new this.constructor(e);
    }
    copyWithBaseBlockAttributes() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      const e = this.getBlocks().map(e => {
        const i = t.concat(e.getAttributes());
        return e.copyWithAttributes(i);
      });
      return new this.constructor(e);
    }
    replaceBlock(t, e) {
      const i = this.blockList.indexOf(t);
      return -1 === i ? this : new this.constructor(this.blockList.replaceObjectAtIndex(e, i));
    }
    insertDocumentAtRange(t, e) {
      const {
        blockList: i
      } = t;
      e = wt(e);
      let [n] = e;
      const {
        index: r,
        offset: o
      } = this.locationFromPosition(n);
      let s = this;
      const a = this.getBlockAtPosition(n);
      return Lt(e) && a.isEmpty() && !a.hasAttributes() ? s = new this.constructor(s.blockList.removeObjectAtIndex(r)) : a.getBlockBreakPosition() === o && n++, s = s.removeTextAtRange(e), new this.constructor(s.blockList.insertSplittableListAtPosition(i, n));
    }
    mergeDocumentAtRange(t, e) {
      let i, n;
      e = wt(e);
      const [r] = e,
        o = this.locationFromPosition(r),
        s = this.getBlockAtIndex(o.index).getAttributes(),
        a = t.getBaseBlockAttributes(),
        l = s.slice(-a.length);
      if (ot(a, l)) {
        const e = s.slice(0, -a.length);
        i = t.copyWithBaseBlockAttributes(e);
      } else i = t.copy({
        consolidateBlocks: !0
      }).copyWithBaseBlockAttributes(s);
      const c = i.getBlockCount(),
        u = i.getBlockAtIndex(0);
      if (ot(s, u.getAttributes())) {
        const t = u.getTextWithoutBlockBreak();
        if (n = this.insertTextAtRange(t, e), c > 1) {
          i = new this.constructor(i.getBlocks().slice(1));
          const e = r + t.getLength();
          n = n.insertDocumentAtRange(i, e);
        }
      } else n = this.insertDocumentAtRange(i, e);
      return n;
    }
    insertTextAtRange(t, e) {
      e = wt(e);
      const [i] = e,
        {
          index: n,
          offset: r
        } = this.locationFromPosition(i),
        o = this.removeTextAtRange(e);
      return new this.constructor(o.blockList.editObjectAtIndex(n, e => e.copyWithText(e.text.insertTextAtPosition(t, r))));
    }
    removeTextAtRange(t) {
      let e;
      t = wt(t);
      const [i, n] = t;
      if (Lt(t)) return this;
      const [r, o] = Array.from(this.locationRangeFromRange(t)),
        s = r.index,
        a = r.offset,
        l = this.getBlockAtIndex(s),
        c = o.index,
        u = o.offset,
        h = this.getBlockAtIndex(c);
      if (n - i == 1 && l.getBlockBreakPosition() === a && h.getBlockBreakPosition() !== u && "\n" === h.text.getStringAtPosition(u)) e = this.blockList.editObjectAtIndex(c, t => t.copyWithText(t.text.removeTextAtRange([u, u + 1])));else {
        let t;
        const i = l.text.getTextAtRange([0, a]),
          n = h.text.getTextAtRange([u, h.getLength()]),
          r = i.appendText(n);
        t = s !== c && 0 === a && l.getAttributeLevel() >= h.getAttributeLevel() ? h.copyWithText(r) : l.copyWithText(r);
        const o = c + 1 - s;
        e = this.blockList.splice(s, o, t);
      }
      return new this.constructor(e);
    }
    moveTextFromRangeToPosition(t, e) {
      let i;
      t = wt(t);
      const [n, r] = t;
      if (n <= e && e <= r) return this;
      let o = this.getDocumentAtRange(t),
        s = this.removeTextAtRange(t);
      const a = n < e;
      a && (e -= o.getLength());
      const [l, ...c] = o.getBlocks();
      return 0 === c.length ? (i = l.getTextWithoutBlockBreak(), a && (e += 1)) : i = l.text, s = s.insertTextAtRange(i, e), 0 === c.length ? s : (o = new this.constructor(c), e += i.getLength(), s.insertDocumentAtRange(o, e));
    }
    addAttributeAtRange(t, e, i) {
      let {
        blockList: n
      } = this;
      return this.eachBlockAtRange(i, (i, r, o) => n = n.editObjectAtIndex(o, function () {
        return mt(t) ? i.addAttribute(t, e) : r[0] === r[1] ? i : i.copyWithText(i.text.addAttributeAtRange(t, e, r));
      })), new this.constructor(n);
    }
    addAttribute(t, e) {
      let {
        blockList: i
      } = this;
      return this.eachBlock((n, r) => i = i.editObjectAtIndex(r, () => n.addAttribute(t, e))), new this.constructor(i);
    }
    removeAttributeAtRange(t, e) {
      let {
        blockList: i
      } = this;
      return this.eachBlockAtRange(e, function (e, n, r) {
        mt(t) ? i = i.editObjectAtIndex(r, () => e.removeAttribute(t)) : n[0] !== n[1] && (i = i.editObjectAtIndex(r, () => e.copyWithText(e.text.removeAttributeAtRange(t, n))));
      }), new this.constructor(i);
    }
    updateAttributesForAttachment(t, e) {
      const i = this.getRangeOfAttachment(e),
        [n] = Array.from(i),
        {
          index: r
        } = this.locationFromPosition(n),
        o = this.getTextAtIndex(r);
      return new this.constructor(this.blockList.editObjectAtIndex(r, i => i.copyWithText(o.updateAttributesForAttachment(t, e))));
    }
    removeAttributeForAttachment(t, e) {
      const i = this.getRangeOfAttachment(e);
      return this.removeAttributeAtRange(t, i);
    }
    setHTMLAttributeAtPosition(t, e, i) {
      const n = this.getBlockAtPosition(t),
        r = n.addHTMLAttribute(e, i);
      return this.replaceBlock(n, r);
    }
    insertBlockBreakAtRange(t) {
      let e;
      t = wt(t);
      const [i] = t,
        {
          offset: n
        } = this.locationFromPosition(i),
        r = this.removeTextAtRange(t);
      return 0 === n && (e = [new Xi()]), new this.constructor(r.blockList.insertSplittableListAtPosition(new Hi(e), i));
    }
    applyBlockAttributeAtRange(t, e, i) {
      const n = this.expandRangeToLineBreaksAndSplitBlocks(i);
      let r = n.document;
      i = n.range;
      const o = mt(t);
      if (o.listAttribute) {
        r = r.removeLastListAttributeAtRange(i, {
          exceptAttributeName: t
        });
        const e = r.convertLineBreaksToBlockBreaksInRange(i);
        r = e.document, i = e.range;
      } else r = o.exclusive ? r.removeBlockAttributesAtRange(i) : o.terminal ? r.removeLastTerminalAttributeAtRange(i) : r.consolidateBlocksAtRange(i);
      return r.addAttributeAtRange(t, e, i);
    }
    removeLastListAttributeAtRange(t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        {
          blockList: i
        } = this;
      return this.eachBlockAtRange(t, function (t, n, r) {
        const o = t.getLastAttribute();
        o && mt(o).listAttribute && o !== e.exceptAttributeName && (i = i.editObjectAtIndex(r, () => t.removeAttribute(o)));
      }), new this.constructor(i);
    }
    removeLastTerminalAttributeAtRange(t) {
      let {
        blockList: e
      } = this;
      return this.eachBlockAtRange(t, function (t, i, n) {
        const r = t.getLastAttribute();
        r && mt(r).terminal && (e = e.editObjectAtIndex(n, () => t.removeAttribute(r)));
      }), new this.constructor(e);
    }
    removeBlockAttributesAtRange(t) {
      let {
        blockList: e
      } = this;
      return this.eachBlockAtRange(t, function (t, i, n) {
        t.hasAttributes() && (e = e.editObjectAtIndex(n, () => t.copyWithoutAttributes()));
      }), new this.constructor(e);
    }
    expandRangeToLineBreaksAndSplitBlocks(t) {
      let e;
      t = wt(t);
      let [i, n] = t;
      const r = this.locationFromPosition(i),
        o = this.locationFromPosition(n);
      let s = this;
      const a = s.getBlockAtIndex(r.index);
      if (r.offset = a.findLineBreakInDirectionFromPosition("backward", r.offset), null != r.offset && (e = s.positionFromLocation(r), s = s.insertBlockBreakAtRange([e, e + 1]), o.index += 1, o.offset -= s.getBlockAtIndex(r.index).getLength(), r.index += 1), r.offset = 0, 0 === o.offset && o.index > r.index) o.index -= 1, o.offset = s.getBlockAtIndex(o.index).getBlockBreakPosition();else {
        const t = s.getBlockAtIndex(o.index);
        "\n" === t.text.getStringAtRange([o.offset - 1, o.offset]) ? o.offset -= 1 : o.offset = t.findLineBreakInDirectionFromPosition("forward", o.offset), o.offset !== t.getBlockBreakPosition() && (e = s.positionFromLocation(o), s = s.insertBlockBreakAtRange([e, e + 1]));
      }
      return i = s.positionFromLocation(r), n = s.positionFromLocation(o), {
        document: s,
        range: t = wt([i, n])
      };
    }
    convertLineBreaksToBlockBreaksInRange(t) {
      t = wt(t);
      let [e] = t;
      const i = this.getStringAtRange(t).slice(0, -1);
      let n = this;
      return i.replace(/.*?\n/g, function (t) {
        e += t.length, n = n.insertBlockBreakAtRange([e - 1, e]);
      }), {
        document: n,
        range: t
      };
    }
    consolidateBlocksAtRange(t) {
      t = wt(t);
      const [e, i] = t,
        n = this.locationFromPosition(e).index,
        r = this.locationFromPosition(i).index;
      return new this.constructor(this.blockList.consolidateFromIndexToIndex(n, r));
    }
    getDocumentAtRange(t) {
      t = wt(t);
      const e = this.blockList.getSplittableListInRange(t).toArray();
      return new this.constructor(e);
    }
    getStringAtRange(t) {
      let e;
      const i = t = wt(t);
      return i[i.length - 1] !== this.getLength() && (e = -1), this.getDocumentAtRange(t).toString().slice(0, e);
    }
    getBlockAtIndex(t) {
      return this.blockList.getObjectAtIndex(t);
    }
    getBlockAtPosition(t) {
      const {
        index: e
      } = this.locationFromPosition(t);
      return this.getBlockAtIndex(e);
    }
    getTextAtIndex(t) {
      var e;
      return null === (e = this.getBlockAtIndex(t)) || void 0 === e ? void 0 : e.text;
    }
    getTextAtPosition(t) {
      const {
        index: e
      } = this.locationFromPosition(t);
      return this.getTextAtIndex(e);
    }
    getPieceAtPosition(t) {
      const {
        index: e,
        offset: i
      } = this.locationFromPosition(t);
      return this.getTextAtIndex(e).getPieceAtPosition(i);
    }
    getCharacterAtPosition(t) {
      const {
        index: e,
        offset: i
      } = this.locationFromPosition(t);
      return this.getTextAtIndex(e).getStringAtRange([i, i + 1]);
    }
    getLength() {
      return this.blockList.getEndPosition();
    }
    getBlocks() {
      return this.blockList.toArray();
    }
    getBlockCount() {
      return this.blockList.length;
    }
    getEditCount() {
      return this.editCount;
    }
    eachBlock(t) {
      return this.blockList.eachObject(t);
    }
    eachBlockAtRange(t, e) {
      let i, n;
      t = wt(t);
      const [r, o] = t,
        s = this.locationFromPosition(r),
        a = this.locationFromPosition(o);
      if (s.index === a.index) return i = this.getBlockAtIndex(s.index), n = [s.offset, a.offset], e(i, n, s.index);
      for (let t = s.index; t <= a.index; t++) if (i = this.getBlockAtIndex(t), i) {
        switch (t) {
          case s.index:
            n = [s.offset, i.text.getLength()];
            break;
          case a.index:
            n = [0, a.offset];
            break;
          default:
            n = [0, i.text.getLength()];
        }
        e(i, n, t);
      }
    }
    getCommonAttributesAtRange(t) {
      t = wt(t);
      const [e] = t;
      if (Lt(t)) return this.getCommonAttributesAtPosition(e);
      {
        const e = [],
          i = [];
        return this.eachBlockAtRange(t, function (t, n) {
          if (n[0] !== n[1]) return e.push(t.text.getCommonAttributesAtRange(n)), i.push(ln(t));
        }), Ht.fromCommonAttributesOfObjects(e).merge(Ht.fromCommonAttributesOfObjects(i)).toObject();
      }
    }
    getCommonAttributesAtPosition(t) {
      let e, i;
      const {
          index: n,
          offset: r
        } = this.locationFromPosition(t),
        o = this.getBlockAtIndex(n);
      if (!o) return {};
      const s = ln(o),
        a = o.text.getAttributesAtPosition(r),
        l = o.text.getAttributesAtPosition(r - 1),
        c = Object.keys(W).filter(t => W[t].inheritable);
      for (e in l) i = l[e], (i === a[e] || c.includes(e)) && (s[e] = i);
      return s;
    }
    getRangeOfCommonAttributeAtPosition(t, e) {
      const {
          index: i,
          offset: n
        } = this.locationFromPosition(e),
        r = this.getTextAtIndex(i),
        [o, s] = Array.from(r.getExpandedRangeForAttributeAtOffset(t, n)),
        a = this.positionFromLocation({
          index: i,
          offset: o
        }),
        l = this.positionFromLocation({
          index: i,
          offset: s
        });
      return wt([a, l]);
    }
    getBaseBlockAttributes() {
      let t = this.getBlockAtIndex(0).getAttributes();
      for (let e = 1; e < this.getBlockCount(); e++) {
        const i = this.getBlockAtIndex(e).getAttributes(),
          n = Math.min(t.length, i.length);
        t = (() => {
          const e = [];
          for (let r = 0; r < n && i[r] === t[r]; r++) e.push(i[r]);
          return e;
        })();
      }
      return t;
    }
    getAttachmentById(t) {
      for (const e of this.getAttachments()) if (e.id === t) return e;
    }
    getAttachmentPieces() {
      let t = [];
      return this.blockList.eachObject(e => {
        let {
          text: i
        } = e;
        return t = t.concat(i.getAttachmentPieces());
      }), t;
    }
    getAttachments() {
      return this.getAttachmentPieces().map(t => t.attachment);
    }
    getRangeOfAttachment(t) {
      let e = 0;
      const i = this.blockList.toArray();
      for (let n = 0; n < i.length; n++) {
        const {
            text: r
          } = i[n],
          o = r.getRangeOfAttachment(t);
        if (o) return wt([e + o[0], e + o[1]]);
        e += r.getLength();
      }
    }
    getLocationRangeOfAttachment(t) {
      const e = this.getRangeOfAttachment(t);
      return this.locationRangeFromRange(e);
    }
    getAttachmentPieceForAttachment(t) {
      for (const e of this.getAttachmentPieces()) if (e.attachment === t) return e;
    }
    findRangesForBlockAttribute(t) {
      let e = 0;
      const i = [];
      return this.getBlocks().forEach(n => {
        const r = n.getLength();
        n.hasAttribute(t) && i.push([e, e + r]), e += r;
      }), i;
    }
    findRangesForTextAttribute(t) {
      let {
          withValue: e
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        i = 0,
        n = [];
      const r = [];
      return this.getPieces().forEach(o => {
        const s = o.getLength();
        (function (i) {
          return e ? i.getAttribute(t) === e : i.hasAttribute(t);
        })(o) && (n[1] === i ? n[1] = i + s : r.push(n = [i, i + s])), i += s;
      }), r;
    }
    locationFromPosition(t) {
      const e = this.blockList.findIndexAndOffsetAtPosition(Math.max(0, t));
      if (null != e.index) return e;
      {
        const t = this.getBlocks();
        return {
          index: t.length - 1,
          offset: t[t.length - 1].getLength()
        };
      }
    }
    positionFromLocation(t) {
      return this.blockList.findPositionAtIndexAndOffset(t.index, t.offset);
    }
    locationRangeFromPosition(t) {
      return wt(this.locationFromPosition(t));
    }
    locationRangeFromRange(t) {
      if (!(t = wt(t))) return;
      const [e, i] = Array.from(t),
        n = this.locationFromPosition(e),
        r = this.locationFromPosition(i);
      return wt([n, r]);
    }
    rangeFromLocationRange(t) {
      let e;
      t = wt(t);
      const i = this.positionFromLocation(t[0]);
      return Lt(t) || (e = this.positionFromLocation(t[1])), wt([i, e]);
    }
    isEqualTo(t) {
      return this.blockList.isEqualTo(null == t ? void 0 : t.blockList);
    }
    getTexts() {
      return this.getBlocks().map(t => t.text);
    }
    getPieces() {
      const t = [];
      return Array.from(this.getTexts()).forEach(e => {
        t.push(...Array.from(e.getPieces() || []));
      }), t;
    }
    getObjects() {
      return this.getBlocks().concat(this.getTexts()).concat(this.getPieces());
    }
    toSerializableDocument() {
      const t = [];
      return this.blockList.eachObject(e => t.push(e.copyWithText(e.text.toSerializableText()))), new this.constructor(t);
    }
    toString() {
      return this.blockList.toString();
    }
    toJSON() {
      return this.blockList.toJSON();
    }
    toConsole() {
      return JSON.stringify(this.blockList.toArray().map(t => JSON.parse(t.text.toConsole())));
    }
  }
  const ln = function (t) {
      const e = {},
        i = t.getLastAttribute();
      return i && (e[i] = !0), e;
    },
    cn = function (t) {
      let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return {
        string: t = Wt(t),
        attributes: e,
        type: "string"
      };
    },
    un = (t, e) => {
      try {
        return JSON.parse(t.getAttribute("data-trix-".concat(e)));
      } catch (t) {
        return {};
      }
    };
  class hn extends q {
    static parse(t, e) {
      const i = new this(t, e);
      return i.parse(), i;
    }
    constructor(t) {
      let {
        referenceElement: e,
        purifyOptions: i
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      super(...arguments), this.html = t, this.referenceElement = e, this.purifyOptions = i, this.blocks = [], this.blockElements = [], this.processedElements = [];
    }
    getDocument() {
      return an.fromJSON(this.blocks);
    }
    parse() {
      try {
        this.createHiddenContainer(), di.setHTML(this.containerElement, this.html, {
          purifyOptions: this.purifyOptions
        });
        const t = R(this.containerElement, {
          usingFilter: pn
        });
        for (; t.nextNode();) this.processNode(t.currentNode);
        return this.translateBlockElementMarginsToNewlines();
      } finally {
        this.removeHiddenContainer();
      }
    }
    createHiddenContainer() {
      return this.referenceElement ? (this.containerElement = this.referenceElement.cloneNode(!1), this.containerElement.removeAttribute("id"), this.containerElement.setAttribute("data-trix-internal", ""), this.containerElement.style.display = "none", this.referenceElement.parentNode.insertBefore(this.containerElement, this.referenceElement.nextSibling)) : (this.containerElement = T({
        tagName: "div",
        style: {
          display: "none"
        }
      }), document.body.appendChild(this.containerElement));
    }
    removeHiddenContainer() {
      return S(this.containerElement);
    }
    processNode(t) {
      switch (t.nodeType) {
        case Node.TEXT_NODE:
          if (!this.isInsignificantTextNode(t)) return this.appendBlockForTextNode(t), this.processTextNode(t);
          break;
        case Node.ELEMENT_NODE:
          return this.appendBlockForElement(t), this.processElement(t);
      }
    }
    appendBlockForTextNode(t) {
      const e = t.parentNode;
      if (e === this.currentBlockElement && this.isBlockElement(t.previousSibling)) return this.appendStringWithAttributes("\n");
      if (e === this.containerElement || this.isBlockElement(e)) {
        var i;
        const t = this.getBlockAttributes(e),
          n = this.getBlockHTMLAttributes(e);
        ot(t, null === (i = this.currentBlock) || void 0 === i ? void 0 : i.attributes) || (this.currentBlock = this.appendBlockForAttributesWithElement(t, e, n), this.currentBlockElement = e);
      }
    }
    appendBlockForElement(t) {
      const e = this.isBlockElement(t),
        i = C(this.currentBlockElement, t);
      if (e && !this.isBlockElement(t.firstChild)) {
        if (!this.isInsignificantTextNode(t.firstChild) || !this.isBlockElement(t.firstElementChild)) {
          const e = this.getBlockAttributes(t),
            n = this.getBlockHTMLAttributes(t);
          if (t.firstChild) {
            if (i && ot(e, this.currentBlock.attributes)) return this.appendStringWithAttributes("\n");
            this.currentBlock = this.appendBlockForAttributesWithElement(e, t, n), this.currentBlockElement = t;
          }
        }
      } else if (this.currentBlockElement && !i && !e) {
        const e = this.findParentBlockElement(t);
        if (e) return this.appendBlockForElement(e);
        this.currentBlock = this.appendEmptyBlock(), this.currentBlockElement = null;
      }
    }
    findParentBlockElement(t) {
      let {
        parentElement: e
      } = t;
      for (; e && e !== this.containerElement;) {
        if (this.isBlockElement(e) && this.blockElements.includes(e)) return e;
        e = e.parentElement;
      }
      return null;
    }
    processTextNode(t) {
      let e = t.data;
      var i;
      dn(t.parentNode) || (e = Vt(e), vn(null === (i = t.previousSibling) || void 0 === i ? void 0 : i.textContent) && (e = fn(e)));
      return this.appendStringWithAttributes(e, this.getTextAttributes(t.parentNode));
    }
    processElement(t) {
      let e;
      if (P(t)) {
        if (e = un(t, "attachment"), Object.keys(e).length) {
          const i = this.getTextAttributes(t);
          this.appendAttachmentWithAttributes(e, i), t.innerHTML = "";
        }
        return this.processedElements.push(t);
      }
      switch (k(t)) {
        case "br":
          return this.isExtraBR(t) || this.isBlockElement(t.nextSibling) || this.appendStringWithAttributes("\n", this.getTextAttributes(t)), this.processedElements.push(t);
        case "img":
          e = {
            url: t.getAttribute("src"),
            contentType: "image"
          };
          const i = (t => {
            const e = t.getAttribute("width"),
              i = t.getAttribute("height"),
              n = {};
            return e && (n.width = parseInt(e, 10)), i && (n.height = parseInt(i, 10)), n;
          })(t);
          for (const t in i) {
            const n = i[t];
            e[t] = n;
          }
          return this.appendAttachmentWithAttributes(e, this.getTextAttributes(t)), this.processedElements.push(t);
        case "tr":
          if (this.needsTableSeparator(t)) return this.appendStringWithAttributes(j.tableRowSeparator);
          break;
        case "td":
          if (this.needsTableSeparator(t)) return this.appendStringWithAttributes(j.tableCellSeparator);
      }
    }
    appendBlockForAttributesWithElement(t, e) {
      let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      this.blockElements.push(e);
      const n = function () {
        return {
          text: [],
          attributes: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          htmlAttributes: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
        };
      }(t, i);
      return this.blocks.push(n), n;
    }
    appendEmptyBlock() {
      return this.appendBlockForAttributesWithElement([], null);
    }
    appendStringWithAttributes(t, e) {
      return this.appendPiece(cn(t, e));
    }
    appendAttachmentWithAttributes(t, e) {
      return this.appendPiece(function (t) {
        return {
          attachment: t,
          attributes: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          type: "attachment"
        };
      }(t, e));
    }
    appendPiece(t) {
      return 0 === this.blocks.length && this.appendEmptyBlock(), this.blocks[this.blocks.length - 1].text.push(t);
    }
    appendStringToTextAtIndex(t, e) {
      const {
          text: i
        } = this.blocks[e],
        n = i[i.length - 1];
      if ("string" !== (null == n ? void 0 : n.type)) return i.push(cn(t));
      n.string += t;
    }
    prependStringToTextAtIndex(t, e) {
      const {
          text: i
        } = this.blocks[e],
        n = i[0];
      if ("string" !== (null == n ? void 0 : n.type)) return i.unshift(cn(t));
      n.string = t + n.string;
    }
    getTextAttributes(t) {
      let e;
      const i = {};
      for (const n in W) {
        const r = W[n];
        if (r.tagName && y(t, {
          matchingSelector: r.tagName,
          untilNode: this.containerElement
        })) i[n] = !0;else if (r.parser) {
          if (e = r.parser(t), e) {
            let o = !1;
            for (const i of this.findBlockElementAncestors(t)) if (r.parser(i) === e) {
              o = !0;
              break;
            }
            o || (i[n] = e);
          }
        } else r.styleProperty && (e = t.style[r.styleProperty], e && (i[n] = e));
      }
      if (P(t)) {
        const n = un(t, "attributes");
        for (const t in n) e = n[t], i[t] = e;
      }
      return i;
    }
    getBlockAttributes(t) {
      const e = [];
      for (; t && t !== this.containerElement;) {
        for (const r in n) {
          const o = n[r];
          var i;
          if (!1 !== o.parse) if (k(t) === o.tagName) (null !== (i = o.test) && void 0 !== i && i.call(o, t) || !o.test) && (e.push(r), o.listAttribute && e.push(o.listAttribute));
        }
        t = t.parentNode;
      }
      return e.reverse();
    }
    getBlockHTMLAttributes(t) {
      const e = {},
        i = Object.values(n).find(e => e.tagName === k(t));
      return ((null == i ? void 0 : i.htmlAttributes) || []).forEach(i => {
        t.hasAttribute(i) && (e[i] = t.getAttribute(i));
      }), e;
    }
    findBlockElementAncestors(t) {
      const e = [];
      for (; t && t !== this.containerElement;) {
        const i = k(t);
        L().includes(i) && e.push(t), t = t.parentNode;
      }
      return e;
    }
    isBlockElement(t) {
      if ((null == t ? void 0 : t.nodeType) === Node.ELEMENT_NODE && !P(t) && !y(t, {
        matchingSelector: "td",
        untilNode: this.containerElement
      })) return L().includes(k(t)) || "block" === window.getComputedStyle(t).display;
    }
    isInsignificantTextNode(t) {
      if ((null == t ? void 0 : t.nodeType) !== Node.TEXT_NODE) return;
      if (!bn(t.data)) return;
      const {
        parentNode: e,
        previousSibling: i,
        nextSibling: n
      } = t;
      return gn(e.previousSibling) && !this.isBlockElement(e.previousSibling) || dn(e) ? void 0 : !i || this.isBlockElement(i) || !n || this.isBlockElement(n);
    }
    isExtraBR(t) {
      return "br" === k(t) && this.isBlockElement(t.parentNode) && t.parentNode.lastChild === t;
    }
    needsTableSeparator(t) {
      if (j.removeBlankTableCells) {
        var e;
        const i = null === (e = t.previousSibling) || void 0 === e ? void 0 : e.textContent;
        return i && /\S/.test(i);
      }
      return t.previousSibling;
    }
    translateBlockElementMarginsToNewlines() {
      const t = this.getMarginOfDefaultBlockElement();
      for (let e = 0; e < this.blocks.length; e++) {
        const i = this.getMarginOfBlockElementAtIndex(e);
        i && (i.top > 2 * t.top && this.prependStringToTextAtIndex("\n", e), i.bottom > 2 * t.bottom && this.appendStringToTextAtIndex("\n", e));
      }
    }
    getMarginOfBlockElementAtIndex(t) {
      const e = this.blockElements[t];
      if (e && e.textContent && !L().includes(k(e)) && !this.processedElements.includes(e)) return mn(e);
    }
    getMarginOfDefaultBlockElement() {
      const t = T(n.default.tagName);
      return this.containerElement.appendChild(t), mn(t);
    }
  }
  const dn = function (t) {
      const {
        whiteSpace: e
      } = window.getComputedStyle(t);
      return ["pre", "pre-wrap", "pre-line"].includes(e);
    },
    gn = t => t && !vn(t.textContent),
    mn = function (t) {
      const e = window.getComputedStyle(t);
      if ("block" === e.display) return {
        top: parseInt(e.marginTop),
        bottom: parseInt(e.marginBottom)
      };
    },
    pn = function (t) {
      return "style" === k(t) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    },
    fn = t => t.replace(new RegExp("^".concat(Ut.source, "+")), ""),
    bn = t => new RegExp("^".concat(Ut.source, "*$")).test(t),
    vn = t => /\s$/.test(t),
    An = ["contenteditable", "data-trix-id", "data-trix-store-key", "data-trix-mutable", "data-trix-placeholder", "tabindex"],
    yn = "data-trix-serialized-attributes",
    xn = "[".concat(yn, "]"),
    Cn = new RegExp("<!--block-->", "g"),
    En = {
      "application/json": function (t) {
        let e;
        if (t instanceof an) e = t;else {
          if (!(t instanceof HTMLElement)) throw new Error("unserializable object");
          e = hn.parse(t.innerHTML).getDocument();
        }
        return e.toSerializableDocument().toJSONString();
      },
      "text/html": function (t) {
        let e;
        if (t instanceof an) e = Si.render(t);else {
          if (!(t instanceof HTMLElement)) throw new Error("unserializable object");
          e = t.cloneNode(!0);
        }
        return Array.from(e.querySelectorAll("[data-trix-serialize=false]")).forEach(t => {
          S(t);
        }), An.forEach(t => {
          Array.from(e.querySelectorAll("[".concat(t, "]"))).forEach(e => {
            e.removeAttribute(t);
          });
        }), Array.from(e.querySelectorAll(xn)).forEach(t => {
          try {
            const e = JSON.parse(t.getAttribute(yn));
            t.removeAttribute(yn);
            for (const i in e) {
              const n = e[i];
              t.setAttribute(i, n);
            }
          } catch (t) {}
        }), e.innerHTML.replace(Cn, "");
      }
    };
  var Sn = Object.freeze({
    __proto__: null
  });
  class Rn extends q {
    constructor(t, e) {
      super(...arguments), this.attachmentManager = t, this.attachment = e, this.id = this.attachment.id, this.file = this.attachment.file;
    }
    remove() {
      return this.attachmentManager.requestRemovalOfAttachment(this.attachment);
    }
  }
  Rn.proxyMethod("attachment.getAttribute"), Rn.proxyMethod("attachment.hasAttribute"), Rn.proxyMethod("attachment.setAttribute"), Rn.proxyMethod("attachment.getAttributes"), Rn.proxyMethod("attachment.setAttributes"), Rn.proxyMethod("attachment.isPending"), Rn.proxyMethod("attachment.isPreviewable"), Rn.proxyMethod("attachment.getURL"), Rn.proxyMethod("attachment.getHref"), Rn.proxyMethod("attachment.getFilename"), Rn.proxyMethod("attachment.getFilesize"), Rn.proxyMethod("attachment.getFormattedFilesize"), Rn.proxyMethod("attachment.getExtension"), Rn.proxyMethod("attachment.getContentType"), Rn.proxyMethod("attachment.getFile"), Rn.proxyMethod("attachment.setFile"), Rn.proxyMethod("attachment.releaseFile"), Rn.proxyMethod("attachment.getUploadProgress"), Rn.proxyMethod("attachment.setUploadProgress");
  class kn extends q {
    constructor() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      super(...arguments), this.managedAttachments = {}, Array.from(t).forEach(t => {
        this.manageAttachment(t);
      });
    }
    getAttachments() {
      const t = [];
      for (const e in this.managedAttachments) {
        const i = this.managedAttachments[e];
        t.push(i);
      }
      return t;
    }
    manageAttachment(t) {
      return this.managedAttachments[t.id] || (this.managedAttachments[t.id] = new Rn(this, t)), this.managedAttachments[t.id];
    }
    attachmentIsManaged(t) {
      return t.id in this.managedAttachments;
    }
    requestRemovalOfAttachment(t) {
      var e, i;
      if (this.attachmentIsManaged(t)) return null === (e = this.delegate) || void 0 === e || null === (i = e.attachmentManagerDidRequestRemovalOfAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    unmanageAttachment(t) {
      const e = this.managedAttachments[t.id];
      return delete this.managedAttachments[t.id], e;
    }
  }
  class Tn {
    constructor(t) {
      this.composition = t, this.document = this.composition.document;
      const e = this.composition.getSelectedRange();
      this.startPosition = e[0], this.endPosition = e[1], this.startLocation = this.document.locationFromPosition(this.startPosition), this.endLocation = this.document.locationFromPosition(this.endPosition), this.block = this.document.getBlockAtIndex(this.endLocation.index), this.breaksOnReturn = this.block.breaksOnReturn(), this.previousCharacter = this.block.text.getStringAtPosition(this.endLocation.offset - 1), this.nextCharacter = this.block.text.getStringAtPosition(this.endLocation.offset);
    }
    shouldInsertBlockBreak() {
      return this.block.hasAttributes() && this.block.isListItem() && !this.block.isEmpty() ? 0 !== this.startLocation.offset : this.breaksOnReturn && "\n" !== this.nextCharacter;
    }
    shouldBreakFormattedBlock() {
      return this.block.hasAttributes() && !this.block.isListItem() && (this.breaksOnReturn && "\n" === this.nextCharacter || "\n" === this.previousCharacter);
    }
    shouldDecreaseListLevel() {
      return this.block.hasAttributes() && this.block.isListItem() && this.block.isEmpty();
    }
    shouldPrependListItem() {
      return this.block.isListItem() && 0 === this.startLocation.offset && !this.block.isEmpty();
    }
    shouldRemoveLastBlockAttribute() {
      return this.block.hasAttributes() && !this.block.isListItem() && this.block.isEmpty();
    }
  }
  class wn extends q {
    constructor() {
      super(...arguments), this.document = new an(), this.attachments = [], this.currentAttributes = {}, this.revision = 0;
    }
    setDocument(t) {
      var e, i;
      if (!t.isEqualTo(this.document)) return this.document = t, this.refreshAttachments(), this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidChangeDocument) || void 0 === i ? void 0 : i.call(e, t);
    }
    getSnapshot() {
      return {
        document: this.document,
        selectedRange: this.getSelectedRange()
      };
    }
    loadSnapshot(t) {
      var e, i, n, r;
      let {
        document: o,
        selectedRange: s
      } = t;
      return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionWillLoadSnapshot) || void 0 === i || i.call(e), this.setDocument(null != o ? o : new an()), this.setSelection(null != s ? s : [0, 0]), null === (n = this.delegate) || void 0 === n || null === (r = n.compositionDidLoadSnapshot) || void 0 === r ? void 0 : r.call(n);
    }
    insertText(t) {
      let {
        updatePosition: e
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        updatePosition: !0
      };
      const i = this.getSelectedRange();
      this.setDocument(this.document.insertTextAtRange(t, i));
      const n = i[0],
        r = n + t.getLength();
      return e && this.setSelection(r), this.notifyDelegateOfInsertionAtRange([n, r]);
    }
    insertBlock() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Xi();
      const e = new an([t]);
      return this.insertDocument(e);
    }
    insertDocument() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new an();
      const e = this.getSelectedRange();
      this.setDocument(this.document.insertDocumentAtRange(t, e));
      const i = e[0],
        n = i + t.getLength();
      return this.setSelection(n), this.notifyDelegateOfInsertionAtRange([i, n]);
    }
    insertString(t, e) {
      const i = this.getCurrentTextAttributes(),
        n = Yi.textForStringWithAttributes(t, i);
      return this.insertText(n, e);
    }
    insertBlockBreak() {
      const t = this.getSelectedRange();
      this.setDocument(this.document.insertBlockBreakAtRange(t));
      const e = t[0],
        i = e + 1;
      return this.setSelection(i), this.notifyDelegateOfInsertionAtRange([e, i]);
    }
    insertLineBreak() {
      const t = new Tn(this);
      if (t.shouldDecreaseListLevel()) return this.decreaseListLevel(), this.setSelection(t.startPosition);
      if (t.shouldPrependListItem()) {
        const e = new an([t.block.copyWithoutText()]);
        return this.insertDocument(e);
      }
      return t.shouldInsertBlockBreak() ? this.insertBlockBreak() : t.shouldRemoveLastBlockAttribute() ? this.removeLastBlockAttribute() : t.shouldBreakFormattedBlock() ? this.breakFormattedBlock(t) : this.insertString("\n");
    }
    insertHTML(t) {
      const e = hn.parse(t, {
          purifyOptions: {
            SAFE_FOR_XML: !0
          }
        }).getDocument(),
        i = this.getSelectedRange();
      this.setDocument(this.document.mergeDocumentAtRange(e, i));
      const n = i[0],
        r = n + e.getLength() - 1;
      return this.setSelection(r), this.notifyDelegateOfInsertionAtRange([n, r]);
    }
    replaceHTML(t) {
      const e = hn.parse(t).getDocument().copyUsingObjectsFromDocument(this.document),
        i = this.getLocationRange({
          strict: !1
        }),
        n = this.document.rangeFromLocationRange(i);
      return this.setDocument(e), this.setSelection(n);
    }
    insertFile(t) {
      return this.insertFiles([t]);
    }
    insertFiles(t) {
      const e = [];
      return Array.from(t).forEach(t => {
        var i;
        if (null !== (i = this.delegate) && void 0 !== i && i.compositionShouldAcceptFile(t)) {
          const i = Vi.attachmentForFile(t);
          e.push(i);
        }
      }), this.insertAttachments(e);
    }
    insertAttachment(t) {
      return this.insertAttachments([t]);
    }
    insertAttachments(t) {
      let e = new Yi();
      return Array.from(t).forEach(t => {
        var n;
        const r = t.getType(),
          o = null === (n = i[r]) || void 0 === n ? void 0 : n.presentation,
          s = this.getCurrentTextAttributes();
        o && (s.presentation = o);
        const a = Yi.textForAttachmentWithAttributes(t, s);
        e = e.appendText(a);
      }), this.insertText(e);
    }
    shouldManageDeletingInDirection(t) {
      const e = this.getLocationRange();
      if (Lt(e)) {
        if ("backward" === t && 0 === e[0].offset) return !0;
        if (this.shouldManageMovingCursorInDirection(t)) return !0;
      } else if (e[0].index !== e[1].index) return !0;
      return !1;
    }
    deleteInDirection(t) {
      let e,
        i,
        n,
        {
          length: r
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const o = this.getLocationRange();
      let s = this.getSelectedRange();
      const a = Lt(s);
      if (a ? i = "backward" === t && 0 === o[0].offset : n = o[0].index !== o[1].index, i && this.canDecreaseBlockAttributeLevel()) {
        const t = this.getBlock();
        if (t.isListItem() ? this.decreaseListLevel() : this.decreaseBlockAttributeLevel(), this.setSelection(s[0]), t.isEmpty()) return !1;
      }
      return a && (s = this.getExpandedRangeInDirection(t, {
        length: r
      }), "backward" === t && (e = this.getAttachmentAtRange(s))), e ? (this.editAttachment(e), !1) : (this.setDocument(this.document.removeTextAtRange(s)), this.setSelection(s[0]), !i && !n && void 0);
    }
    moveTextFromRange(t) {
      const [e] = Array.from(this.getSelectedRange());
      return this.setDocument(this.document.moveTextFromRangeToPosition(t, e)), this.setSelection(e);
    }
    removeAttachment(t) {
      const e = this.document.getRangeOfAttachment(t);
      if (e) return this.stopEditingAttachment(), this.setDocument(this.document.removeTextAtRange(e)), this.setSelection(e[0]);
    }
    removeLastBlockAttribute() {
      const [t, e] = Array.from(this.getSelectedRange()),
        i = this.document.getBlockAtPosition(e);
      return this.removeCurrentAttribute(i.getLastAttribute()), this.setSelection(t);
    }
    insertPlaceholder() {
      return this.placeholderPosition = this.getPosition(), this.insertString(" ");
    }
    selectPlaceholder() {
      if (null != this.placeholderPosition) return this.setSelectedRange([this.placeholderPosition, this.placeholderPosition + 1]), this.getSelectedRange();
    }
    forgetPlaceholder() {
      this.placeholderPosition = null;
    }
    hasCurrentAttribute(t) {
      const e = this.currentAttributes[t];
      return null != e && !1 !== e;
    }
    toggleCurrentAttribute(t) {
      const e = !this.currentAttributes[t];
      return e ? this.setCurrentAttribute(t, e) : this.removeCurrentAttribute(t);
    }
    canSetCurrentAttribute(t) {
      return mt(t) ? this.canSetCurrentBlockAttribute(t) : this.canSetCurrentTextAttribute(t);
    }
    canSetCurrentTextAttribute(t) {
      const e = this.getSelectedDocument();
      if (e) {
        for (const t of Array.from(e.getAttachments())) if (!t.hasContent()) return !1;
        return !0;
      }
    }
    canSetCurrentBlockAttribute(t) {
      const e = this.getBlock();
      if (e) return !e.isTerminalBlock();
    }
    setCurrentAttribute(t, e) {
      return mt(t) ? this.setBlockAttribute(t, e) : (this.setTextAttribute(t, e), this.currentAttributes[t] = e, this.notifyDelegateOfCurrentAttributesChange());
    }
    setHTMLAtributeAtPosition(t, e, i) {
      var n;
      const r = this.document.getBlockAtPosition(t),
        o = null === (n = mt(r.getLastAttribute())) || void 0 === n ? void 0 : n.htmlAttributes;
      if (r && null != o && o.includes(e)) {
        const n = this.document.setHTMLAttributeAtPosition(t, e, i);
        this.setDocument(n);
      }
    }
    setTextAttribute(t, e) {
      const i = this.getSelectedRange();
      if (!i) return;
      const [n, r] = Array.from(i);
      if (n !== r) return this.setDocument(this.document.addAttributeAtRange(t, e, i));
      if ("href" === t) {
        const t = Yi.textForStringWithAttributes(e, {
          href: e
        });
        return this.insertText(t);
      }
    }
    setBlockAttribute(t, e) {
      const i = this.getSelectedRange();
      if (this.canSetCurrentAttribute(t)) return this.setDocument(this.document.applyBlockAttributeAtRange(t, e, i)), this.setSelection(i);
    }
    removeCurrentAttribute(t) {
      return mt(t) ? (this.removeBlockAttribute(t), this.updateCurrentAttributes()) : (this.removeTextAttribute(t), delete this.currentAttributes[t], this.notifyDelegateOfCurrentAttributesChange());
    }
    removeTextAttribute(t) {
      const e = this.getSelectedRange();
      if (e) return this.setDocument(this.document.removeAttributeAtRange(t, e));
    }
    removeBlockAttribute(t) {
      const e = this.getSelectedRange();
      if (e) return this.setDocument(this.document.removeAttributeAtRange(t, e));
    }
    canDecreaseNestingLevel() {
      var t;
      return (null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getNestingLevel()) > 0;
    }
    canIncreaseNestingLevel() {
      var t;
      const e = this.getBlock();
      if (e) {
        if (null === (t = mt(e.getLastNestableAttribute())) || void 0 === t || !t.listAttribute) return e.getNestingLevel() > 0;
        {
          const t = this.getPreviousBlock();
          if (t) return function () {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return ot((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).slice(0, t.length), t);
          }(t.getListItemAttributes(), e.getListItemAttributes());
        }
      }
    }
    decreaseNestingLevel() {
      const t = this.getBlock();
      if (t) return this.setDocument(this.document.replaceBlock(t, t.decreaseNestingLevel()));
    }
    increaseNestingLevel() {
      const t = this.getBlock();
      if (t) return this.setDocument(this.document.replaceBlock(t, t.increaseNestingLevel()));
    }
    canDecreaseBlockAttributeLevel() {
      var t;
      return (null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getAttributeLevel()) > 0;
    }
    decreaseBlockAttributeLevel() {
      var t;
      const e = null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getLastAttribute();
      if (e) return this.removeCurrentAttribute(e);
    }
    decreaseListLevel() {
      let [t] = Array.from(this.getSelectedRange());
      const {
        index: e
      } = this.document.locationFromPosition(t);
      let i = e;
      const n = this.getBlock().getAttributeLevel();
      let r = this.document.getBlockAtIndex(i + 1);
      for (; r && r.isListItem() && !(r.getAttributeLevel() <= n);) i++, r = this.document.getBlockAtIndex(i + 1);
      t = this.document.positionFromLocation({
        index: e,
        offset: 0
      });
      const o = this.document.positionFromLocation({
        index: i,
        offset: 0
      });
      return this.setDocument(this.document.removeLastListAttributeAtRange([t, o]));
    }
    updateCurrentAttributes() {
      const t = this.getSelectedRange({
        ignoreLock: !0
      });
      if (t) {
        const e = this.document.getCommonAttributesAtRange(t);
        if (Array.from(gt()).forEach(t => {
          e[t] || this.canSetCurrentAttribute(t) || (e[t] = !1);
        }), !Tt(e, this.currentAttributes)) return this.currentAttributes = e, this.notifyDelegateOfCurrentAttributesChange();
      }
    }
    getCurrentAttributes() {
      return m.call({}, this.currentAttributes);
    }
    getCurrentTextAttributes() {
      const t = {};
      for (const e in this.currentAttributes) {
        const i = this.currentAttributes[e];
        !1 !== i && ft(e) && (t[e] = i);
      }
      return t;
    }
    freezeSelection() {
      return this.setCurrentAttribute("frozen", !0);
    }
    thawSelection() {
      return this.removeCurrentAttribute("frozen");
    }
    hasFrozenSelection() {
      return this.hasCurrentAttribute("frozen");
    }
    setSelection(t) {
      var e;
      const i = this.document.locationRangeFromRange(t);
      return null === (e = this.delegate) || void 0 === e ? void 0 : e.compositionDidRequestChangingSelectionToLocationRange(i);
    }
    getSelectedRange() {
      const t = this.getLocationRange();
      if (t) return this.document.rangeFromLocationRange(t);
    }
    setSelectedRange(t) {
      const e = this.document.locationRangeFromRange(t);
      return this.getSelectionManager().setLocationRange(e);
    }
    getPosition() {
      const t = this.getLocationRange();
      if (t) return this.document.positionFromLocation(t[0]);
    }
    getLocationRange(t) {
      return this.targetLocationRange ? this.targetLocationRange : this.getSelectionManager().getLocationRange(t) || wt({
        index: 0,
        offset: 0
      });
    }
    withTargetLocationRange(t, e) {
      let i;
      this.targetLocationRange = t;
      try {
        i = e();
      } finally {
        this.targetLocationRange = null;
      }
      return i;
    }
    withTargetRange(t, e) {
      const i = this.document.locationRangeFromRange(t);
      return this.withTargetLocationRange(i, e);
    }
    withTargetDOMRange(t, e) {
      const i = this.createLocationRangeFromDOMRange(t, {
        strict: !1
      });
      return this.withTargetLocationRange(i, e);
    }
    getExpandedRangeInDirection(t) {
      let {
          length: e
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        [i, n] = Array.from(this.getSelectedRange());
      return "backward" === t ? e ? i -= e : i = this.translateUTF16PositionFromOffset(i, -1) : e ? n += e : n = this.translateUTF16PositionFromOffset(n, 1), wt([i, n]);
    }
    shouldManageMovingCursorInDirection(t) {
      if (this.editingAttachment) return !0;
      const e = this.getExpandedRangeInDirection(t);
      return null != this.getAttachmentAtRange(e);
    }
    moveCursorInDirection(t) {
      let e, i;
      if (this.editingAttachment) i = this.document.getRangeOfAttachment(this.editingAttachment);else {
        const n = this.getSelectedRange();
        i = this.getExpandedRangeInDirection(t), e = !Dt(n, i);
      }
      if ("backward" === t ? this.setSelectedRange(i[0]) : this.setSelectedRange(i[1]), e) {
        const t = this.getAttachmentAtRange(i);
        if (t) return this.editAttachment(t);
      }
    }
    expandSelectionInDirection(t) {
      let {
        length: e
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const i = this.getExpandedRangeInDirection(t, {
        length: e
      });
      return this.setSelectedRange(i);
    }
    expandSelectionForEditing() {
      if (this.hasCurrentAttribute("href")) return this.expandSelectionAroundCommonAttribute("href");
    }
    expandSelectionAroundCommonAttribute(t) {
      const e = this.getPosition(),
        i = this.document.getRangeOfCommonAttributeAtPosition(t, e);
      return this.setSelectedRange(i);
    }
    selectionContainsAttachments() {
      var t;
      return (null === (t = this.getSelectedAttachments()) || void 0 === t ? void 0 : t.length) > 0;
    }
    selectionIsInCursorTarget() {
      return this.editingAttachment || this.positionIsCursorTarget(this.getPosition());
    }
    positionIsCursorTarget(t) {
      const e = this.document.locationFromPosition(t);
      if (e) return this.locationIsCursorTarget(e);
    }
    positionIsBlockBreak(t) {
      var e;
      return null === (e = this.document.getPieceAtPosition(t)) || void 0 === e ? void 0 : e.isBlockBreak();
    }
    getSelectedDocument() {
      const t = this.getSelectedRange();
      if (t) return this.document.getDocumentAtRange(t);
    }
    getSelectedAttachments() {
      var t;
      return null === (t = this.getSelectedDocument()) || void 0 === t ? void 0 : t.getAttachments();
    }
    getAttachments() {
      return this.attachments.slice(0);
    }
    refreshAttachments() {
      const t = this.document.getAttachments(),
        {
          added: e,
          removed: i
        } = function () {
          let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          const i = [],
            n = [],
            r = new Set();
          t.forEach(t => {
            r.add(t);
          });
          const o = new Set();
          return e.forEach(t => {
            o.add(t), r.has(t) || i.push(t);
          }), t.forEach(t => {
            o.has(t) || n.push(t);
          }), {
            added: i,
            removed: n
          };
        }(this.attachments, t);
      return this.attachments = t, Array.from(i).forEach(t => {
        var e, i;
        t.delegate = null, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidRemoveAttachment) || void 0 === i || i.call(e, t);
      }), (() => {
        const t = [];
        return Array.from(e).forEach(e => {
          var i, n;
          e.delegate = this, t.push(null === (i = this.delegate) || void 0 === i || null === (n = i.compositionDidAddAttachment) || void 0 === n ? void 0 : n.call(i, e));
        }), t;
      })();
    }
    attachmentDidChangeAttributes(t) {
      var e, i;
      return this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidEditAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    attachmentDidChangePreviewURL(t) {
      var e, i;
      return this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidChangeAttachmentPreviewURL) || void 0 === i ? void 0 : i.call(e, t);
    }
    editAttachment(t, e) {
      var i, n;
      if (t !== this.editingAttachment) return this.stopEditingAttachment(), this.editingAttachment = t, null === (i = this.delegate) || void 0 === i || null === (n = i.compositionDidStartEditingAttachment) || void 0 === n ? void 0 : n.call(i, this.editingAttachment, e);
    }
    stopEditingAttachment() {
      var t, e;
      this.editingAttachment && (null === (t = this.delegate) || void 0 === t || null === (e = t.compositionDidStopEditingAttachment) || void 0 === e || e.call(t, this.editingAttachment), this.editingAttachment = null);
    }
    updateAttributesForAttachment(t, e) {
      return this.setDocument(this.document.updateAttributesForAttachment(t, e));
    }
    removeAttributeForAttachment(t, e) {
      return this.setDocument(this.document.removeAttributeForAttachment(t, e));
    }
    breakFormattedBlock(t) {
      let {
        document: e
      } = t;
      const {
        block: i
      } = t;
      let n = t.startPosition,
        r = [n - 1, n];
      i.getBlockBreakPosition() === t.startLocation.offset ? (i.breaksOnReturn() && "\n" === t.nextCharacter ? n += 1 : e = e.removeTextAtRange(r), r = [n, n]) : "\n" === t.nextCharacter ? "\n" === t.previousCharacter ? r = [n - 1, n + 1] : (r = [n, n + 1], n += 1) : t.startLocation.offset - 1 != 0 && (n += 1);
      const o = new an([i.removeLastAttribute().copyWithoutText()]);
      return this.setDocument(e.insertDocumentAtRange(o, r)), this.setSelection(n);
    }
    getPreviousBlock() {
      const t = this.getLocationRange();
      if (t) {
        const {
          index: e
        } = t[0];
        if (e > 0) return this.document.getBlockAtIndex(e - 1);
      }
    }
    getBlock() {
      const t = this.getLocationRange();
      if (t) return this.document.getBlockAtIndex(t[0].index);
    }
    getAttachmentAtRange(t) {
      const e = this.document.getDocumentAtRange(t);
      if (e.toString() === "".concat("\uFFFC", "\n")) return e.getAttachments()[0];
    }
    notifyDelegateOfCurrentAttributesChange() {
      var t, e;
      return null === (t = this.delegate) || void 0 === t || null === (e = t.compositionDidChangeCurrentAttributes) || void 0 === e ? void 0 : e.call(t, this.currentAttributes);
    }
    notifyDelegateOfInsertionAtRange(t) {
      var e, i;
      return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidPerformInsertionAtRange) || void 0 === i ? void 0 : i.call(e, t);
    }
    translateUTF16PositionFromOffset(t, e) {
      const i = this.document.toUTF16String(),
        n = i.offsetFromUCS2Offset(t);
      return i.offsetToUCS2Offset(n + e);
    }
  }
  wn.proxyMethod("getSelectionManager().getPointRange"), wn.proxyMethod("getSelectionManager().setLocationRangeFromPointRange"), wn.proxyMethod("getSelectionManager().createLocationRangeFromDOMRange"), wn.proxyMethod("getSelectionManager().locationIsCursorTarget"), wn.proxyMethod("getSelectionManager().selectionIsExpanded"), wn.proxyMethod("delegate?.getSelectionManager");
  class Ln extends q {
    constructor(t) {
      super(...arguments), this.composition = t, this.undoEntries = [], this.redoEntries = [];
    }
    recordUndoEntry(t) {
      let {
        context: e,
        consolidatable: i
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      const n = this.undoEntries.slice(-1)[0];
      if (!i || !Dn(n, t, e)) {
        const i = this.createEntry({
          description: t,
          context: e
        });
        this.undoEntries.push(i), this.redoEntries = [];
      }
    }
    undo() {
      const t = this.undoEntries.pop();
      if (t) {
        const e = this.createEntry(t);
        return this.redoEntries.push(e), this.composition.loadSnapshot(t.snapshot);
      }
    }
    redo() {
      const t = this.redoEntries.pop();
      if (t) {
        const e = this.createEntry(t);
        return this.undoEntries.push(e), this.composition.loadSnapshot(t.snapshot);
      }
    }
    canUndo() {
      return this.undoEntries.length > 0;
    }
    canRedo() {
      return this.redoEntries.length > 0;
    }
    createEntry() {
      let {
        description: t,
        context: e
      } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return {
        description: null == t ? void 0 : t.toString(),
        context: JSON.stringify(e),
        snapshot: this.composition.getSnapshot()
      };
    }
  }
  const Dn = (t, e, i) => (null == t ? void 0 : t.description) === (null == e ? void 0 : e.toString()) && (null == t ? void 0 : t.context) === JSON.stringify(i),
    Nn = "attachmentGallery";
  class In {
    constructor(t) {
      this.document = t.document, this.selectedRange = t.selectedRange;
    }
    perform() {
      return this.removeBlockAttribute(), this.applyBlockAttribute();
    }
    getSnapshot() {
      return {
        document: this.document,
        selectedRange: this.selectedRange
      };
    }
    removeBlockAttribute() {
      return this.findRangesOfBlocks().map(t => this.document = this.document.removeAttributeAtRange(Nn, t));
    }
    applyBlockAttribute() {
      let t = 0;
      this.findRangesOfPieces().forEach(e => {
        e[1] - e[0] > 1 && (e[0] += t, e[1] += t, "\n" !== this.document.getCharacterAtPosition(e[1]) && (this.document = this.document.insertBlockBreakAtRange(e[1]), e[1] < this.selectedRange[1] && this.moveSelectedRangeForward(), e[1]++, t++), 0 !== e[0] && "\n" !== this.document.getCharacterAtPosition(e[0] - 1) && (this.document = this.document.insertBlockBreakAtRange(e[0]), e[0] < this.selectedRange[0] && this.moveSelectedRangeForward(), e[0]++, t++), this.document = this.document.applyBlockAttributeAtRange(Nn, !0, e));
      });
    }
    findRangesOfBlocks() {
      return this.document.findRangesForBlockAttribute(Nn);
    }
    findRangesOfPieces() {
      return this.document.findRangesForTextAttribute("presentation", {
        withValue: "gallery"
      });
    }
    moveSelectedRangeForward() {
      this.selectedRange[0] += 1, this.selectedRange[1] += 1;
    }
  }
  const On = function (t) {
      const e = new In(t);
      return e.perform(), e.getSnapshot();
    },
    Fn = [On];
  class Pn {
    constructor(t, e, i) {
      this.insertFiles = this.insertFiles.bind(this), this.composition = t, this.selectionManager = e, this.element = i, this.undoManager = new Ln(this.composition), this.filters = Fn.slice(0);
    }
    loadDocument(t) {
      return this.loadSnapshot({
        document: t,
        selectedRange: [0, 0]
      });
    }
    loadHTML() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
      const e = hn.parse(t, {
        referenceElement: this.element
      }).getDocument();
      return this.loadDocument(e);
    }
    loadJSON(t) {
      let {
        document: e,
        selectedRange: i
      } = t;
      return e = an.fromJSON(e), this.loadSnapshot({
        document: e,
        selectedRange: i
      });
    }
    loadSnapshot(t) {
      return this.undoManager = new Ln(this.composition), this.composition.loadSnapshot(t);
    }
    getDocument() {
      return this.composition.document;
    }
    getSelectedDocument() {
      return this.composition.getSelectedDocument();
    }
    getSnapshot() {
      return this.composition.getSnapshot();
    }
    toJSON() {
      return this.getSnapshot();
    }
    deleteInDirection(t) {
      return this.composition.deleteInDirection(t);
    }
    insertAttachment(t) {
      return this.composition.insertAttachment(t);
    }
    insertAttachments(t) {
      return this.composition.insertAttachments(t);
    }
    insertDocument(t) {
      return this.composition.insertDocument(t);
    }
    insertFile(t) {
      return this.composition.insertFile(t);
    }
    insertFiles(t) {
      return this.composition.insertFiles(t);
    }
    insertHTML(t) {
      return this.composition.insertHTML(t);
    }
    insertString(t) {
      return this.composition.insertString(t);
    }
    insertText(t) {
      return this.composition.insertText(t);
    }
    insertLineBreak() {
      return this.composition.insertLineBreak();
    }
    getSelectedRange() {
      return this.composition.getSelectedRange();
    }
    getPosition() {
      return this.composition.getPosition();
    }
    getClientRectAtPosition(t) {
      const e = this.getDocument().locationRangeFromRange([t, t + 1]);
      return this.selectionManager.getClientRectAtLocationRange(e);
    }
    expandSelectionInDirection(t) {
      return this.composition.expandSelectionInDirection(t);
    }
    moveCursorInDirection(t) {
      return this.composition.moveCursorInDirection(t);
    }
    setSelectedRange(t) {
      return this.composition.setSelectedRange(t);
    }
    activateAttribute(t) {
      let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return this.composition.setCurrentAttribute(t, e);
    }
    attributeIsActive(t) {
      return this.composition.hasCurrentAttribute(t);
    }
    canActivateAttribute(t) {
      return this.composition.canSetCurrentAttribute(t);
    }
    deactivateAttribute(t) {
      return this.composition.removeCurrentAttribute(t);
    }
    setHTMLAtributeAtPosition(t, e, i) {
      this.composition.setHTMLAtributeAtPosition(t, e, i);
    }
    canDecreaseNestingLevel() {
      return this.composition.canDecreaseNestingLevel();
    }
    canIncreaseNestingLevel() {
      return this.composition.canIncreaseNestingLevel();
    }
    decreaseNestingLevel() {
      if (this.canDecreaseNestingLevel()) return this.composition.decreaseNestingLevel();
    }
    increaseNestingLevel() {
      if (this.canIncreaseNestingLevel()) return this.composition.increaseNestingLevel();
    }
    canRedo() {
      return this.undoManager.canRedo();
    }
    canUndo() {
      return this.undoManager.canUndo();
    }
    recordUndoEntry(t) {
      let {
        context: e,
        consolidatable: i
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.undoManager.recordUndoEntry(t, {
        context: e,
        consolidatable: i
      });
    }
    redo() {
      if (this.canRedo()) return this.undoManager.redo();
    }
    undo() {
      if (this.canUndo()) return this.undoManager.undo();
    }
  }
  class Mn {
    constructor(t) {
      this.element = t;
    }
    findLocationFromContainerAndOffset(t, e) {
      let {
          strict: i
        } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          strict: !0
        },
        n = 0,
        r = !1;
      const o = {
          index: 0,
          offset: 0
        },
        s = this.findAttachmentElementParentForNode(t);
      s && (t = s.parentNode, e = E(s));
      const a = R(this.element, {
        usingFilter: Wn
      });
      for (; a.nextNode();) {
        const s = a.currentNode;
        if (s === t && B(t)) {
          F(s) || (o.offset += e);
          break;
        }
        if (s.parentNode === t) {
          if (n++ === e) break;
        } else if (!C(t, s) && n > 0) break;
        N(s, {
          strict: i
        }) ? (r && o.index++, o.offset = 0, r = !0) : o.offset += Bn(s);
      }
      return o;
    }
    findContainerAndOffsetFromLocation(t) {
      let e, i;
      if (0 === t.index && 0 === t.offset) {
        for (e = this.element, i = 0; e.firstChild;) if (e = e.firstChild, D(e)) {
          i = 1;
          break;
        }
        return [e, i];
      }
      let [n, r] = this.findNodeAndOffsetFromLocation(t);
      if (n) {
        if (B(n)) 0 === Bn(n) ? (e = n.parentNode.parentNode, i = E(n.parentNode), F(n, {
          name: "right"
        }) && i++) : (e = n, i = t.offset - r);else {
          if (e = n.parentNode, !N(n.previousSibling) && !D(e)) for (; n === e.lastChild && (n = e, e = e.parentNode, !D(e)););
          i = E(n), 0 !== t.offset && i++;
        }
        return [e, i];
      }
    }
    findNodeAndOffsetFromLocation(t) {
      let e,
        i,
        n = 0;
      for (const r of this.getSignificantNodesForIndex(t.index)) {
        const o = Bn(r);
        if (t.offset <= n + o) if (B(r)) {
          if (e = r, i = n, t.offset === i && F(e)) break;
        } else e || (e = r, i = n);
        if (n += o, n > t.offset) break;
      }
      return [e, i];
    }
    findAttachmentElementParentForNode(t) {
      for (; t && t !== this.element;) {
        if (P(t)) return t;
        t = t.parentNode;
      }
    }
    getSignificantNodesForIndex(t) {
      const e = [],
        i = R(this.element, {
          usingFilter: _n
        });
      let n = !1;
      for (; i.nextNode();) {
        const o = i.currentNode;
        var r;
        if (I(o)) {
          if (null != r ? r++ : r = 0, r === t) n = !0;else if (n) break;
        } else n && e.push(o);
      }
      return e;
    }
  }
  const Bn = function (t) {
      if (t.nodeType === Node.TEXT_NODE) {
        if (F(t)) return 0;
        return t.textContent.length;
      }
      return "br" === k(t) || P(t) ? 1 : 0;
    },
    _n = function (t) {
      return jn(t) === NodeFilter.FILTER_ACCEPT ? Wn(t) : NodeFilter.FILTER_REJECT;
    },
    jn = function (t) {
      return M(t) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    },
    Wn = function (t) {
      return P(t.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
  class Un {
    createDOMRangeFromPoint(t) {
      let e,
        {
          x: i,
          y: n
        } = t;
      if (document.caretPositionFromPoint) {
        const {
          offsetNode: t,
          offset: r
        } = document.caretPositionFromPoint(i, n);
        return e = document.createRange(), e.setStart(t, r), e;
      }
      if (document.caretRangeFromPoint) return document.caretRangeFromPoint(i, n);
      if (document.body.createTextRange) {
        const t = Mt();
        try {
          const t = document.body.createTextRange();
          t.moveToPoint(i, n), t.select();
        } catch (t) {}
        return e = Mt(), Bt(t), e;
      }
    }
    getClientRectsForDOMRange(t) {
      const e = Array.from(t.getClientRects());
      return [e[0], e[e.length - 1]];
    }
  }
  class Vn extends q {
    constructor(t) {
      super(...arguments), this.didMouseDown = this.didMouseDown.bind(this), this.selectionDidChange = this.selectionDidChange.bind(this), this.element = t, this.locationMapper = new Mn(this.element), this.pointMapper = new Un(), this.lockCount = 0, b("mousedown", {
        onElement: this.element,
        withCallback: this.didMouseDown
      });
    }
    getLocationRange() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return !1 === t.strict ? this.createLocationRangeFromDOMRange(Mt()) : t.ignoreLock ? this.currentLocationRange : this.lockedLocationRange ? this.lockedLocationRange : this.currentLocationRange;
    }
    setLocationRange(t) {
      if (this.lockedLocationRange) return;
      t = wt(t);
      const e = this.createDOMRangeFromLocationRange(t);
      e && (Bt(e), this.updateCurrentLocationRange(t));
    }
    setLocationRangeFromPointRange(t) {
      t = wt(t);
      const e = this.getLocationAtPoint(t[0]),
        i = this.getLocationAtPoint(t[1]);
      this.setLocationRange([e, i]);
    }
    getClientRectAtLocationRange(t) {
      const e = this.createDOMRangeFromLocationRange(t);
      if (e) return this.getClientRectsForDOMRange(e)[1];
    }
    locationIsCursorTarget(t) {
      const e = Array.from(this.findNodeAndOffsetFromLocation(t))[0];
      return F(e);
    }
    lock() {
      0 == this.lockCount++ && (this.updateCurrentLocationRange(), this.lockedLocationRange = this.getLocationRange());
    }
    unlock() {
      if (0 == --this.lockCount) {
        const {
          lockedLocationRange: t
        } = this;
        if (this.lockedLocationRange = null, null != t) return this.setLocationRange(t);
      }
    }
    clearSelection() {
      var t;
      return null === (t = Pt()) || void 0 === t ? void 0 : t.removeAllRanges();
    }
    selectionIsCollapsed() {
      var t;
      return !0 === (null === (t = Mt()) || void 0 === t ? void 0 : t.collapsed);
    }
    selectionIsExpanded() {
      return !this.selectionIsCollapsed();
    }
    createLocationRangeFromDOMRange(t, e) {
      if (null == t || !this.domRangeWithinElement(t)) return;
      const i = this.findLocationFromContainerAndOffset(t.startContainer, t.startOffset, e);
      if (!i) return;
      const n = t.collapsed ? void 0 : this.findLocationFromContainerAndOffset(t.endContainer, t.endOffset, e);
      return wt([i, n]);
    }
    didMouseDown() {
      return this.pauseTemporarily();
    }
    pauseTemporarily() {
      let t;
      this.paused = !0;
      const e = () => {
          if (this.paused = !1, clearTimeout(i), Array.from(t).forEach(t => {
            t.destroy();
          }), C(document, this.element)) return this.selectionDidChange();
        },
        i = setTimeout(e, 200);
      t = ["mousemove", "keydown"].map(t => b(t, {
        onElement: document,
        withCallback: e
      }));
    }
    selectionDidChange() {
      if (!this.paused && !x(this.element)) return this.updateCurrentLocationRange();
    }
    updateCurrentLocationRange(t) {
      var e, i;
      if ((null != t ? t : t = this.createLocationRangeFromDOMRange(Mt())) && !Dt(t, this.currentLocationRange)) return this.currentLocationRange = t, null === (e = this.delegate) || void 0 === e || null === (i = e.locationRangeDidChange) || void 0 === i ? void 0 : i.call(e, this.currentLocationRange.slice(0));
    }
    createDOMRangeFromLocationRange(t) {
      const e = this.findContainerAndOffsetFromLocation(t[0]),
        i = Lt(t) ? e : this.findContainerAndOffsetFromLocation(t[1]) || e;
      if (null != e && null != i) {
        const t = document.createRange();
        return t.setStart(...Array.from(e || [])), t.setEnd(...Array.from(i || [])), t;
      }
    }
    getLocationAtPoint(t) {
      const e = this.createDOMRangeFromPoint(t);
      var i;
      if (e) return null === (i = this.createLocationRangeFromDOMRange(e)) || void 0 === i ? void 0 : i[0];
    }
    domRangeWithinElement(t) {
      return t.collapsed ? C(this.element, t.startContainer) : C(this.element, t.startContainer) && C(this.element, t.endContainer);
    }
  }
  Vn.proxyMethod("locationMapper.findLocationFromContainerAndOffset"), Vn.proxyMethod("locationMapper.findContainerAndOffsetFromLocation"), Vn.proxyMethod("locationMapper.findNodeAndOffsetFromLocation"), Vn.proxyMethod("pointMapper.createDOMRangeFromPoint"), Vn.proxyMethod("pointMapper.getClientRectsForDOMRange");
  var zn = Object.freeze({
      __proto__: null,
      Attachment: Vi,
      AttachmentManager: kn,
      AttachmentPiece: zi,
      Block: Xi,
      Composition: wn,
      Document: an,
      Editor: Pn,
      HTMLParser: hn,
      HTMLSanitizer: di,
      LineBreakInsertion: Tn,
      LocationMapper: Mn,
      ManagedAttachment: Rn,
      Piece: Wi,
      PointMapper: Un,
      SelectionManager: Vn,
      SplittableList: Hi,
      StringPiece: qi,
      Text: Yi,
      UndoManager: Ln
    }),
    qn = Object.freeze({
      __proto__: null,
      ObjectView: ie,
      AttachmentView: pi,
      BlockView: Ei,
      DocumentView: Si,
      PieceView: Ai,
      PreviewableAttachmentView: vi,
      TextView: yi
    });
  const {
      lang: Hn,
      css: Jn,
      keyNames: Kn
    } = z,
    Gn = function (t) {
      return function () {
        const e = t.apply(this || _global, arguments);
        e.do(), (this || _global).undos || ((this || _global).undos = []), (this || _global).undos.push(e.undo);
      };
    };
  class Yn extends q {
    constructor(t, e, i) {
      let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      super(...arguments), Di(this, "makeElementMutable", Gn(() => ({
        do: () => {
          this.element.dataset.trixMutable = !0;
        },
        undo: () => delete this.element.dataset.trixMutable
      }))), Di(this, "addToolbar", Gn(() => {
        const t = T({
          tagName: "div",
          className: Jn.attachmentToolbar,
          data: {
            trixMutable: !0
          },
          childNodes: T({
            tagName: "div",
            className: "trix-button-row",
            childNodes: T({
              tagName: "span",
              className: "trix-button-group trix-button-group--actions",
              childNodes: T({
                tagName: "button",
                className: "trix-button trix-button--remove",
                textContent: Hn.remove,
                attributes: {
                  title: Hn.remove
                },
                data: {
                  trixAction: "remove"
                }
              })
            })
          })
        });
        return this.attachment.isPreviewable() && t.appendChild(T({
          tagName: "div",
          className: Jn.attachmentMetadataContainer,
          childNodes: T({
            tagName: "span",
            className: Jn.attachmentMetadata,
            childNodes: [T({
              tagName: "span",
              className: Jn.attachmentName,
              textContent: this.attachment.getFilename(),
              attributes: {
                title: this.attachment.getFilename()
              }
            }), T({
              tagName: "span",
              className: Jn.attachmentSize,
              textContent: this.attachment.getFormattedFilesize()
            })]
          })
        })), b("click", {
          onElement: t,
          withCallback: this.didClickToolbar
        }), b("click", {
          onElement: t,
          matchingSelector: "[data-trix-action]",
          withCallback: this.didClickActionButton
        }), v("trix-attachment-before-toolbar", {
          onElement: this.element,
          attributes: {
            toolbar: t,
            attachment: this.attachment
          }
        }), {
          do: () => this.element.appendChild(t),
          undo: () => S(t)
        };
      })), Di(this, "installCaptionEditor", Gn(() => {
        const t = T({
          tagName: "textarea",
          className: Jn.attachmentCaptionEditor,
          attributes: {
            placeholder: Hn.captionPlaceholder
          },
          data: {
            trixMutable: !0
          }
        });
        t.value = this.attachmentPiece.getCaption();
        const e = t.cloneNode();
        e.classList.add("trix-autoresize-clone"), e.tabIndex = -1;
        const i = function () {
          e.value = t.value, t.style.height = e.scrollHeight + "px";
        };
        b("input", {
          onElement: t,
          withCallback: i
        }), b("input", {
          onElement: t,
          withCallback: this.didInputCaption
        }), b("keydown", {
          onElement: t,
          withCallback: this.didKeyDownCaption
        }), b("change", {
          onElement: t,
          withCallback: this.didChangeCaption
        }), b("blur", {
          onElement: t,
          withCallback: this.didBlurCaption
        });
        const n = this.element.querySelector("figcaption"),
          r = n.cloneNode();
        return {
          do: () => {
            if (n.style.display = "none", r.appendChild(t), r.appendChild(e), r.classList.add("".concat(Jn.attachmentCaption, "--editing")), n.parentElement.insertBefore(r, n), i(), this.options.editCaption) return Rt(() => t.focus());
          },
          undo() {
            S(r), n.style.display = null;
          }
        };
      })), this.didClickToolbar = this.didClickToolbar.bind(this), this.didClickActionButton = this.didClickActionButton.bind(this), this.didKeyDownCaption = this.didKeyDownCaption.bind(this), this.didInputCaption = this.didInputCaption.bind(this), this.didChangeCaption = this.didChangeCaption.bind(this), this.didBlurCaption = this.didBlurCaption.bind(this), this.attachmentPiece = t, this.element = e, this.container = i, this.options = n, this.attachment = this.attachmentPiece.attachment, "a" === k(this.element) && (this.element = this.element.firstChild), this.install();
    }
    install() {
      this.makeElementMutable(), this.addToolbar(), this.attachment.isPreviewable() && this.installCaptionEditor();
    }
    uninstall() {
      var t;
      let e = this.undos.pop();
      for (this.savePendingCaption(); e;) e(), e = this.undos.pop();
      null === (t = this.delegate) || void 0 === t || t.didUninstallAttachmentEditor(this);
    }
    savePendingCaption() {
      if (null != this.pendingCaption) {
        const r = this.pendingCaption;
        var t, e, i, n;
        if (this.pendingCaption = null, r) null === (t = this.delegate) || void 0 === t || null === (e = t.attachmentEditorDidRequestUpdatingAttributesForAttachment) || void 0 === e || e.call(t, {
          caption: r
        }, this.attachment);else null === (i = this.delegate) || void 0 === i || null === (n = i.attachmentEditorDidRequestRemovingAttributeForAttachment) || void 0 === n || n.call(i, "caption", this.attachment);
      }
    }
    didClickToolbar(t) {
      return t.preventDefault(), t.stopPropagation();
    }
    didClickActionButton(t) {
      var e;
      if ("remove" === t.target.getAttribute("data-trix-action")) return null === (e = this.delegate) || void 0 === e ? void 0 : e.attachmentEditorDidRequestRemovalOfAttachment(this.attachment);
    }
    didKeyDownCaption(t) {
      var e, i;
      if ("return" === Kn[t.keyCode]) return t.preventDefault(), this.savePendingCaption(), null === (e = this.delegate) || void 0 === e || null === (i = e.attachmentEditorDidRequestDeselectingAttachment) || void 0 === i ? void 0 : i.call(e, this.attachment);
    }
    didInputCaption(t) {
      this.pendingCaption = t.target.value.replace(/\s/g, " ").trim();
    }
    didChangeCaption(t) {
      return this.savePendingCaption();
    }
    didBlurCaption(t) {
      return this.savePendingCaption();
    }
  }
  class Xn extends q {
    constructor(t, i) {
      super(...arguments), this.didFocus = this.didFocus.bind(this), this.didBlur = this.didBlur.bind(this), this.didClickAttachment = this.didClickAttachment.bind(this), this.element = t, this.composition = i, this.documentView = new Si(this.composition.document, {
        element: this.element
      }), b("focus", {
        onElement: this.element,
        withCallback: this.didFocus
      }), b("blur", {
        onElement: this.element,
        withCallback: this.didBlur
      }), b("click", {
        onElement: this.element,
        matchingSelector: "a[contenteditable=false]",
        preventDefault: !0
      }), b("mousedown", {
        onElement: this.element,
        matchingSelector: e,
        withCallback: this.didClickAttachment
      }), b("click", {
        onElement: this.element,
        matchingSelector: "a".concat(e),
        preventDefault: !0
      });
    }
    didFocus(t) {
      var e;
      const i = () => {
        var t, e;
        if (!this.focused) return this.focused = !0, null === (t = this.delegate) || void 0 === t || null === (e = t.compositionControllerDidFocus) || void 0 === e ? void 0 : e.call(t);
      };
      return (null === (e = this.blurPromise) || void 0 === e ? void 0 : e.then(i)) || i();
    }
    didBlur(t) {
      this.blurPromise = new Promise(t => Rt(() => {
        var e, i;
        x(this.element) || (this.focused = null, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidBlur) || void 0 === i || i.call(e));
        return this.blurPromise = null, t();
      }));
    }
    didClickAttachment(t, e) {
      var i, n;
      const r = this.findAttachmentForElement(e),
        o = !!y(t.target, {
          matchingSelector: "figcaption"
        });
      return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerDidSelectAttachment) || void 0 === n ? void 0 : n.call(i, r, {
        editCaption: o
      });
    }
    getSerializableElement() {
      return this.isEditingAttachment() ? this.documentView.shadowElement : this.element;
    }
    render() {
      var t, e, i, n, r, o;
      (this.revision !== this.composition.revision && (this.documentView.setDocument(this.composition.document), this.documentView.render(), this.revision = this.composition.revision), this.canSyncDocumentView() && !this.documentView.isSynced()) && (null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillSyncDocumentView) || void 0 === n || n.call(i), this.documentView.sync(), null === (r = this.delegate) || void 0 === r || null === (o = r.compositionControllerDidSyncDocumentView) || void 0 === o || o.call(r));
      return null === (t = this.delegate) || void 0 === t || null === (e = t.compositionControllerDidRender) || void 0 === e ? void 0 : e.call(t);
    }
    rerenderViewForObject(t) {
      return this.invalidateViewForObject(t), this.render();
    }
    invalidateViewForObject(t) {
      return this.documentView.invalidateViewForObject(t);
    }
    isViewCachingEnabled() {
      return this.documentView.isViewCachingEnabled();
    }
    enableViewCaching() {
      return this.documentView.enableViewCaching();
    }
    disableViewCaching() {
      return this.documentView.disableViewCaching();
    }
    refreshViewCache() {
      return this.documentView.garbageCollectCachedViews();
    }
    isEditingAttachment() {
      return !!this.attachmentEditor;
    }
    installAttachmentEditorForAttachment(t, e) {
      var i;
      if ((null === (i = this.attachmentEditor) || void 0 === i ? void 0 : i.attachment) === t) return;
      const n = this.documentView.findElementForObject(t);
      if (!n) return;
      this.uninstallAttachmentEditor();
      const r = this.composition.document.getAttachmentPieceForAttachment(t);
      this.attachmentEditor = new Yn(r, n, this.element, e), this.attachmentEditor.delegate = this;
    }
    uninstallAttachmentEditor() {
      var t;
      return null === (t = this.attachmentEditor) || void 0 === t ? void 0 : t.uninstall();
    }
    didUninstallAttachmentEditor() {
      return this.attachmentEditor = null, this.render();
    }
    attachmentEditorDidRequestUpdatingAttributesForAttachment(t, e) {
      var i, n;
      return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillUpdateAttachment) || void 0 === n || n.call(i, e), this.composition.updateAttributesForAttachment(t, e);
    }
    attachmentEditorDidRequestRemovingAttributeForAttachment(t, e) {
      var i, n;
      return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillUpdateAttachment) || void 0 === n || n.call(i, e), this.composition.removeAttributeForAttachment(t, e);
    }
    attachmentEditorDidRequestRemovalOfAttachment(t) {
      var e, i;
      return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidRequestRemovalOfAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    attachmentEditorDidRequestDeselectingAttachment(t) {
      var e, i;
      return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidRequestDeselectingAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    canSyncDocumentView() {
      return !this.isEditingAttachment();
    }
    findAttachmentForElement(t) {
      return this.composition.document.getAttachmentById(parseInt(t.dataset.trixId, 10));
    }
  }
  class $n extends q {}
  const Zn = "data-trix-mutable",
    Qn = "[".concat(Zn, "]"),
    tr = {
      attributes: !0,
      childList: !0,
      characterData: !0,
      characterDataOldValue: !0,
      subtree: !0
    };
  class er extends q {
    constructor(t) {
      super(t), this.didMutate = this.didMutate.bind(this), this.element = t, this.observer = new window.MutationObserver(this.didMutate), this.start();
    }
    start() {
      return this.reset(), this.observer.observe(this.element, tr);
    }
    stop() {
      return this.observer.disconnect();
    }
    didMutate(t) {
      var e, i;
      if (this.mutations.push(...Array.from(this.findSignificantMutations(t) || [])), this.mutations.length) return null === (e = this.delegate) || void 0 === e || null === (i = e.elementDidMutate) || void 0 === i || i.call(e, this.getMutationSummary()), this.reset();
    }
    reset() {
      this.mutations = [];
    }
    findSignificantMutations(t) {
      return t.filter(t => this.mutationIsSignificant(t));
    }
    mutationIsSignificant(t) {
      if (this.nodeIsMutable(t.target)) return !1;
      for (const e of Array.from(this.nodesModifiedByMutation(t))) if (this.nodeIsSignificant(e)) return !0;
      return !1;
    }
    nodeIsSignificant(t) {
      return t !== this.element && !this.nodeIsMutable(t) && !M(t);
    }
    nodeIsMutable(t) {
      return y(t, {
        matchingSelector: Qn
      });
    }
    nodesModifiedByMutation(t) {
      const e = [];
      switch (t.type) {
        case "attributes":
          t.attributeName !== Zn && e.push(t.target);
          break;
        case "characterData":
          e.push(t.target.parentNode), e.push(t.target);
          break;
        case "childList":
          e.push(...Array.from(t.addedNodes || [])), e.push(...Array.from(t.removedNodes || []));
      }
      return e;
    }
    getMutationSummary() {
      return this.getTextMutationSummary();
    }
    getTextMutationSummary() {
      const {
          additions: t,
          deletions: e
        } = this.getTextChangesFromCharacterData(),
        i = this.getTextChangesFromChildList();
      Array.from(i.additions).forEach(e => {
        Array.from(t).includes(e) || t.push(e);
      }), e.push(...Array.from(i.deletions || []));
      const n = {},
        r = t.join("");
      r && (n.textAdded = r);
      const o = e.join("");
      return o && (n.textDeleted = o), n;
    }
    getMutationsByType(t) {
      return Array.from(this.mutations).filter(e => e.type === t);
    }
    getTextChangesFromChildList() {
      let t, e;
      const i = [],
        n = [];
      Array.from(this.getMutationsByType("childList")).forEach(t => {
        i.push(...Array.from(t.addedNodes || [])), n.push(...Array.from(t.removedNodes || []));
      });
      0 === i.length && 1 === n.length && I(n[0]) ? (t = [], e = ["\n"]) : (t = ir(i), e = ir(n));
      const r = t.filter((t, i) => t !== e[i]).map(Wt),
        o = e.filter((e, i) => e !== t[i]).map(Wt);
      return {
        additions: r,
        deletions: o
      };
    }
    getTextChangesFromCharacterData() {
      let t, e;
      const i = this.getMutationsByType("characterData");
      if (i.length) {
        const n = i[0],
          r = i[i.length - 1],
          o = function (t, e) {
            let i, n;
            return t = $.box(t), (e = $.box(e)).length < t.length ? [n, i] = zt(t, e) : [i, n] = zt(e, t), {
              added: i,
              removed: n
            };
          }(Wt(n.oldValue), Wt(r.target.data));
        t = o.added, e = o.removed;
      }
      return {
        additions: t ? [t] : [],
        deletions: e ? [e] : []
      };
    }
  }
  const ir = function () {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    const e = [];
    for (const i of Array.from(t)) switch (i.nodeType) {
      case Node.TEXT_NODE:
        e.push(i.data);
        break;
      case Node.ELEMENT_NODE:
        "br" === k(i) ? e.push("\n") : e.push(...Array.from(ir(i.childNodes) || []));
    }
    return e;
  };
  class nr extends ee {
    constructor(t) {
      super(...arguments), this.file = t;
    }
    perform(t) {
      const e = new FileReader();
      return e.onerror = () => t(!1), e.onload = () => {
        e.onerror = null;
        try {
          e.abort();
        } catch (t) {}
        return t(!0, this.file);
      }, e.readAsArrayBuffer(this.file);
    }
  }
  class rr {
    constructor(t) {
      this.element = t;
    }
    shouldIgnore(t) {
      return !!a.samsungAndroid && (this.previousEvent = this.event, this.event = t, this.checkSamsungKeyboardBuggyModeStart(), this.checkSamsungKeyboardBuggyModeEnd(), this.buggyMode);
    }
    checkSamsungKeyboardBuggyModeStart() {
      this.insertingLongTextAfterUnidentifiedChar() && or(this.element.innerText, this.event.data) && (this.buggyMode = !0, this.event.preventDefault());
    }
    checkSamsungKeyboardBuggyModeEnd() {
      this.buggyMode && "insertText" !== this.event.inputType && (this.buggyMode = !1);
    }
    insertingLongTextAfterUnidentifiedChar() {
      var t;
      return this.isBeforeInputInsertText() && this.previousEventWasUnidentifiedKeydown() && (null === (t = this.event.data) || void 0 === t ? void 0 : t.length) > 50;
    }
    isBeforeInputInsertText() {
      return "beforeinput" === this.event.type && "insertText" === this.event.inputType;
    }
    previousEventWasUnidentifiedKeydown() {
      var t, e;
      return "keydown" === (null === (t = this.previousEvent) || void 0 === t ? void 0 : t.type) && "Unidentified" === (null === (e = this.previousEvent) || void 0 === e ? void 0 : e.key);
    }
  }
  const or = (t, e) => ar(t) === ar(e),
    sr = new RegExp("(".concat("\uFFFC", "|").concat(d, "|").concat(g, "|\\s)+"), "g"),
    ar = t => t.replace(sr, " ").trim();
  class lr extends q {
    constructor(t) {
      super(...arguments), this.element = t, this.mutationObserver = new er(this.element), this.mutationObserver.delegate = this, this.flakyKeyboardDetector = new rr(this.element);
      for (const t in this.constructor.events) b(t, {
        onElement: this.element,
        withCallback: this.handlerFor(t)
      });
    }
    elementDidMutate(t) {}
    editorWillSyncDocumentView() {
      return this.mutationObserver.stop();
    }
    editorDidSyncDocumentView() {
      return this.mutationObserver.start();
    }
    requestRender() {
      var t, e;
      return null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidRequestRender) || void 0 === e ? void 0 : e.call(t);
    }
    requestReparse() {
      var t, e;
      return null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidRequestReparse) || void 0 === e || e.call(t), this.requestRender();
    }
    attachFiles(t) {
      const e = Array.from(t).map(t => new nr(t));
      return Promise.all(e).then(t => {
        this.handleInput(function () {
          var e, i;
          return null === (e = this.delegate) || void 0 === e || e.inputControllerWillAttachFiles(), null === (i = this.responder) || void 0 === i || i.insertFiles(t), this.requestRender();
        });
      });
    }
    handlerFor(t) {
      return e => {
        e.defaultPrevented || this.handleInput(() => {
          if (!x(this.element)) {
            if (this.flakyKeyboardDetector.shouldIgnore(e)) return;
            this.eventName = t, this.constructor.events[t].call(this, e);
          }
        });
      };
    }
    handleInput(t) {
      try {
        var e;
        null === (e = this.delegate) || void 0 === e || e.inputControllerWillHandleInput(), t.call(this);
      } finally {
        var i;
        null === (i = this.delegate) || void 0 === i || i.inputControllerDidHandleInput();
      }
    }
    createLinkHTML(t, e) {
      const i = document.createElement("a");
      return i.href = t, i.textContent = e || t, i.outerHTML;
    }
  }
  var cr;
  Di(lr, "events", {});
  const {
    browser: ur,
    keyNames: hr
  } = z;
  let dr = 0;
  class gr extends lr {
    constructor() {
      super(...arguments), this.resetInputSummary();
    }
    setInputSummary() {
      let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      this.inputSummary.eventName = this.eventName;
      for (const e in t) {
        const i = t[e];
        this.inputSummary[e] = i;
      }
      return this.inputSummary;
    }
    resetInputSummary() {
      this.inputSummary = {};
    }
    reset() {
      return this.resetInputSummary(), Ft.reset();
    }
    elementDidMutate(t) {
      var e, i;
      return this.isComposing() ? null === (e = this.delegate) || void 0 === e || null === (i = e.inputControllerDidAllowUnhandledInput) || void 0 === i ? void 0 : i.call(e) : this.handleInput(function () {
        return this.mutationIsSignificant(t) && (this.mutationIsExpected(t) ? this.requestRender() : this.requestReparse()), this.reset();
      });
    }
    mutationIsExpected(t) {
      let {
        textAdded: e,
        textDeleted: i
      } = t;
      if (this.inputSummary.preferDocument) return !0;
      const n = null != e ? e === this.inputSummary.textAdded : !this.inputSummary.textAdded,
        r = null != i ? this.inputSummary.didDelete : !this.inputSummary.didDelete,
        o = ["\n", " \n"].includes(e) && !n,
        s = "\n" === i && !r;
      if (o && !s || s && !o) {
        const t = this.getSelectedRange();
        if (t) {
          var a;
          const i = o ? e.replace(/\n$/, "").length || -1 : (null == e ? void 0 : e.length) || 1;
          if (null !== (a = this.responder) && void 0 !== a && a.positionIsBlockBreak(t[1] + i)) return !0;
        }
      }
      return n && r;
    }
    mutationIsSignificant(t) {
      var e;
      const i = Object.keys(t).length > 0,
        n = "" === (null === (e = this.compositionInput) || void 0 === e ? void 0 : e.getEndData());
      return i || !n;
    }
    getCompositionInput() {
      if (this.isComposing()) return this.compositionInput;
      this.compositionInput = new vr(this);
    }
    isComposing() {
      return this.compositionInput && !this.compositionInput.isEnded();
    }
    deleteInDirection(t, e) {
      var i;
      return !1 !== (null === (i = this.responder) || void 0 === i ? void 0 : i.deleteInDirection(t)) ? this.setInputSummary({
        didDelete: !0
      }) : e ? (e.preventDefault(), this.requestRender()) : void 0;
    }
    serializeSelectionToDataTransfer(t) {
      var e;
      if (!function (t) {
        if (null == t || !t.setData) return !1;
        for (const e in Ct) {
          const i = Ct[e];
          try {
            if (t.setData(e, i), !t.getData(e) === i) return !1;
          } catch (t) {
            return !1;
          }
        }
        return !0;
      }(t)) return;
      const i = null === (e = this.responder) || void 0 === e ? void 0 : e.getSelectedDocument().toSerializableDocument();
      return t.setData("application/x-trix-document", JSON.stringify(i)), t.setData("text/html", Si.render(i).innerHTML), t.setData("text/plain", i.toString().replace(/\n$/, "")), !0;
    }
    canAcceptDataTransfer(t) {
      const e = {};
      return Array.from((null == t ? void 0 : t.types) || []).forEach(t => {
        e[t] = !0;
      }), e.Files || e["application/x-trix-document"] || e["text/html"] || e["text/plain"];
    }
    getPastedHTMLUsingHiddenElement(t) {
      const e = this.getSelectedRange(),
        i = {
          position: "absolute",
          left: "".concat(window.pageXOffset, "px"),
          top: "".concat(window.pageYOffset, "px"),
          opacity: 0
        },
        n = T({
          style: i,
          tagName: "div",
          editable: !0
        });
      return document.body.appendChild(n), n.focus(), requestAnimationFrame(() => {
        const i = n.innerHTML;
        return S(n), this.setSelectedRange(e), t(i);
      });
    }
  }
  Di(gr, "events", {
    keydown(t) {
      this.isComposing() || this.resetInputSummary(), (this || _global).inputSummary.didInput = !0;
      const e = hr[t.keyCode];
      if (e) {
        var i;
        let n = (this || _global).keys;
        ["ctrl", "alt", "shift", "meta"].forEach(e => {
          var i;
          t["".concat(e, "Key")] && ("ctrl" === e && (e = "control"), n = null === (i = n) || void 0 === i ? void 0 : i[e]);
        }), null != (null === (i = n) || void 0 === i ? void 0 : i[e]) && (this.setInputSummary({
          keyName: e
        }), Ft.reset(), n[e].call(this || _global, t));
      }
      if (St(t)) {
        const e = String.fromCharCode(t.keyCode).toLowerCase();
        if (e) {
          var n;
          const i = ["alt", "shift"].map(e => {
            if (t["".concat(e, "Key")]) return e;
          }).filter(t => t);
          i.push(e), null !== (n = (this || _global).delegate) && void 0 !== n && n.inputControllerDidReceiveKeyboardCommand(i) && t.preventDefault();
        }
      }
    },
    keypress(t) {
      if (null != (this || _global).inputSummary.eventName) return;
      if (t.metaKey) return;
      if (t.ctrlKey && !t.altKey) return;
      const e = fr(t);
      var i, n;
      return e ? (null === (i = (this || _global).delegate) || void 0 === i || i.inputControllerWillPerformTyping(), null === (n = (this || _global).responder) || void 0 === n || n.insertString(e), this.setInputSummary({
        textAdded: e,
        didDelete: this.selectionIsExpanded()
      })) : void 0;
    },
    textInput(t) {
      const {
          data: e
        } = t,
        {
          textAdded: i
        } = (this || _global).inputSummary;
      if (i && i !== e && i.toUpperCase() === e) {
        var n;
        const t = this.getSelectedRange();
        return this.setSelectedRange([t[0], t[1] + i.length]), null === (n = (this || _global).responder) || void 0 === n || n.insertString(e), this.setInputSummary({
          textAdded: e
        }), this.setSelectedRange(t);
      }
    },
    dragenter(t) {
      t.preventDefault();
    },
    dragstart(t) {
      var e, i;
      return this.serializeSelectionToDataTransfer(t.dataTransfer), (this || _global).draggedRange = this.getSelectedRange(), null === (e = (this || _global).delegate) || void 0 === e || null === (i = e.inputControllerDidStartDrag) || void 0 === i ? void 0 : i.call(e);
    },
    dragover(t) {
      if ((this || _global).draggedRange || this.canAcceptDataTransfer(t.dataTransfer)) {
        t.preventDefault();
        const n = {
          x: t.clientX,
          y: t.clientY
        };
        var e, i;
        if (!Tt(n, (this || _global).draggingPoint)) return (this || _global).draggingPoint = n, null === (e = (this || _global).delegate) || void 0 === e || null === (i = e.inputControllerDidReceiveDragOverPoint) || void 0 === i ? void 0 : i.call(e, (this || _global).draggingPoint);
      }
    },
    dragend(t) {
      var e, i;
      null === (e = (this || _global).delegate) || void 0 === e || null === (i = e.inputControllerDidCancelDrag) || void 0 === i || i.call(e), (this || _global).draggedRange = null, (this || _global).draggingPoint = null;
    },
    drop(t) {
      var e, i;
      t.preventDefault();
      const n = null === (e = t.dataTransfer) || void 0 === e ? void 0 : e.files,
        r = t.dataTransfer.getData("application/x-trix-document"),
        o = {
          x: t.clientX,
          y: t.clientY
        };
      if (null === (i = (this || _global).responder) || void 0 === i || i.setLocationRangeFromPointRange(o), null != n && n.length) this.attachFiles(n);else if ((this || _global).draggedRange) {
        var s, a;
        null === (s = (this || _global).delegate) || void 0 === s || s.inputControllerWillMoveText(), null === (a = (this || _global).responder) || void 0 === a || a.moveTextFromRange((this || _global).draggedRange), (this || _global).draggedRange = null, this.requestRender();
      } else if (r) {
        var l;
        const t = an.fromJSONString(r);
        null === (l = (this || _global).responder) || void 0 === l || l.insertDocument(t), this.requestRender();
      }
      (this || _global).draggedRange = null, (this || _global).draggingPoint = null;
    },
    cut(t) {
      var e, i;
      if (null !== (e = (this || _global).responder) && void 0 !== e && e.selectionIsExpanded() && (this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault(), null === (i = (this || _global).delegate) || void 0 === i || i.inputControllerWillCutText(), this.deleteInDirection("backward"), t.defaultPrevented)) return this.requestRender();
    },
    copy(t) {
      var e;
      null !== (e = (this || _global).responder) && void 0 !== e && e.selectionIsExpanded() && this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault();
    },
    paste(t) {
      const e = t.clipboardData || t.testClipboardData,
        i = {
          clipboard: e
        };
      if (!e || br(t)) return void this.getPastedHTMLUsingHiddenElement(t => {
        var e, n, r;
        return i.type = "text/html", i.html = t, null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPaste(i), null === (n = (this || _global).responder) || void 0 === n || n.insertHTML(i.html), this.requestRender(), null === (r = (this || _global).delegate) || void 0 === r ? void 0 : r.inputControllerDidPaste(i);
      });
      const n = e.getData("URL"),
        r = e.getData("text/html"),
        o = e.getData("public.url-name");
      if (n) {
        var s, a, l;
        let t;
        i.type = "text/html", t = o ? Vt(o).trim() : n, i.html = this.createLinkHTML(n, t), null === (s = (this || _global).delegate) || void 0 === s || s.inputControllerWillPaste(i), this.setInputSummary({
          textAdded: t,
          didDelete: this.selectionIsExpanded()
        }), null === (a = (this || _global).responder) || void 0 === a || a.insertHTML(i.html), this.requestRender(), null === (l = (this || _global).delegate) || void 0 === l || l.inputControllerDidPaste(i);
      } else if (Et(e)) {
        var c, u, h;
        i.type = "text/plain", i.string = e.getData("text/plain"), null === (c = (this || _global).delegate) || void 0 === c || c.inputControllerWillPaste(i), this.setInputSummary({
          textAdded: i.string,
          didDelete: this.selectionIsExpanded()
        }), null === (u = (this || _global).responder) || void 0 === u || u.insertString(i.string), this.requestRender(), null === (h = (this || _global).delegate) || void 0 === h || h.inputControllerDidPaste(i);
      } else if (r) {
        var d, g, m;
        i.type = "text/html", i.html = r, null === (d = (this || _global).delegate) || void 0 === d || d.inputControllerWillPaste(i), null === (g = (this || _global).responder) || void 0 === g || g.insertHTML(i.html), this.requestRender(), null === (m = (this || _global).delegate) || void 0 === m || m.inputControllerDidPaste(i);
      } else if (Array.from(e.types).includes("Files")) {
        var p, f;
        const t = null === (p = e.items) || void 0 === p || null === (p = p[0]) || void 0 === p || null === (f = p.getAsFile) || void 0 === f ? void 0 : f.call(p);
        if (t) {
          var b, v, A;
          const e = mr(t);
          !t.name && e && (t.name = "pasted-file-".concat(++dr, ".").concat(e)), i.type = "File", i.file = t, null === (b = (this || _global).delegate) || void 0 === b || b.inputControllerWillAttachFiles(), null === (v = (this || _global).responder) || void 0 === v || v.insertFile(i.file), this.requestRender(), null === (A = (this || _global).delegate) || void 0 === A || A.inputControllerDidPaste(i);
        }
      }
      t.preventDefault();
    },
    compositionstart(t) {
      return this.getCompositionInput().start(t.data);
    },
    compositionupdate(t) {
      return this.getCompositionInput().update(t.data);
    },
    compositionend(t) {
      return this.getCompositionInput().end(t.data);
    },
    beforeinput(t) {
      (this || _global).inputSummary.didInput = !0;
    },
    input(t) {
      return (this || _global).inputSummary.didInput = !0, t.stopPropagation();
    }
  }), Di(gr, "keys", {
    backspace(t) {
      var e;
      return null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
    },
    delete(t) {
      var e;
      return null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
    },
    return(t) {
      var e, i;
      return this.setInputSummary({
        preferDocument: !0
      }), null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = (this || _global).responder) || void 0 === i ? void 0 : i.insertLineBreak();
    },
    tab(t) {
      var e, i;
      null !== (e = (this || _global).responder) && void 0 !== e && e.canIncreaseNestingLevel() && (null === (i = (this || _global).responder) || void 0 === i || i.increaseNestingLevel(), this.requestRender(), t.preventDefault());
    },
    left(t) {
      var e;
      if (this.selectionIsInCursorTarget()) return t.preventDefault(), null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.moveCursorInDirection("backward");
    },
    right(t) {
      var e;
      if (this.selectionIsInCursorTarget()) return t.preventDefault(), null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.moveCursorInDirection("forward");
    },
    control: {
      d(t) {
        var e;
        return null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
      },
      h(t) {
        var e;
        return null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
      },
      o(t) {
        var e, i;
        return t.preventDefault(), null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = (this || _global).responder) || void 0 === i || i.insertString("\n", {
          updatePosition: !1
        }), this.requestRender();
      }
    },
    shift: {
      return(t) {
        var e, i;
        null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = (this || _global).responder) || void 0 === i || i.insertString("\n"), this.requestRender(), t.preventDefault();
      },
      tab(t) {
        var e, i;
        null !== (e = (this || _global).responder) && void 0 !== e && e.canDecreaseNestingLevel() && (null === (i = (this || _global).responder) || void 0 === i || i.decreaseNestingLevel(), this.requestRender(), t.preventDefault());
      },
      left(t) {
        if (this.selectionIsInCursorTarget()) return t.preventDefault(), this.expandSelectionInDirection("backward");
      },
      right(t) {
        if (this.selectionIsInCursorTarget()) return t.preventDefault(), this.expandSelectionInDirection("forward");
      }
    },
    alt: {
      backspace(t) {
        var e;
        return this.setInputSummary({
          preferDocument: !1
        }), null === (e = (this || _global).delegate) || void 0 === e ? void 0 : e.inputControllerWillPerformTyping();
      }
    },
    meta: {
      backspace(t) {
        var e;
        return this.setInputSummary({
          preferDocument: !1
        }), null === (e = (this || _global).delegate) || void 0 === e ? void 0 : e.inputControllerWillPerformTyping();
      }
    }
  }), gr.proxyMethod("responder?.getSelectedRange"), gr.proxyMethod("responder?.setSelectedRange"), gr.proxyMethod("responder?.expandSelectionInDirection"), gr.proxyMethod("responder?.selectionIsInCursorTarget"), gr.proxyMethod("responder?.selectionIsExpanded");
  const mr = t => {
      var e;
      return null === (e = t.type) || void 0 === e || null === (e = e.match(/\/(\w+)$/)) || void 0 === e ? void 0 : e[1];
    },
    pr = !(null === (cr = " ".codePointAt) || void 0 === cr || !cr.call(" ", 0)),
    fr = function (t) {
      if (t.key && pr && t.key.codePointAt(0) === t.keyCode) return t.key;
      {
        let e;
        if (null === t.which ? e = t.keyCode : 0 !== t.which && 0 !== t.charCode && (e = t.charCode), null != e && "escape" !== hr[e]) return $.fromCodepoints([e]).toString();
      }
    },
    br = function (t) {
      const e = t.clipboardData;
      if (e) {
        if (e.types.includes("text/html")) {
          for (const t of e.types) {
            const i = /^CorePasteboardFlavorType/.test(t),
              n = /^dyn\./.test(t) && e.getData(t);
            if (i || n) return !0;
          }
          return !1;
        }
        {
          const t = e.types.includes("com.apple.webarchive"),
            i = e.types.includes("com.apple.flat-rtfd");
          return t || i;
        }
      }
    };
  class vr extends q {
    constructor(t) {
      super(...arguments), this.inputController = t, this.responder = this.inputController.responder, this.delegate = this.inputController.delegate, this.inputSummary = this.inputController.inputSummary, this.data = {};
    }
    start(t) {
      if (this.data.start = t, this.isSignificant()) {
        var e, i;
        if ("keypress" === this.inputSummary.eventName && this.inputSummary.textAdded) null === (i = this.responder) || void 0 === i || i.deleteInDirection("left");
        this.selectionIsExpanded() || (this.insertPlaceholder(), this.requestRender()), this.range = null === (e = this.responder) || void 0 === e ? void 0 : e.getSelectedRange();
      }
    }
    update(t) {
      if (this.data.update = t, this.isSignificant()) {
        const t = this.selectPlaceholder();
        t && (this.forgetPlaceholder(), this.range = t);
      }
    }
    end(t) {
      return this.data.end = t, this.isSignificant() ? (this.forgetPlaceholder(), this.canApplyToDocument() ? (this.setInputSummary({
        preferDocument: !0,
        didInput: !1
      }), null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i || i.setSelectedRange(this.range), null === (n = this.responder) || void 0 === n || n.insertString(this.data.end), null === (r = this.responder) || void 0 === r ? void 0 : r.setSelectedRange(this.range[0] + this.data.end.length)) : null != this.data.start || null != this.data.update ? (this.requestReparse(), this.inputController.reset()) : void 0) : this.inputController.reset();
      var e, i, n, r;
    }
    getEndData() {
      return this.data.end;
    }
    isEnded() {
      return null != this.getEndData();
    }
    isSignificant() {
      return !ur.composesExistingText || this.inputSummary.didInput;
    }
    canApplyToDocument() {
      var t, e;
      return 0 === (null === (t = this.data.start) || void 0 === t ? void 0 : t.length) && (null === (e = this.data.end) || void 0 === e ? void 0 : e.length) > 0 && this.range;
    }
  }
  vr.proxyMethod("inputController.setInputSummary"), vr.proxyMethod("inputController.requestRender"), vr.proxyMethod("inputController.requestReparse"), vr.proxyMethod("responder?.selectionIsExpanded"), vr.proxyMethod("responder?.insertPlaceholder"), vr.proxyMethod("responder?.selectPlaceholder"), vr.proxyMethod("responder?.forgetPlaceholder");
  class Ar extends lr {
    constructor() {
      super(...arguments), this.render = this.render.bind(this);
    }
    elementDidMutate() {
      return this.scheduledRender ? this.composing ? null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidAllowUnhandledInput) || void 0 === e ? void 0 : e.call(t) : void 0 : this.reparse();
      var t, e;
    }
    scheduleRender() {
      return this.scheduledRender ? this.scheduledRender : this.scheduledRender = requestAnimationFrame(this.render);
    }
    render() {
      var t, e;
      (cancelAnimationFrame(this.scheduledRender), this.scheduledRender = null, this.composing) || null === (e = this.delegate) || void 0 === e || e.render();
      null === (t = this.afterRender) || void 0 === t || t.call(this), this.afterRender = null;
    }
    reparse() {
      var t;
      return null === (t = this.delegate) || void 0 === t ? void 0 : t.reparse();
    }
    insertString() {
      var t;
      let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        i = arguments.length > 1 ? arguments[1] : void 0;
      return null === (t = this.delegate) || void 0 === t || t.inputControllerWillPerformTyping(), this.withTargetDOMRange(function () {
        var t;
        return null === (t = this.responder) || void 0 === t ? void 0 : t.insertString(e, i);
      });
    }
    toggleAttributeIfSupported(t) {
      var e;
      if (gt().includes(t)) return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformFormatting(t), this.withTargetDOMRange(function () {
        var e;
        return null === (e = this.responder) || void 0 === e ? void 0 : e.toggleCurrentAttribute(t);
      });
    }
    activateAttributeIfSupported(t, e) {
      var i;
      if (gt().includes(t)) return null === (i = this.delegate) || void 0 === i || i.inputControllerWillPerformFormatting(t), this.withTargetDOMRange(function () {
        var i;
        return null === (i = this.responder) || void 0 === i ? void 0 : i.setCurrentAttribute(t, e);
      });
    }
    deleteInDirection(t) {
      let {
        recordUndoEntry: e
      } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        recordUndoEntry: !0
      };
      var i;
      e && (null === (i = this.delegate) || void 0 === i || i.inputControllerWillPerformTyping());
      const n = () => {
          var e;
          return null === (e = this.responder) || void 0 === e ? void 0 : e.deleteInDirection(t);
        },
        r = this.getTargetDOMRange({
          minLength: this.composing ? 1 : 2
        });
      return r ? this.withTargetDOMRange(r, n) : n();
    }
    withTargetDOMRange(t, e) {
      var i;
      return "function" == typeof t && (e = t, t = this.getTargetDOMRange()), t ? null === (i = this.responder) || void 0 === i ? void 0 : i.withTargetDOMRange(t, e.bind(this)) : (Ft.reset(), e.call(this));
    }
    getTargetDOMRange() {
      var t, e;
      let {
        minLength: i
      } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        minLength: 0
      };
      const n = null === (t = (e = this.event).getTargetRanges) || void 0 === t ? void 0 : t.call(e);
      if (n && n.length) {
        const t = yr(n[0]);
        if (0 === i || t.toString().length >= i) return t;
      }
    }
    withEvent(t, e) {
      let i;
      this.event = t;
      try {
        i = e.call(this);
      } finally {
        this.event = null;
      }
      return i;
    }
  }
  Di(Ar, "events", {
    keydown(t) {
      if (St(t)) {
        var e;
        const i = Rr(t);
        null !== (e = (this || _global).delegate) && void 0 !== e && e.inputControllerDidReceiveKeyboardCommand(i) && t.preventDefault();
      } else {
        let e = t.key;
        t.altKey && (e += "+Alt"), t.shiftKey && (e += "+Shift");
        const i = (this || _global).constructor.keys[e];
        if (i) return this.withEvent(t, i);
      }
    },
    paste(t) {
      var e;
      let i;
      const n = null === (e = t.clipboardData) || void 0 === e ? void 0 : e.getData("URL");
      return Er(t) ? (t.preventDefault(), this.attachFiles(t.clipboardData.files)) : Sr(t) ? (t.preventDefault(), i = {
        type: "text/plain",
        string: t.clipboardData.getData("text/plain")
      }, null === (r = (this || _global).delegate) || void 0 === r || r.inputControllerWillPaste(i), null === (o = (this || _global).responder) || void 0 === o || o.insertString(i.string), this.render(), null === (s = (this || _global).delegate) || void 0 === s ? void 0 : s.inputControllerDidPaste(i)) : n ? (t.preventDefault(), i = {
        type: "text/html",
        html: this.createLinkHTML(n)
      }, null === (a = (this || _global).delegate) || void 0 === a || a.inputControllerWillPaste(i), null === (l = (this || _global).responder) || void 0 === l || l.insertHTML(i.html), this.render(), null === (c = (this || _global).delegate) || void 0 === c ? void 0 : c.inputControllerDidPaste(i)) : void 0;
      var r, o, s, a, l, c;
    },
    beforeinput(t) {
      const e = (this || _global).constructor.inputTypes[t.inputType],
        i = (n = t, !(!/iPhone|iPad/.test(navigator.userAgent) || n.inputType && "insertParagraph" !== n.inputType));
      var n;
      e && (this.withEvent(t, e), i || this.scheduleRender()), i && this.render();
    },
    input(t) {
      Ft.reset();
    },
    dragstart(t) {
      var e, i;
      null !== (e = (this || _global).responder) && void 0 !== e && e.selectionContainsAttachments() && (t.dataTransfer.setData("application/x-trix-dragging", !0), (this || _global).dragging = {
        range: null === (i = (this || _global).responder) || void 0 === i ? void 0 : i.getSelectedRange(),
        point: kr(t)
      });
    },
    dragenter(t) {
      xr(t) && t.preventDefault();
    },
    dragover(t) {
      if ((this || _global).dragging) {
        t.preventDefault();
        const i = kr(t);
        var e;
        if (!Tt(i, (this || _global).dragging.point)) return (this || _global).dragging.point = i, null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.setLocationRangeFromPointRange(i);
      } else xr(t) && t.preventDefault();
    },
    drop(t) {
      var e, i;
      if ((this || _global).dragging) return t.preventDefault(), null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillMoveText(), null === (i = (this || _global).responder) || void 0 === i || i.moveTextFromRange((this || _global).dragging.range), (this || _global).dragging = null, this.scheduleRender();
      if (xr(t)) {
        var n;
        t.preventDefault();
        const e = kr(t);
        return null === (n = (this || _global).responder) || void 0 === n || n.setLocationRangeFromPointRange(e), this.attachFiles(t.dataTransfer.files);
      }
    },
    dragend() {
      var t;
      (this || _global).dragging && (null === (t = (this || _global).responder) || void 0 === t || t.setSelectedRange((this || _global).dragging.range), (this || _global).dragging = null);
    },
    compositionend(t) {
      (this || _global).composing && ((this || _global).composing = !1, a.recentAndroid || this.scheduleRender());
    }
  }), Di(Ar, "keys", {
    ArrowLeft() {
      var t, e;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.shouldManageMovingCursorInDirection("backward")) return (this || _global).event.preventDefault(), null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.moveCursorInDirection("backward");
    },
    ArrowRight() {
      var t, e;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.shouldManageMovingCursorInDirection("forward")) return (this || _global).event.preventDefault(), null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.moveCursorInDirection("forward");
    },
    Backspace() {
      var t, e, i;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.shouldManageDeletingInDirection("backward")) return (this || _global).event.preventDefault(), null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = (this || _global).responder) || void 0 === i || i.deleteInDirection("backward"), this.render();
    },
    Tab() {
      var t, e;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.canIncreaseNestingLevel()) return (this || _global).event.preventDefault(), null === (e = (this || _global).responder) || void 0 === e || e.increaseNestingLevel(), this.render();
    },
    "Tab+Shift"() {
      var t, e;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.canDecreaseNestingLevel()) return (this || _global).event.preventDefault(), null === (e = (this || _global).responder) || void 0 === e || e.decreaseNestingLevel(), this.render();
    }
  }), Di(Ar, "inputTypes", {
    deleteByComposition() {
      return this.deleteInDirection("backward", {
        recordUndoEntry: !1
      });
    },
    deleteByCut() {
      return this.deleteInDirection("backward");
    },
    deleteByDrag() {
      return (this || _global).event.preventDefault(), this.withTargetDOMRange(function () {
        var t;
        (this || _global).deleteByDragRange = null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.getSelectedRange();
      });
    },
    deleteCompositionText() {
      return this.deleteInDirection("backward", {
        recordUndoEntry: !1
      });
    },
    deleteContent() {
      return this.deleteInDirection("backward");
    },
    deleteContentBackward() {
      return this.deleteInDirection("backward");
    },
    deleteContentForward() {
      return this.deleteInDirection("forward");
    },
    deleteEntireSoftLine() {
      return this.deleteInDirection("forward");
    },
    deleteHardLineBackward() {
      return this.deleteInDirection("backward");
    },
    deleteHardLineForward() {
      return this.deleteInDirection("forward");
    },
    deleteSoftLineBackward() {
      return this.deleteInDirection("backward");
    },
    deleteSoftLineForward() {
      return this.deleteInDirection("forward");
    },
    deleteWordBackward() {
      return this.deleteInDirection("backward");
    },
    deleteWordForward() {
      return this.deleteInDirection("forward");
    },
    formatBackColor() {
      return this.activateAttributeIfSupported("backgroundColor", (this || _global).event.data);
    },
    formatBold() {
      return this.toggleAttributeIfSupported("bold");
    },
    formatFontColor() {
      return this.activateAttributeIfSupported("color", (this || _global).event.data);
    },
    formatFontName() {
      return this.activateAttributeIfSupported("font", (this || _global).event.data);
    },
    formatIndent() {
      var t;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.canIncreaseNestingLevel()) return this.withTargetDOMRange(function () {
        var t;
        return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.increaseNestingLevel();
      });
    },
    formatItalic() {
      return this.toggleAttributeIfSupported("italic");
    },
    formatJustifyCenter() {
      return this.toggleAttributeIfSupported("justifyCenter");
    },
    formatJustifyFull() {
      return this.toggleAttributeIfSupported("justifyFull");
    },
    formatJustifyLeft() {
      return this.toggleAttributeIfSupported("justifyLeft");
    },
    formatJustifyRight() {
      return this.toggleAttributeIfSupported("justifyRight");
    },
    formatOutdent() {
      var t;
      if (null !== (t = (this || _global).responder) && void 0 !== t && t.canDecreaseNestingLevel()) return this.withTargetDOMRange(function () {
        var t;
        return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.decreaseNestingLevel();
      });
    },
    formatRemove() {
      this.withTargetDOMRange(function () {
        for (const i in null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.getCurrentAttributes()) {
          var t, e;
          null === (e = (this || _global).responder) || void 0 === e || e.removeCurrentAttribute(i);
        }
      });
    },
    formatSetBlockTextDirection() {
      return this.activateAttributeIfSupported("blockDir", (this || _global).event.data);
    },
    formatSetInlineTextDirection() {
      return this.activateAttributeIfSupported("textDir", (this || _global).event.data);
    },
    formatStrikeThrough() {
      return this.toggleAttributeIfSupported("strike");
    },
    formatSubscript() {
      return this.toggleAttributeIfSupported("sub");
    },
    formatSuperscript() {
      return this.toggleAttributeIfSupported("sup");
    },
    formatUnderline() {
      return this.toggleAttributeIfSupported("underline");
    },
    historyRedo() {
      var t;
      return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerWillPerformRedo();
    },
    historyUndo() {
      var t;
      return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerWillPerformUndo();
    },
    insertCompositionText() {
      return (this || _global).composing = !0, this.insertString((this || _global).event.data);
    },
    insertFromComposition() {
      return (this || _global).composing = !1, this.insertString((this || _global).event.data);
    },
    insertFromDrop() {
      const t = (this || _global).deleteByDragRange;
      var e;
      if (t) return (this || _global).deleteByDragRange = null, null === (e = (this || _global).delegate) || void 0 === e || e.inputControllerWillMoveText(), this.withTargetDOMRange(function () {
        var e;
        return null === (e = (this || _global).responder) || void 0 === e ? void 0 : e.moveTextFromRange(t);
      });
    },
    insertFromPaste() {
      const {
          dataTransfer: t
        } = (this || _global).event,
        e = {
          dataTransfer: t
        },
        i = t.getData("URL"),
        n = t.getData("text/html");
      if (i) {
        var r;
        let n;
        (this || _global).event.preventDefault(), e.type = "text/html";
        const o = t.getData("public.url-name");
        n = o ? Vt(o).trim() : i, e.html = this.createLinkHTML(i, n), null === (r = (this || _global).delegate) || void 0 === r || r.inputControllerWillPaste(e), this.withTargetDOMRange(function () {
          var t;
          return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.insertHTML(e.html);
        }), (this || _global).afterRender = () => {
          var t;
          return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
        };
      } else if (Et(t)) {
        var o;
        e.type = "text/plain", e.string = t.getData("text/plain"), null === (o = (this || _global).delegate) || void 0 === o || o.inputControllerWillPaste(e), this.withTargetDOMRange(function () {
          var t;
          return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.insertString(e.string);
        }), (this || _global).afterRender = () => {
          var t;
          return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
        };
      } else if (Cr((this || _global).event)) {
        var s;
        e.type = "File", e.file = t.files[0], null === (s = (this || _global).delegate) || void 0 === s || s.inputControllerWillPaste(e), this.withTargetDOMRange(function () {
          var t;
          return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.insertFile(e.file);
        }), (this || _global).afterRender = () => {
          var t;
          return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
        };
      } else if (n) {
        var a;
        (this || _global).event.preventDefault(), e.type = "text/html", e.html = n, null === (a = (this || _global).delegate) || void 0 === a || a.inputControllerWillPaste(e), this.withTargetDOMRange(function () {
          var t;
          return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.insertHTML(e.html);
        }), (this || _global).afterRender = () => {
          var t;
          return null === (t = (this || _global).delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
        };
      }
    },
    insertFromYank() {
      return this.insertString((this || _global).event.data);
    },
    insertLineBreak() {
      return this.insertString("\n");
    },
    insertLink() {
      return this.activateAttributeIfSupported("href", (this || _global).event.data);
    },
    insertOrderedList() {
      return this.toggleAttributeIfSupported("number");
    },
    insertParagraph() {
      var t;
      return null === (t = (this || _global).delegate) || void 0 === t || t.inputControllerWillPerformTyping(), this.withTargetDOMRange(function () {
        var t;
        return null === (t = (this || _global).responder) || void 0 === t ? void 0 : t.insertLineBreak();
      });
    },
    insertReplacementText() {
      const t = (this || _global).event.dataTransfer.getData("text/plain"),
        e = (this || _global).event.getTargetRanges()[0];
      this.withTargetDOMRange(e, () => {
        this.insertString(t, {
          updatePosition: !1
        });
      });
    },
    insertText() {
      var t;
      return this.insertString((this || _global).event.data || (null === (t = (this || _global).event.dataTransfer) || void 0 === t ? void 0 : t.getData("text/plain")));
    },
    insertTranspose() {
      return this.insertString((this || _global).event.data);
    },
    insertUnorderedList() {
      return this.toggleAttributeIfSupported("bullet");
    }
  });
  const yr = function (t) {
      const e = document.createRange();
      return e.setStart(t.startContainer, t.startOffset), e.setEnd(t.endContainer, t.endOffset), e;
    },
    xr = t => {
      var e;
      return Array.from((null === (e = t.dataTransfer) || void 0 === e ? void 0 : e.types) || []).includes("Files");
    },
    Cr = t => {
      var e;
      return (null === (e = t.dataTransfer.files) || void 0 === e ? void 0 : e[0]) && !Er(t) && !(t => {
        let {
          dataTransfer: e
        } = t;
        return e.types.includes("Files") && e.types.includes("text/html") && e.getData("text/html").includes("urn:schemas-microsoft-com:office:office");
      })(t);
    },
    Er = function (t) {
      const e = t.clipboardData;
      if (e) {
        return Array.from(e.types).filter(t => t.match(/file/i)).length === e.types.length && e.files.length >= 1;
      }
    },
    Sr = function (t) {
      const e = t.clipboardData;
      if (e) return e.types.includes("text/plain") && 1 === e.types.length;
    },
    Rr = function (t) {
      const e = [];
      return t.altKey && e.push("alt"), t.shiftKey && e.push("shift"), e.push(t.key), e;
    },
    kr = t => ({
      x: t.clientX,
      y: t.clientY
    }),
    Tr = "[data-trix-attribute]",
    wr = "[data-trix-action]",
    Lr = "".concat(Tr, ", ").concat(wr),
    Dr = "[data-trix-dialog]",
    Nr = "".concat(Dr, "[data-trix-active]"),
    Ir = "".concat(Dr, " [data-trix-method]"),
    Or = "".concat(Dr, " [data-trix-input]"),
    Fr = (t, e) => (e || (e = Mr(t)), t.querySelector("[data-trix-input][name='".concat(e, "']"))),
    Pr = t => t.getAttribute("data-trix-action"),
    Mr = t => t.getAttribute("data-trix-attribute") || t.getAttribute("data-trix-dialog-attribute");
  class Br extends q {
    constructor(t) {
      super(t), this.didClickActionButton = this.didClickActionButton.bind(this), this.didClickAttributeButton = this.didClickAttributeButton.bind(this), this.didClickDialogButton = this.didClickDialogButton.bind(this), this.didKeyDownDialogInput = this.didKeyDownDialogInput.bind(this), this.element = t, this.attributes = {}, this.actions = {}, this.resetDialogInputs(), b("mousedown", {
        onElement: this.element,
        matchingSelector: wr,
        withCallback: this.didClickActionButton
      }), b("mousedown", {
        onElement: this.element,
        matchingSelector: Tr,
        withCallback: this.didClickAttributeButton
      }), b("click", {
        onElement: this.element,
        matchingSelector: Lr,
        preventDefault: !0
      }), b("click", {
        onElement: this.element,
        matchingSelector: Ir,
        withCallback: this.didClickDialogButton
      }), b("keydown", {
        onElement: this.element,
        matchingSelector: Or,
        withCallback: this.didKeyDownDialogInput
      });
    }
    didClickActionButton(t, e) {
      var i;
      null === (i = this.delegate) || void 0 === i || i.toolbarDidClickButton(), t.preventDefault();
      const n = Pr(e);
      return this.getDialog(n) ? this.toggleDialog(n) : null === (r = this.delegate) || void 0 === r ? void 0 : r.toolbarDidInvokeAction(n, e);
      var r;
    }
    didClickAttributeButton(t, e) {
      var i;
      null === (i = this.delegate) || void 0 === i || i.toolbarDidClickButton(), t.preventDefault();
      const n = Mr(e);
      var r;
      this.getDialog(n) ? this.toggleDialog(n) : null === (r = this.delegate) || void 0 === r || r.toolbarDidToggleAttribute(n);
      return this.refreshAttributeButtons();
    }
    didClickDialogButton(t, e) {
      const i = y(e, {
        matchingSelector: Dr
      });
      return this[e.getAttribute("data-trix-method")].call(this, i);
    }
    didKeyDownDialogInput(t, e) {
      if (13 === t.keyCode) {
        t.preventDefault();
        const i = e.getAttribute("name"),
          n = this.getDialog(i);
        this.setAttribute(n);
      }
      if (27 === t.keyCode) return t.preventDefault(), this.hideDialog();
    }
    updateActions(t) {
      return this.actions = t, this.refreshActionButtons();
    }
    refreshActionButtons() {
      return this.eachActionButton((t, e) => {
        t.disabled = !1 === this.actions[e];
      });
    }
    eachActionButton(t) {
      return Array.from(this.element.querySelectorAll(wr)).map(e => t(e, Pr(e)));
    }
    updateAttributes(t) {
      return this.attributes = t, this.refreshAttributeButtons();
    }
    refreshAttributeButtons() {
      return this.eachAttributeButton((t, e) => (t.disabled = !1 === this.attributes[e], this.attributes[e] || this.dialogIsVisible(e) ? (t.setAttribute("data-trix-active", ""), t.classList.add("trix-active")) : (t.removeAttribute("data-trix-active"), t.classList.remove("trix-active"))));
    }
    eachAttributeButton(t) {
      return Array.from(this.element.querySelectorAll(Tr)).map(e => t(e, Mr(e)));
    }
    applyKeyboardCommand(t) {
      const e = JSON.stringify(t.sort());
      for (const t of Array.from(this.element.querySelectorAll("[data-trix-key]"))) {
        const i = t.getAttribute("data-trix-key").split("+");
        if (JSON.stringify(i.sort()) === e) return v("mousedown", {
          onElement: t
        }), !0;
      }
      return !1;
    }
    dialogIsVisible(t) {
      const e = this.getDialog(t);
      if (e) return e.hasAttribute("data-trix-active");
    }
    toggleDialog(t) {
      return this.dialogIsVisible(t) ? this.hideDialog() : this.showDialog(t);
    }
    showDialog(t) {
      var e, i;
      this.hideDialog(), null === (e = this.delegate) || void 0 === e || e.toolbarWillShowDialog();
      const n = this.getDialog(t);
      n.setAttribute("data-trix-active", ""), n.classList.add("trix-active"), Array.from(n.querySelectorAll("input[disabled]")).forEach(t => {
        t.removeAttribute("disabled");
      });
      const r = Mr(n);
      if (r) {
        const e = Fr(n, t);
        e && (e.value = this.attributes[r] || "", e.select());
      }
      return null === (i = this.delegate) || void 0 === i ? void 0 : i.toolbarDidShowDialog(t);
    }
    setAttribute(t) {
      var e;
      const i = Mr(t),
        n = Fr(t, i);
      return !n.willValidate || (n.setCustomValidity(""), n.checkValidity() && this.isSafeAttribute(n)) ? (null === (e = this.delegate) || void 0 === e || e.toolbarDidUpdateAttribute(i, n.value), this.hideDialog()) : (n.setCustomValidity("Invalid value"), n.setAttribute("data-trix-validate", ""), n.classList.add("trix-validate"), n.focus());
    }
    isSafeAttribute(t) {
      return !t.hasAttribute("data-trix-validate-href") || li.isValidAttribute("a", "href", t.value);
    }
    removeAttribute(t) {
      var e;
      const i = Mr(t);
      return null === (e = this.delegate) || void 0 === e || e.toolbarDidRemoveAttribute(i), this.hideDialog();
    }
    hideDialog() {
      const t = this.element.querySelector(Nr);
      var e;
      if (t) return t.removeAttribute("data-trix-active"), t.classList.remove("trix-active"), this.resetDialogInputs(), null === (e = this.delegate) || void 0 === e ? void 0 : e.toolbarDidHideDialog((t => t.getAttribute("data-trix-dialog"))(t));
    }
    resetDialogInputs() {
      Array.from(this.element.querySelectorAll(Or)).forEach(t => {
        t.setAttribute("disabled", "disabled"), t.removeAttribute("data-trix-validate"), t.classList.remove("trix-validate");
      });
    }
    getDialog(t) {
      return this.element.querySelector("[data-trix-dialog=".concat(t, "]"));
    }
  }
  class _r extends $n {
    constructor(t) {
      let {
        editorElement: e,
        document: i,
        html: n
      } = t;
      super(...arguments), this.editorElement = e, this.selectionManager = new Vn(this.editorElement), this.selectionManager.delegate = this, this.composition = new wn(), this.composition.delegate = this, this.attachmentManager = new kn(this.composition.getAttachments()), this.attachmentManager.delegate = this, this.inputController = 2 === _.getLevel() ? new Ar(this.editorElement) : new gr(this.editorElement), this.inputController.delegate = this, this.inputController.responder = this.composition, this.compositionController = new Xn(this.editorElement, this.composition), this.compositionController.delegate = this, this.toolbarController = new Br(this.editorElement.toolbarElement), this.toolbarController.delegate = this, this.editor = new Pn(this.composition, this.selectionManager, this.editorElement), i ? this.editor.loadDocument(i) : this.editor.loadHTML(n);
    }
    registerSelectionManager() {
      return Ft.registerSelectionManager(this.selectionManager);
    }
    unregisterSelectionManager() {
      return Ft.unregisterSelectionManager(this.selectionManager);
    }
    render() {
      return this.compositionController.render();
    }
    reparse() {
      return this.composition.replaceHTML(this.editorElement.innerHTML);
    }
    compositionDidChangeDocument(t) {
      if (this.notifyEditorElement("document-change"), !this.handlingInput) return this.render();
    }
    compositionDidChangeCurrentAttributes(t) {
      return this.currentAttributes = t, this.toolbarController.updateAttributes(this.currentAttributes), this.updateCurrentActions(), this.notifyEditorElement("attributes-change", {
        attributes: this.currentAttributes
      });
    }
    compositionDidPerformInsertionAtRange(t) {
      this.pasting && (this.pastedRange = t);
    }
    compositionShouldAcceptFile(t) {
      return this.notifyEditorElement("file-accept", {
        file: t
      });
    }
    compositionDidAddAttachment(t) {
      const e = this.attachmentManager.manageAttachment(t);
      return this.notifyEditorElement("attachment-add", {
        attachment: e
      });
    }
    compositionDidEditAttachment(t) {
      this.compositionController.rerenderViewForObject(t);
      const e = this.attachmentManager.manageAttachment(t);
      return this.notifyEditorElement("attachment-edit", {
        attachment: e
      }), this.notifyEditorElement("change");
    }
    compositionDidChangeAttachmentPreviewURL(t) {
      return this.compositionController.invalidateViewForObject(t), this.notifyEditorElement("change");
    }
    compositionDidRemoveAttachment(t) {
      const e = this.attachmentManager.unmanageAttachment(t);
      return this.notifyEditorElement("attachment-remove", {
        attachment: e
      });
    }
    compositionDidStartEditingAttachment(t, e) {
      return this.attachmentLocationRange = this.composition.document.getLocationRangeOfAttachment(t), this.compositionController.installAttachmentEditorForAttachment(t, e), this.selectionManager.setLocationRange(this.attachmentLocationRange);
    }
    compositionDidStopEditingAttachment(t) {
      this.compositionController.uninstallAttachmentEditor(), this.attachmentLocationRange = null;
    }
    compositionDidRequestChangingSelectionToLocationRange(t) {
      if (!this.loadingSnapshot || this.isFocused()) return this.requestedLocationRange = t, this.compositionRevisionWhenLocationRangeRequested = this.composition.revision, this.handlingInput ? void 0 : this.render();
    }
    compositionWillLoadSnapshot() {
      this.loadingSnapshot = !0;
    }
    compositionDidLoadSnapshot() {
      this.compositionController.refreshViewCache(), this.render(), this.loadingSnapshot = !1;
    }
    getSelectionManager() {
      return this.selectionManager;
    }
    attachmentManagerDidRequestRemovalOfAttachment(t) {
      return this.removeAttachment(t);
    }
    compositionControllerWillSyncDocumentView() {
      return this.inputController.editorWillSyncDocumentView(), this.selectionManager.lock(), this.selectionManager.clearSelection();
    }
    compositionControllerDidSyncDocumentView() {
      return this.inputController.editorDidSyncDocumentView(), this.selectionManager.unlock(), this.updateCurrentActions(), this.notifyEditorElement("sync");
    }
    compositionControllerDidRender() {
      this.requestedLocationRange && (this.compositionRevisionWhenLocationRangeRequested === this.composition.revision && this.selectionManager.setLocationRange(this.requestedLocationRange), this.requestedLocationRange = null, this.compositionRevisionWhenLocationRangeRequested = null), this.renderedCompositionRevision !== this.composition.revision && (this.runEditorFilters(), this.composition.updateCurrentAttributes(), this.notifyEditorElement("render")), this.renderedCompositionRevision = this.composition.revision;
    }
    compositionControllerDidFocus() {
      return this.isFocusedInvisibly() && this.setLocationRange({
        index: 0,
        offset: 0
      }), this.toolbarController.hideDialog(), this.notifyEditorElement("focus");
    }
    compositionControllerDidBlur() {
      return this.notifyEditorElement("blur");
    }
    compositionControllerDidSelectAttachment(t, e) {
      return this.toolbarController.hideDialog(), this.composition.editAttachment(t, e);
    }
    compositionControllerDidRequestDeselectingAttachment(t) {
      const e = this.attachmentLocationRange || this.composition.document.getLocationRangeOfAttachment(t);
      return this.selectionManager.setLocationRange(e[1]);
    }
    compositionControllerWillUpdateAttachment(t) {
      return this.editor.recordUndoEntry("Edit Attachment", {
        context: t.id,
        consolidatable: !0
      });
    }
    compositionControllerDidRequestRemovalOfAttachment(t) {
      return this.removeAttachment(t);
    }
    inputControllerWillHandleInput() {
      this.handlingInput = !0, this.requestedRender = !1;
    }
    inputControllerDidRequestRender() {
      this.requestedRender = !0;
    }
    inputControllerDidHandleInput() {
      if (this.handlingInput = !1, this.requestedRender) return this.requestedRender = !1, this.render();
    }
    inputControllerDidAllowUnhandledInput() {
      return this.notifyEditorElement("change");
    }
    inputControllerDidRequestReparse() {
      return this.reparse();
    }
    inputControllerWillPerformTyping() {
      return this.recordTypingUndoEntry();
    }
    inputControllerWillPerformFormatting(t) {
      return this.recordFormattingUndoEntry(t);
    }
    inputControllerWillCutText() {
      return this.editor.recordUndoEntry("Cut");
    }
    inputControllerWillPaste(t) {
      return this.editor.recordUndoEntry("Paste"), this.pasting = !0, this.notifyEditorElement("before-paste", {
        paste: t
      });
    }
    inputControllerDidPaste(t) {
      return t.range = this.pastedRange, this.pastedRange = null, this.pasting = null, this.notifyEditorElement("paste", {
        paste: t
      });
    }
    inputControllerWillMoveText() {
      return this.editor.recordUndoEntry("Move");
    }
    inputControllerWillAttachFiles() {
      return this.editor.recordUndoEntry("Drop Files");
    }
    inputControllerWillPerformUndo() {
      return this.editor.undo();
    }
    inputControllerWillPerformRedo() {
      return this.editor.redo();
    }
    inputControllerDidReceiveKeyboardCommand(t) {
      return this.toolbarController.applyKeyboardCommand(t);
    }
    inputControllerDidStartDrag() {
      this.locationRangeBeforeDrag = this.selectionManager.getLocationRange();
    }
    inputControllerDidReceiveDragOverPoint(t) {
      return this.selectionManager.setLocationRangeFromPointRange(t);
    }
    inputControllerDidCancelDrag() {
      this.selectionManager.setLocationRange(this.locationRangeBeforeDrag), this.locationRangeBeforeDrag = null;
    }
    locationRangeDidChange(t) {
      return this.composition.updateCurrentAttributes(), this.updateCurrentActions(), this.attachmentLocationRange && !Dt(this.attachmentLocationRange, t) && this.composition.stopEditingAttachment(), this.notifyEditorElement("selection-change");
    }
    toolbarDidClickButton() {
      if (!this.getLocationRange()) return this.setLocationRange({
        index: 0,
        offset: 0
      });
    }
    toolbarDidInvokeAction(t, e) {
      return this.invokeAction(t, e);
    }
    toolbarDidToggleAttribute(t) {
      if (this.recordFormattingUndoEntry(t), this.composition.toggleCurrentAttribute(t), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarDidUpdateAttribute(t, e) {
      if (this.recordFormattingUndoEntry(t), this.composition.setCurrentAttribute(t, e), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarDidRemoveAttribute(t) {
      if (this.recordFormattingUndoEntry(t), this.composition.removeCurrentAttribute(t), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarWillShowDialog(t) {
      return this.composition.expandSelectionForEditing(), this.freezeSelection();
    }
    toolbarDidShowDialog(t) {
      return this.notifyEditorElement("toolbar-dialog-show", {
        dialogName: t
      });
    }
    toolbarDidHideDialog(t) {
      return this.thawSelection(), this.editorElement.focus(), this.notifyEditorElement("toolbar-dialog-hide", {
        dialogName: t
      });
    }
    freezeSelection() {
      if (!this.selectionFrozen) return this.selectionManager.lock(), this.composition.freezeSelection(), this.selectionFrozen = !0, this.render();
    }
    thawSelection() {
      if (this.selectionFrozen) return this.composition.thawSelection(), this.selectionManager.unlock(), this.selectionFrozen = !1, this.render();
    }
    canInvokeAction(t) {
      return !!this.actionIsExternal(t) || !(null === (e = this.actions[t]) || void 0 === e || null === (e = e.test) || void 0 === e || !e.call(this));
      var e;
    }
    invokeAction(t, e) {
      return this.actionIsExternal(t) ? this.notifyEditorElement("action-invoke", {
        actionName: t,
        invokingElement: e
      }) : null === (i = this.actions[t]) || void 0 === i || null === (i = i.perform) || void 0 === i ? void 0 : i.call(this);
      var i;
    }
    actionIsExternal(t) {
      return /^x-./.test(t);
    }
    getCurrentActions() {
      const t = {};
      for (const e in this.actions) t[e] = this.canInvokeAction(e);
      return t;
    }
    updateCurrentActions() {
      const t = this.getCurrentActions();
      if (!Tt(t, this.currentActions)) return this.currentActions = t, this.toolbarController.updateActions(this.currentActions), this.notifyEditorElement("actions-change", {
        actions: this.currentActions
      });
    }
    runEditorFilters() {
      let t = this.composition.getSnapshot();
      if (Array.from(this.editor.filters).forEach(e => {
        const {
          document: i,
          selectedRange: n
        } = t;
        t = e.call(this.editor, t) || {}, t.document || (t.document = i), t.selectedRange || (t.selectedRange = n);
      }), e = t, i = this.composition.getSnapshot(), !Dt(e.selectedRange, i.selectedRange) || !e.document.isEqualTo(i.document)) return this.composition.loadSnapshot(t);
      var e, i;
    }
    updateInputElement() {
      const t = function (t, e) {
        const i = En[e];
        if (i) return i(t);
        throw new Error("unknown content type: ".concat(e));
      }(this.compositionController.getSerializableElement(), "text/html");
      return this.editorElement.setFormValue(t);
    }
    notifyEditorElement(t, e) {
      switch (t) {
        case "document-change":
          this.documentChangedSinceLastRender = !0;
          break;
        case "render":
          this.documentChangedSinceLastRender && (this.documentChangedSinceLastRender = !1, this.notifyEditorElement("change"));
          break;
        case "change":
        case "attachment-add":
        case "attachment-edit":
        case "attachment-remove":
          this.updateInputElement();
      }
      return this.editorElement.notify(t, e);
    }
    removeAttachment(t) {
      return this.editor.recordUndoEntry("Delete Attachment"), this.composition.removeAttachment(t), this.render();
    }
    recordFormattingUndoEntry(t) {
      const e = mt(t),
        i = this.selectionManager.getLocationRange();
      if (e || !Lt(i)) return this.editor.recordUndoEntry("Formatting", {
        context: this.getUndoContext(),
        consolidatable: !0
      });
    }
    recordTypingUndoEntry() {
      return this.editor.recordUndoEntry("Typing", {
        context: this.getUndoContext(this.currentAttributes),
        consolidatable: !0
      });
    }
    getUndoContext() {
      for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
      return [this.getLocationContext(), this.getTimeContext(), ...Array.from(e)];
    }
    getLocationContext() {
      const t = this.selectionManager.getLocationRange();
      return Lt(t) ? t[0].index : t;
    }
    getTimeContext() {
      return V.interval > 0 ? Math.floor(new Date().getTime() / V.interval) : 0;
    }
    isFocused() {
      var t;
      return this.editorElement === (null === (t = this.editorElement.ownerDocument) || void 0 === t ? void 0 : t.activeElement);
    }
    isFocusedInvisibly() {
      return this.isFocused() && !this.getLocationRange();
    }
    get actions() {
      return this.constructor.actions;
    }
  }
  Di(_r, "actions", {
    undo: {
      test() {
        return (this || _global).editor.canUndo();
      },
      perform() {
        return (this || _global).editor.undo();
      }
    },
    redo: {
      test() {
        return (this || _global).editor.canRedo();
      },
      perform() {
        return (this || _global).editor.redo();
      }
    },
    link: {
      test() {
        return (this || _global).editor.canActivateAttribute("href");
      }
    },
    increaseNestingLevel: {
      test() {
        return (this || _global).editor.canIncreaseNestingLevel();
      },
      perform() {
        return (this || _global).editor.increaseNestingLevel() && this.render();
      }
    },
    decreaseNestingLevel: {
      test() {
        return (this || _global).editor.canDecreaseNestingLevel();
      },
      perform() {
        return (this || _global).editor.decreaseNestingLevel() && this.render();
      }
    },
    attachFiles: {
      test: () => !0,
      perform() {
        return _.pickFiles((this || _global).editor.insertFiles);
      }
    }
  }), _r.proxyMethod("getSelectionManager().setLocationRange"), _r.proxyMethod("getSelectionManager().getLocationRange");
  var jr = Object.freeze({
      __proto__: null,
      AttachmentEditorController: Yn,
      CompositionController: Xn,
      Controller: $n,
      EditorController: _r,
      InputController: lr,
      Level0InputController: gr,
      Level2InputController: Ar,
      ToolbarController: Br
    }),
    Wr = Object.freeze({
      __proto__: null,
      MutationObserver: er,
      SelectionChangeObserver: Ot
    }),
    Ur = Object.freeze({
      __proto__: null,
      FileVerificationOperation: nr,
      ImagePreloadOperation: Ui
    });
  vt("trix-toolbar", "%t {\n  display: block;\n}\n\n%t {\n  white-space: nowrap;\n}\n\n%t [data-trix-dialog] {\n  display: none;\n}\n\n%t [data-trix-dialog][data-trix-active] {\n  display: block;\n}\n\n%t [data-trix-dialog] [data-trix-validate]:invalid {\n  background-color: #ffdddd;\n}");
  class Vr extends HTMLElement {
    connectedCallback() {
      "" === this.innerHTML && (this.innerHTML = U.getDefaultHTML());
    }
  }
  let zr = 0;
  const qr = function (t) {
      if (!t.hasAttribute("contenteditable")) return t.setAttribute("contenteditable", ""), function (t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return e.times = 1, b(t, e);
      }("focus", {
        onElement: t,
        withCallback: () => Hr(t)
      });
    },
    Hr = function (t) {
      return Jr(t), Kr(t);
    },
    Jr = function (t) {
      var e, i;
      if (null !== (e = (i = document).queryCommandSupported) && void 0 !== e && e.call(i, "enableObjectResizing")) return document.execCommand("enableObjectResizing", !1, !1), b("mscontrolselect", {
        onElement: t,
        preventDefault: !0
      });
    },
    Kr = function (t) {
      var e, i;
      if (null !== (e = (i = document).queryCommandSupported) && void 0 !== e && e.call(i, "DefaultParagraphSeparator")) {
        const {
          tagName: t
        } = n.default;
        if (["div", "p"].includes(t)) return document.execCommand("DefaultParagraphSeparator", !1, t);
      }
    },
    Gr = a.forcesObjectResizing ? {
      display: "inline",
      width: "auto"
    } : {
      display: "inline-block",
      width: "1px"
    };
  vt("trix-editor", "%t {\n    display: block;\n}\n\n%t:empty::before {\n    content: attr(placeholder);\n    color: graytext;\n    cursor: text;\n    pointer-events: none;\n    white-space: pre-line;\n}\n\n%t a[contenteditable=false] {\n    cursor: text;\n}\n\n%t img {\n    max-width: 100%;\n    height: auto;\n}\n\n%t ".concat(e, " figcaption textarea {\n    resize: none;\n}\n\n%t ").concat(e, " figcaption textarea.trix-autoresize-clone {\n    position: absolute;\n    left: -9999px;\n    max-height: 0px;\n}\n\n%t ").concat(e, " figcaption[data-trix-placeholder]:empty::before {\n    content: attr(data-trix-placeholder);\n    color: graytext;\n}\n\n%t [data-trix-cursor-target] {\n    display: ").concat(Gr.display, " !important;\n    width: ").concat(Gr.width, " !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    border: none !important;\n}\n\n%t [data-trix-cursor-target=left] {\n    vertical-align: top !important;\n    margin-left: -1px !important;\n}\n\n%t [data-trix-cursor-target=right] {\n    vertical-align: bottom !important;\n    margin-right: -1px !important;\n}"));
  var Yr = new WeakMap(),
    Xr = new WeakSet();
  class $r {
    constructor(t) {
      var e, i;
      _i(e = this, i = Xr), i.add(e), ji(this, Yr, {
        writable: !0,
        value: void 0
      }), this.element = t, Oi(this, Yr, t.attachInternals());
    }
    connectedCallback() {
      Bi(this, Xr, Zr).call(this);
    }
    disconnectedCallback() {}
    get labels() {
      return Ii(this, Yr).labels;
    }
    get disabled() {
      var t;
      return null === (t = this.element.inputElement) || void 0 === t ? void 0 : t.disabled;
    }
    set disabled(t) {
      this.element.toggleAttribute("disabled", t);
    }
    get required() {
      return this.element.hasAttribute("required");
    }
    set required(t) {
      this.element.toggleAttribute("required", t), Bi(this, Xr, Zr).call(this);
    }
    get validity() {
      return Ii(this, Yr).validity;
    }
    get validationMessage() {
      return Ii(this, Yr).validationMessage;
    }
    get willValidate() {
      return Ii(this, Yr).willValidate;
    }
    setFormValue(t) {
      Bi(this, Xr, Zr).call(this);
    }
    checkValidity() {
      return Ii(this, Yr).checkValidity();
    }
    reportValidity() {
      return Ii(this, Yr).reportValidity();
    }
    setCustomValidity(t) {
      Bi(this, Xr, Zr).call(this, t);
    }
  }
  function Zr() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    const {
        required: e,
        value: i
      } = (this || _global).element,
      n = e && !i,
      r = !!t,
      o = T("input", {
        required: e
      }),
      s = t || o.validationMessage;
    Ii(this || _global, Yr).setValidity({
      valueMissing: n,
      customError: r
    }, s);
  }
  var Qr = new WeakMap(),
    to = new WeakMap(),
    eo = new WeakMap();
  class io {
    constructor(t) {
      ji(this, Qr, {
        writable: !0,
        value: void 0
      }), ji(this, to, {
        writable: !0,
        value: t => {
          t.defaultPrevented || t.target === this.element.form && this.element.reset();
        }
      }), ji(this, eo, {
        writable: !0,
        value: t => {
          if (t.defaultPrevented) return;
          if (this.element.contains(t.target)) return;
          const e = y(t.target, {
            matchingSelector: "label"
          });
          e && Array.from(this.labels).includes(e) && this.element.focus();
        }
      }), this.element = t;
    }
    connectedCallback() {
      Oi(this, Qr, function (t) {
        if (t.hasAttribute("aria-label") || t.hasAttribute("aria-labelledby")) return;
        const e = function () {
          const e = Array.from(t.labels).map(e => {
              if (!e.contains(t)) return e.textContent;
            }).filter(t => t),
            i = e.join(" ");
          return i ? t.setAttribute("aria-label", i) : t.removeAttribute("aria-label");
        };
        return e(), b("focus", {
          onElement: t,
          withCallback: e
        });
      }(this.element)), window.addEventListener("reset", Ii(this, to), !1), window.addEventListener("click", Ii(this, eo), !1);
    }
    disconnectedCallback() {
      var t;
      null === (t = Ii(this, Qr)) || void 0 === t || t.destroy(), window.removeEventListener("reset", Ii(this, to), !1), window.removeEventListener("click", Ii(this, eo), !1);
    }
    get labels() {
      const t = [];
      this.element.id && this.element.ownerDocument && t.push(...Array.from(this.element.ownerDocument.querySelectorAll("label[for='".concat(this.element.id, "']")) || []));
      const e = y(this.element, {
        matchingSelector: "label"
      });
      return e && [this.element, null].includes(e.control) && t.push(e), t;
    }
    get disabled() {
      return console.warn("This browser does not support the [disabled] attribute for trix-editor elements."), !1;
    }
    set disabled(t) {
      console.warn("This browser does not support the [disabled] attribute for trix-editor elements.");
    }
    get required() {
      return console.warn("This browser does not support the [required] attribute for trix-editor elements."), !1;
    }
    set required(t) {
      console.warn("This browser does not support the [required] attribute for trix-editor elements.");
    }
    get validity() {
      return console.warn("This browser does not support the validity property for trix-editor elements."), null;
    }
    get validationMessage() {
      return console.warn("This browser does not support the validationMessage property for trix-editor elements."), "";
    }
    get willValidate() {
      return console.warn("This browser does not support the willValidate property for trix-editor elements."), !1;
    }
    setFormValue(t) {}
    checkValidity() {
      return console.warn("This browser does not support checkValidity() for trix-editor elements."), !0;
    }
    reportValidity() {
      return console.warn("This browser does not support reportValidity() for trix-editor elements."), !0;
    }
    setCustomValidity(t) {
      console.warn("This browser does not support setCustomValidity(validationMessage) for trix-editor elements.");
    }
  }
  var no = new WeakMap();
  class ro extends HTMLElement {
    constructor() {
      super(), ji(this, no, {
        writable: !0,
        value: void 0
      }), Oi(this, no, this.constructor.formAssociated ? new $r(this) : new io(this));
    }
    get trixId() {
      return this.hasAttribute("trix-id") ? this.getAttribute("trix-id") : (this.setAttribute("trix-id", ++zr), this.trixId);
    }
    get labels() {
      return Ii(this, no).labels;
    }
    get disabled() {
      return Ii(this, no).disabled;
    }
    set disabled(t) {
      Ii(this, no).disabled = t;
    }
    get required() {
      return Ii(this, no).required;
    }
    set required(t) {
      Ii(this, no).required = t;
    }
    get validity() {
      return Ii(this, no).validity;
    }
    get validationMessage() {
      return Ii(this, no).validationMessage;
    }
    get willValidate() {
      return Ii(this, no).willValidate;
    }
    get type() {
      return this.localName;
    }
    get toolbarElement() {
      var t;
      if (this.hasAttribute("toolbar")) return null === (t = this.ownerDocument) || void 0 === t ? void 0 : t.getElementById(this.getAttribute("toolbar"));
      if (this.parentNode) {
        const t = "trix-toolbar-".concat(this.trixId);
        return this.setAttribute("toolbar", t), this.internalToolbar = T("trix-toolbar", {
          id: t
        }), this.parentNode.insertBefore(this.internalToolbar, this), this.internalToolbar;
      }
    }
    get form() {
      var t;
      return null === (t = this.inputElement) || void 0 === t ? void 0 : t.form;
    }
    get inputElement() {
      var t;
      if (this.hasAttribute("input")) return null === (t = this.ownerDocument) || void 0 === t ? void 0 : t.getElementById(this.getAttribute("input"));
      if (this.parentNode) {
        const t = "trix-input-".concat(this.trixId);
        this.setAttribute("input", t);
        const e = T("input", {
          type: "hidden",
          id: t
        });
        return this.parentNode.insertBefore(e, this.nextElementSibling), e;
      }
    }
    get editor() {
      var t;
      return null === (t = this.editorController) || void 0 === t ? void 0 : t.editor;
    }
    get name() {
      var t;
      return null === (t = this.inputElement) || void 0 === t ? void 0 : t.name;
    }
    get value() {
      var t;
      return null === (t = this.inputElement) || void 0 === t ? void 0 : t.value;
    }
    set value(t) {
      var e;
      this.defaultValue = t, null === (e = this.editor) || void 0 === e || e.loadHTML(this.defaultValue);
    }
    attributeChangedCallback(t, e, i) {
      "connected" === t && this.isConnected && null != e && e !== i && requestAnimationFrame(() => this.reconnect());
    }
    notify(t, e) {
      if (this.editorController) return v("trix-".concat(t), {
        onElement: this,
        attributes: e
      });
    }
    setFormValue(t) {
      this.inputElement && (this.inputElement.value = t, Ii(this, no).setFormValue(t));
    }
    connectedCallback() {
      this.hasAttribute("data-trix-internal") || (qr(this), function (t) {
        if (!t.hasAttribute("role")) t.setAttribute("role", "textbox");
      }(this), this.editorController || (v("trix-before-initialize", {
        onElement: this
      }), this.editorController = new _r({
        editorElement: this,
        html: this.defaultValue = this.value
      }), requestAnimationFrame(() => v("trix-initialize", {
        onElement: this
      }))), this.editorController.registerSelectionManager(), Ii(this, no).connectedCallback(), this.toggleAttribute("connected", !0), function (t) {
        if (!document.querySelector(":focus") && t.hasAttribute("autofocus") && document.querySelector("[autofocus]") === t) t.focus();
      }(this));
    }
    disconnectedCallback() {
      var t;
      null === (t = this.editorController) || void 0 === t || t.unregisterSelectionManager(), Ii(this, no).disconnectedCallback(), this.toggleAttribute("connected", !1);
    }
    reconnect() {
      this.removeInternalToolbar(), this.disconnectedCallback(), this.connectedCallback();
    }
    removeInternalToolbar() {
      var t;
      null === (t = this.internalToolbar) || void 0 === t || t.remove(), this.internalToolbar = null;
    }
    checkValidity() {
      return Ii(this, no).checkValidity();
    }
    reportValidity() {
      return Ii(this, no).reportValidity();
    }
    setCustomValidity(t) {
      Ii(this, no).setCustomValidity(t);
    }
    formDisabledCallback(t) {
      this.inputElement && (this.inputElement.disabled = t), this.toggleAttribute("contenteditable", !t);
    }
    formResetCallback() {
      this.reset();
    }
    reset() {
      this.value = this.defaultValue;
    }
  }
  Di(ro, "formAssociated", "ElementInternals" in window), Di(ro, "observedAttributes", ["connected"]);
  const oo = {
    VERSION: t,
    config: z,
    core: Sn,
    models: zn,
    views: qn,
    controllers: jr,
    observers: Wr,
    operations: Ur,
    elements: Object.freeze({
      __proto__: null,
      TrixEditorElement: ro,
      TrixToolbarElement: Vr
    }),
    filters: Object.freeze({
      __proto__: null,
      Filter: In,
      attachmentGalleryFilter: On
    })
  };
  return Object.assign(oo, zn), window.Trix = oo, setTimeout(function () {
    customElements.get("trix-toolbar") || customElements.define("trix-toolbar", Vr), customElements.get("trix-editor") || customElements.define("trix-editor", ro);
  }, 0), oo;
});
//# sourceMappingURL=trix.umd.min.js.map
export default exports;